/* eslint-disable */
var en = function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return (n10 == 1 && n100 != 11) ? 'one'
      : (n10 == 2 && n100 != 12) ? 'two'
      : (n10 == 3 && n100 != 13) ? 'few'
      : 'other';
  return (n == 1 && v0) ? 'one' : 'other';
};
var fi = function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
};
var number = function (value, name, offset) {
  if (!offset) return value;
  if (isNaN(value)) throw new Error("Can't apply offset:" + offset + ' to argument `' + name + '` with non-numerical value ' + JSON.stringify(value) + '.');
  return value - offset;
};
var plural = function (value, offset, lcfunc, data, isOrdinal) {
  if ({}.hasOwnProperty.call(data, value)) return data[value];
  if (offset) value -= offset;
  var key = lcfunc(value, isOrdinal);
  return key in data ? data[key] : data.other;
};

export default {
  en: {
    common: {
      back: function(d) { return "Back"; },
      print: function(d) { return "Print"; },
      readMore: function(d) { return "Read more"; },
      signOut: function(d) { return "Sign out"; },
      yes: function(d) { return "Yes"; },
      no: function(d) { return "No"; }
    },
    navigation: {
      m2koditLink: function(d) { return "Go to M2-Kodit home page"; },
      omaM2Link: function(d) { return "Go to OmaM2 home page"; },
      home: {
        title: function(d) { return "Home"; }
      },
      apartment: {
        title: function(d) { return "My apartment"; },
        agreement: function(d) { return "My lease agreement"; },
        billing: function(d) { return "My rent and payment information"; },
        change: function(d) { return "Apartment exchange"; },
        watermeter: function(d) { return "Information on water billing"; },
        termination: function(d) { return "Terminate rental agreement"; },
        bookingsCalendar: function(d) { return "My reservations"; },
        messages: function(d) { return "Fault reports"; },
        forms: function(d) { return "Forms"; }
      },
      housing: {
        title: function(d) { return "My building"; },
        myhousing: function(d) { return "Information"; },
        news: function(d) { return "News"; },
        safety: function(d) { return "Safety"; },
        laundry: function(d) { return "Laundry room"; },
        ownhouse: function(d) { return "Own house"; },
        storage: function(d) { return "Storage"; },
        internet: function(d) { return "Internet connection"; },
        rentSummary: function(d) { return "Information on rent formation"; },
        bookingsCalendar: function(d) { return "My reservations"; },
        manuals: function(d) { return "User manuals and documents"; }
      },
      living: {
        title: function(d) { return "Living in M2-Homes"; },
        benefits: function(d) { return "Tenant benefits"; },
        events: function(d) { return "Tenant events"; },
        activities: function(d) { return "Community activities"; }
      },
      m2homes: {
        title: function(d) { return "M2-Homes"; },
        about: function(d) { return "About M2-Homes"; },
        sustainability: function(d) { return "Sustainability"; }
      },
      messages: {
        title: function(d) { return "Fault reports"; }
      },
      profileAlt: {
        title: function(d) { return "My information"; }
      },
      signout: {
        title: function(d) { return "Sign out"; }
      },
      profileMain: {
        title: function(d) { return "My information"; }
      },
      profileMenu: {
        forms: function(d) { return "My forms"; }
      },
      finnish: function(d) { return "Suomeksi"; },
      english: function(d) { return "In English"; }
    },
    faultformbulletin: {
      title: function(d) { return "There may still be some work to be done at home. If so, we apologise!"; },
      description: function(d) { return "A paper version of a Guarantee Check form has been delivered to your home. Instead of a paper form, you can use the electric form to report any faults and defects you may find in your home. The information will be redirected to the builder, who will ensure that any issues that need finishing are dealt with."; },
      description2: function(d) { return "Return the form even if there are no defects. The form must be completed within two weeks of the start of the lease."; },
      open: function(d) { return "Open the Guarantee Check form"; },
      close: function(d) { return "Close the Guarantee Check form"; }
    },
    moveinnotice: {
      description: function(d) { return "Your new home will be completed by " + d.startDate + ". The contents of these Home folders will be updated as we receive the necessary materials from the contractors. Our goal is to have all the content available to you latest on the move-in date."; }
    },
    wordpress: {
      errorpage: {
        title: function(d) { return "Page was not found!"; },
        post: function(d) { return "Please refresh the page or try again later!"; }
      }
    },
    search: {
      queryplaceholder: function(d) { return "Search from site"; },
      buttontext: function(d) { return "Search"; },
      title: function(d) { return "Search results"; },
      resultsummary: function(d) { return "Your search " + d.query + " " + plural(d.resultCount, 0, en, { "0": "returned no results.", "1": "returned one result.", other: "returned " + number(d.resultCount, "resultCount") + " results." }); },
      apartment: {
        title: function(d) { return "My lease agreement"; },
        description: function(d) { return "Details of your lease agreement."; }
      },
      billing: {
        title: function(d) { return "My rent and payment information"; },
        description: function(d) { return "View your rent and payment information."; }
      },
      change: {
        title: function(d) { return "Apartment change"; },
        description: function(d) { return "You can apply for a new apartment from the M2-Kodit apartments becoming vacant if there is a justified need for a new apartment. Such needs may include, for example, changes in the size or the financial situation of the family or a health-related reason."; }
      },
      contact: {
        title: function(d) { return "Contact"; },
        description: function(d) { return "Send a message to our customer support through the form below. We will respond by email as soon as possible."; }
      },
      contactinformation: {
        title: function(d) { return "Contact information"; },
        description: function(d) { return "Information about your property's contact information."; }
      },
      fault: {
        title: function(d) { return "Fault report"; },
        description: function(d) { return "Report non-critical faults or problems with your apartment or your building's common spaces."; }
      },
      internet: {
        title: function(d) { return "Internet connection"; },
        description: function(d) { return "Information about your building's internet connection."; }
      },
      laundry: {
        title: function(d) { return "Laundry room"; },
        description: function(d) { return "Information about your building's common laundry room, its usage and booking."; }
      },
      manuals: {
        title: function(d) { return "User manuals and documents"; },
        description: function(d) { return "Information about your building's appliances and maintenance."; }
      },
      news: {
        title: function(d) { return "News"; },
        description: function(d) { return "News realted to your building"; }
      },
      parking: {
        title: function(d) { return "Resident parking"; },
        description: function(d) { return "Information about your building's resident parking spaces."; }
      },
      safety: {
        title: function(d) { return "Safety and evacuation"; },
        description: function(d) { return "Information about your buildings safety and evacuation plan."; }
      },
      sauna: {
        title: function(d) { return "Sauna"; },
        description: function(d) { return "Information about your building's common sauna and how to book it."; }
      },
      storage: {
        title: function(d) { return "Storage"; },
        description: function(d) { return "Information about your building's storage facilities."; }
      }
    },
    home: {
      title: function(d) { return "Welcome to OmaM2!"; },
      description: function(d) { return "You can manage your residence-related matters conveniently in the OmaM2 service."; },
      address: {
        title: function(d) { return "Address"; }
      },
      contact: {
        title: function(d) { return "Contact us"; },
        intro: function(d) { return "Use the form below to send a message to our customer service. We will reply by e-mail as soon as possible."; },
        email: function(d) { return "E-mail address"; },
        phone: function(d) { return "Telephone number"; },
        subject: function(d) { return "Subject"; },
        header: function(d) { return "Header"; },
        desc: function(d) { return "Message"; },
        send: function(d) { return "Send"; }
      },
      residentpricelist: function(d) { return "Resident price list"; },
      hello: function(d) { return "Hi"; },
      grid: {
        bookings: {
          title: function(d) { return "Upcoming reservations"; },
          secondary_action: {
            label: function(d) { return "To reservations"; }
          }
        },
        contact: {
          title: function(d) { return "Contact us"; },
          action: {
            label: function(d) { return "New message"; }
          },
          customer_service: function(d) { return "Customer service"; },
          customer_service_active: function(d) { return "Weekdays " + d.hour_range; },
          maintenance: function(d) { return "Maintenance company"; },
          manager: function(d) { return "Property manager"; }
        },
        events: {
          title: function(d) { return "Resident events"; },
          action: {
            label: function(d) { return "View all"; }
          }
        },
        events_for_all: {
          title: function(d) { return "Events in the building"; },
          action: {
            label: function(d) { return "View all"; }
          }
        },
        rent: {
          title: function(d) { return "Current payment period"; },
          action: {
            label: function(d) { return "Pay"; }
          },
          action2: {
            label: function(d) { return "Rent and payment information"; }
          },
          monthly_rent: function(d) { return "Rent"; },
          debt_positive: function(d) { return "Debt"; },
          debt_negative: function(d) { return "Paid in advance"; },
          total_to_pay: function(d) { return "Total remaining to be paid"; },
          total_paid: function(d) { return "Total paid in adv."; },
          due_date_label: function(d) { return "Due date"; },
          paid_in_advance: function(d) { return "Excess amount paid in advance"; },
          loadfailure: function(d) { return "Rent information could not be retrieved. Please try again later."; },
          payment_delay_description: function(d) { return "It takes 3-5 banking days for payments to appear in the OmaM2 service."; }
        },
        debt: {
          title: function(d) { return "Debt"; },
          action: {
            label: function(d) { return "Debt report"; }
          },
          unpaid: {
            label: function(d) { return "Total overdue amount"; }
          },
          payment_delay_description: function(d) { return "If you've already paid, it will show up in the OmaM2 service in 3-5 banking days."; },
          loadfailure: function(d) { return "Debt information could not be retrieved. Please try again later."; }
        },
        news: {
          title: function(d) { return "News"; },
          action: {
            label: function(d) { return "View all"; }
          },
          readmore: function(d) { return "Read more"; }
        },
        faults: {
          title: function(d) { return "Fault reports"; },
          action: {
            label: function(d) { return "View all"; }
          },
          secondary_action: {
            label: function(d) { return "Report fault"; }
          }
        }
      }
    },
    links: {
      fault: function(d) { return "Report a fault"; },
      agreement: function(d) { return "View your agreement"; },
      messages: function(d) { return "Contact us"; },
      payments: function(d) { return "Rent payment"; },
      terminate: function(d) { return "Terminate your agreement"; },
      exchange: function(d) { return "Change apartment"; }
    },
    linkshome: {
      parking: {
        title: function(d) { return "Info about parking"; },
        description: function(d) { return "Information about your building's resident parking spaces."; }
      },
      sauna: {
        title: function(d) { return "Info about sauna"; },
        description: function(d) { return "Information about your building's common sauna and how to book it."; }
      },
      laundry: {
        title: function(d) { return "Info about Laundry"; },
        description: function(d) { return "Information about your building's common laundry room, its usage and booking."; }
      },
      fault: {
        title: function(d) { return "Fault report"; },
        description: function(d) { return "Report non-critical faults or problems with your apartment or your building's common spaces."; }
      },
      disorder: {
        title: function(d) { return "Disturbances and disorderly conduct"; },
        description: function(d) { return "Report disturbances, such as excessive noise or smoking indoors"; }
      },
      forms: {
        title: function(d) { return "Forms"; },
        description: function(d) { return "Administrative forms"; }
      },
      change: {
        title: function(d) { return "Apartment change"; },
        description: function(d) { return "You can apply for a new apartment from the M2-Kodit apartments becoming vacant if there is a justified need for a new apartment. Such needs may include, for example, changes in the size or the financial situation of the family or a health-related reason."; },
        linktext: function(d) { return "Change apartments"; }
      },
      urgent: {
        title: function(d) { return "Report a fault"; },
        description: function(d) { return "Immediately call maintenance if you notice a critical fault, that should be fixed immediately, in your apartment or your buildings common spaces. A critical fault is for example a water leak that could cause severe damage."; },
        linktext: function(d) { return "Report an issue"; },
        contactbutton: function(d) { return "View contact information"; }
      },
      billing: {
        linktext: function(d) { return "Pay your rent"; }
      },
      contact: {
        title: function(d) { return "Contact"; },
        description: function(d) { return "Send a message to our customer support through the form below. We will respond by email as soon as possible."; },
        linktext: function(d) { return "Contact us"; }
      }
    },
    warning: {
      debt: function(d) { return "There are overdue payments"; },
      conditional: function(d) { return "If you have made the payment, this notice is not valid."; },
      proceedings: function(d) { return "Your debt is under legal collection. Please contact the rent supervision services on +358 (0)9 7742 5513 Mon–Fri 9 a.m.–3 p.m."; },
      distraint: function(d) { return "The entirety or a part of your debt is being collected by enforcement authorities. Debts collected by enforcement authorities cannot be paid to the account of M2-Kodit. Please contact the rent supervision services for instructions on how to pay your debt. Rent supervision services’ phone number: +358 (0)9 7742 5513 Mon–Fri 9 a.m.–3 p.m."; },
      close: function(d) { return "Close"; },
      uuras: {
        text: function(d) { return "Additional income through the Uuras employment programme."; },
        linktext: function(d) { return "Read more."; }
      },
      gotopayment: function(d) { return "Make a payment"; }
    },
    apartment: {
      title: function(d) { return "My apartment information"; }
    },
    change: {
      title: function(d) { return "Planning to move?"; },
      description: function(d) { return "If your life circumstances change, you can request changing your apartment to another M2-Kodit apartment in two ways."; },
      alternative1: function(d) { return "1. Switch homes with another M2-Kodit customer"; },
      alt1description: function(d) { return "Existing M2-Kodit customers can agree to change apartments with each other. This option works well when you are e.g., looking for a smaller apartment and an other M2-Kodit customer is looking for a bigger apartment at the same time. Read more..."; },
      alternative2: function(d) { return "2. Requesting a new apartment by sending a whole new application to us"; },
      alt2description: function(d) { return "Visit our website https://m2kodit.fi/en/ and browse all the available/soon coming available apartments and send a whole new application to M2-Kodit. Read more..."; },
      apartmentchangelink: function(d) { return "https://hakemus.tampuuri.fi/m2kodit/"; },
      descriptiontitle2: function(d) { return "Apartment exchange"; },
      changeinstructionslink: function(d) { return "http://m2kodit.fi/asukkaalle/asunnon-vaihto/"; },
      descriptioncontact: function(d) { return "Browse the apartment exchange notices or submit your own notice. The apartment exchange arrangement involves the residents of two apartments swapping their apartments. If you find an apartment that suits you, request an apartment exchange by sending M2-Kodit a message on"; },
      descriptionmakechangelinktext: function(d) { return "kodit@ysaatio.fi"; },
      descriptionmakechangelinkhref: function(d) { return "kodit@ysaatio.fi"; },
      descriptionmakechangeend: function(d) { return "."; },
      descriptioninstructionslinktext: function(d) { return "Learn more about the apartment exchange arrangements."; },
      descriptiontitle3: function(d) { return "Requesting a new apartment through M2-Kodit"; },
      searchvacantapartments: function(d) { return "Browse the M2-Kodit apartments becoming vacant"; },
      searchvacantlink: function(d) { return "https://asunnot.m2kodit.fi"; },
      and: function(d) { return "and"; },
      fillapartmentform: function(d) { return "submit an apartment application."; },
      fillapartmentformlink: function(d) { return "https://hakemus.tampuuri.fi/m2kodit/?_ga=2.31850682.540683483.1587125277-1894718168.1581421105"; },
      description3content: function(d) { return "You can apply for a new apartment from the M2-Kodit apartments becoming vacant if there is a justified need for a new apartment. Such needs may include, for example, changes in the size or the financial situation of the family or a health-related reason."; },
      enlistedapartments: function(d) { return "Apartments available for exchange"; },
      instructions: {
        title: function(d) { return "Instructions for moving from one apartment to another"; }
      },
      instructions1: {
        text: function(d) { return "It is possible to exchange the apartments of two tenants. When you have found a suitable apartment, please contact the tenant who submitted the notice directly."; },
        text2: function(d) { return "Arrange the time and date of visiting the apartments. If the arrangement suits both parties, contact M2-Kodit on"; },
        textlink: function(d) { return "kodit@ysaatio.fi"; },
        textend: function(d) { return "."; },
        text3: function(d) { return "M2-Kodit will handle the apartment exchange arrangements according to the instructions of the Housing Finance and Development Centre of Finland. The payment and tenancy information of your current lease agreement and your credit history will be checked during this process. Any payment default entries will have an effect on the amount of the security deposit of the new rental apartment. The exchange can be made if the prerequisites for the exchange are fulfilled. \nDo not terminate the lease agreement of your current apartment before the apartment exchange arrangement has been confirmed. M2-Kodit will not carry out separate moving inspections when apartments are exchanged."; }
      },
      instructions2: {
        title: function(d) { return "Submit an apartment exchange notice"; },
        text: function(d) { return "Make your apartment available for apartment exchange with an OmaM2 form. Your notice will be processed and published in the service if the apartment is eligible for exchange. Please note that when you make your apartment available for exchange, the details of your apartment, your contact details and the notice will be made public to all users of the OmaM2 service. \nYour notice will be displayed for six months or until you delete it. If you change apartments or stop using the service, the notice will be deleted automatically."; }
      },
      adsent: function(d) { return "Your notice has been submitted and is awaiting confirmation!"; },
      gotonewad: function(d) { return "Make an apartment exchange notice"; },
      allcities: function(d) { return "All cities"; },
      emptyadlist: function(d) { return "No apartment exchange notices"; },
      close: function(d) { return "Close"; },
      ad: {
        current: {
          title: function(d) { return "Tenant's description of their home"; }
        },
        desired: {
          title: function(d) { return "I am looking for this kind of home"; }
        },
        buildingtitle: function(d) { return "Details of the apartment"; },
        name: function(d) { return "Tenant’s name"; },
        phone: function(d) { return "Telephone number"; },
        email: function(d) { return "E-mail address"; },
        address: function(d) { return "Home address"; },
        description: function(d) { return "Describe the apartment you are looking for and when you would like to move. The text will be published with your notice."; },
        newtitle: function(d) { return "Make an apartment exchange notice"; },
        newdescstart: function(d) { return "When you make your apartment available for exchange, the details of your apartment, your contact details and the notice will be published in this service."; },
        newdesclinktext: function(d) { return "Learn more about the apartment exchange arrangements"; },
        newdescend: function(d) { return "."; },
        publish: function(d) { return "Send"; },
        status: {
          published: function(d) { return "Published: " + d.published; },
          "new": function(d) { return "Awaiting confirmation"; },
          deleted: function(d) { return "Deleted"; }
        },
        icontext: function(d) { return "Apartment exchange notice"; },
        removebtn: function(d) { return "Delete"; },
        housinginfobtn: function(d) { return "View building presentation"; },
        rooms: function(d) { return "Apartment type"; },
        squares: function(d) { return "Floor area"; },
        lease: function(d) { return "Rent"; },
        water: function(d) { return "Monthly advance water tariff"; },
        buildingtype: function(d) { return "Building type"; },
        year: function(d) { return "Year of construction"; },
        apartments: function(d) { return "Number of apartments"; },
        floors: function(d) { return "Number of floors"; },
        elevator: function(d) { return "Lift"; },
        yes: function(d) { return "Yes"; },
        no: function(d) { return "No"; }
      },
      disabled: function(d) { return "You have a valid apartment exchange notice. If you want to make a new notice, please first delete the old one."; },
      swap: {
        label: function(d) { return "Switch"; },
        title: function(d) { return "Alternative 1 – M2-Kodit customers switch homes with each other"; },
        description: function(d) { return "Every M2-Kodit customer can place an announcement of willingness to switch homes with another M2-Kodit customer. When you choose this option, do as follows:"; },
        step1: function(d) { return "Take a look at the homes shown below and see if there is a home that interests you. (If there is no announcements shown below, no customer wants to switch homes at the moment. You can check the situation again whenever you want.)"; },
        step2: function(d) { return "When you find a suitable home, contact the customer who has submitted the notice directly and agree about seeing the apartment. Getting to see the apartment is always agreed between customers."; },
        step3: function(d) { return "When you find a partner for switching homes, send a message about it to: kodit@ysaatio.fi"; },
        step4: function(d) { return "We will process the switching application according to the instructions of the Housing Finance and Development Centre of Finland. We will also check applicants' payment and tenancy information and credit history. Any payment default entries will affect on the amount of the security deposit of the new rental apartment."; },
        step5: function(d) { return "The switch can be done when the prerequisites are fulfilled."; },
        notice: function(d) { return "Note! Do not terminate the lease agreement of your current home before the switch arrangements are confirmed. M2-Kodit will not carry out moving inspections in situations where customers switch homes with each other."; },
        instructionlink: function(d) { return "Would you like to submit an announcement to switch apartments with another M2-Kodit customer?"; },
        link: function(d) { return "Click here for instructions."; },
        newtitle: function(d) { return "Submit an announcement to switch apartments with another M2-Kodit customer"; },
        newswapinfo1: function(d) { return "The information of your present home will be added to the announcement automatically. Informations are: apartment type, floor area, rent, water usage fee (also if there is a seperate water usage measuring in the apartment), building type, year of construction, number of apartments and number of floors."; },
        newswapinfo2: function(d) { return "Note that everything you write to your announcement will be published. Don't write anything you don't want other customer to see. Never write your social security number to the announcement. Details of your apartment and your contact information will be made public for all OmaM2 users."; },
        newswapinfo3: function(d) { return "Only announcements in which the switch between customers is possible will be published. Your announcement is valid for three (3) months. You can remove your announcement whenever you want. If you move away from your apartment, the announcement will be deleted automatically."; },
        currentapttitle: function(d) { return "Additional information of your current home"; },
        currentaptplaceholder: function(d) { return "Here you can arvertise your current apartment. Tell others why they would consider to move to your current home. Is there a balcony perhaps? A dog park nearby or something else? The text you write here will be published in your announcement."; },
        desiredapttitle: function(d) { return "What kind of an apartment you search in exchange?"; },
        desiredaptplaceholder: function(d) { return "Tell here what kind of a home you are searching, where and when would you like to move. The text you write here will be published in your announcement."; },
        termscheckbox: function(d) { return "I have understood that details of my current apartment and my contact information will be published in my announcement. Also the additional text I wrote above will be published for other OmaM2 users to see."; },
        send: function(d) { return "Send"; },
        backtotop: function(d) { return "Return to top"; }
      },
      newapplication: {
        label: function(d) { return "New application"; },
        title: function(d) { return "Alternative 2 - A whole new application"; },
        description: function(d) { return "When you want to leave a whole new application to M2-Kodit, do as follows:"; },
        step1: function(d) { return "Go to the address"; },
        step2: function(d) { return "Bowse the apartments. When you find an apartment or apartments that would suite your present life situation better that you current home, add the apartments to the application and follow the instructions on the website."; },
        step3: function(d) { return "We will process your application according to the instructions of the Housing Finance and Development Centre of Finland."; },
        step4: function(d) { return "We will also check applicant's payment and tenancy history. Possible payment default entries will affect on the amount ot the security deposit of the new rental apartment."; },
        notice: function(d) { return "Note that you can apply for a new apartment if there is a justified need for it. Such needs may include, for example, changes in the size or the financial situation of the family or in health-related reasons."; }
      }
    },
    watermeter: {
      title: function(d) { return "Information on water billing"; },
      noexist: {
        description: function(d) { return "Your apartment does not have it's own water meter."; }
      }
    },
    housing: {
      title: function(d) { return "My building"; },
      update: {
        title: function(d) { return "We are updating your building's information"; },
        description: function(d) { return "On this page, you will soon be able to view basic information about your building as well as additional details about the common areas and their use."; }
      },
      description: function(d) { return "Through the OmaM2 service you can conveniently manage your apartment."; },
      basicinfo: {
        buildingtype: function(d) { return "Building type"; },
        year: function(d) { return "Year of construction"; },
        apartmentcounts: function(d) { return "Apartments"; },
        floors: function(d) { return "Number of floors"; },
        elevator: function(d) { return "Lift"; }
      },
      basicInfo: {
        amount: function(d) { return "units"; },
        energyClass: function(d) { return "Energy class"; }
      },
      housefeat: {
        title: function(d) { return "Your building is equipped with"; },
        laundryroom: function(d) { return "Laundry"; },
        dryingroom: function(d) { return "Drying room"; },
        bikestorage: function(d) { return "Bicycle storage"; },
        clubroom: function(d) { return "Club room"; },
        wasteroom: function(d) { return "Waste collection room"; },
        buildingsauna: function(d) { return "Sauna"; },
        locker: function(d) { return "Dressing room"; },
        apartmentstorage: function(d) { return "Apartment storage"; },
        outdoorstorage: function(d) { return "Outdoor equipment storage"; },
        babycarriage: function(d) { return "Baby carriage storage"; },
        none: function(d) { return "No info"; },
        book: function(d) { return "Book"; }
      },
      altText: {
        tenantBuilding: function(d) { return "Exterior view of your residential building"; }
      },
      contacts: {
        title: function(d) { return "Contact information"; },
        manager: function(d) { return "Need to contact the property manager?"; },
        managerInfo: function(d) { return "Contact the property manager for administrative matters relating to the building."; },
        descriptionLeft: function(d) { return "At M2-Kodit, our competent customer service primarily helps with questions related to property management. Please contact our customer service (information on the left)."; },
        descriptionAbove: function(d) { return "At M2-Kodit, our competent customer service primarily helps with questions related to property management. Please contact our customer service (information above)."; },
        maintenance: function(d) { return "Maintenance company"; },
        maintenanceNotFound: function(d) { return "Maintenance company information is currently not available. Please check the building's notice board."; },
        maintenanceInfo: function(d) { return "If you notice an faults in your house or building, contact to your maintenance company."; },
        callMaintenance: function(d) { return "Call to maintenance"; },
        customerservice: function(d) { return "Customer service"; },
        customerserviceopen: function(d) { return "On weekdays from 9 AM to 3 PM"; },
        customerservicename: function(d) { return "M2-Kodit"; },
        email: {
          customerservice: {
            aria: function(d) { return "Opens default email client to contact M2-Kodit customer service"; }
          }
        },
        phone: {
          customerservice: {
            aria: function(d) { return "Opens phone application for calling to maintenance company's customer service"; }
          }
        },
        emergencyphone: {
          customerservice: {
            aria: function(d) { return "Opens phone application for calling to maintenance company's emergency number."; }
          }
        },
        customerserviceInfo: function(d) { return "The call costs the price set by your operator."; },
        emergency: function(d) { return "On-call services"; },
        phonenumber: function(d) { return "tel."; },
        urgentRequest: function(d) { return "Urgent Maintenance Request"; },
        urgentRequestInfo: function(d) { return "Call maintenance immediately if you notice a fault in your house or apartment that requires urgent repair, such as a water leak or any other issue that poses a danger to living conditions. You can find the contact information for your maintenance service below."; },
        temporaryUrgentRequestInfo: function(d) { return "Call maintenance immediately if you notice a fault in your house or apartment that requires urgent repair, such as a water leak or any other issue that poses a danger to living conditions."; },
        nonurgentRequest: function(d) { return "Non-Urgent Maintenance Request"; },
        nonurgentRequestInfo: function(d) { return "Report non-urgent issues by filling out a fault report online. Non-urgent issues are those that do not compromise living conditions."; }
      },
      briefings: {
        title: function(d) { return "Bulletins"; }
      },
      showall: {
        placeholder: function(d) { return "Show all"; }
      },
      documents: {
        title: function(d) { return "Documents"; }
      },
      instructions: {
        title: function(d) { return "Downloadable instructions"; }
      },
      emergencyplan: {
        title: function(d) { return "Property rescue plan"; },
        documentname: function(d) { return "Rescue plan"; }
      },
      noexist: {
        emergencyplan: function(d) { return "Rescue plan to be made available."; },
        briefings: function(d) { return "No bulletins."; },
        documents: function(d) { return "No documents."; },
        residentpricelist: function(d) { return "No resident price lists."; },
        instructions: function(d) { return "You can find the important contact information for dealing with everyday situations below. If you wish, you can also contact us via the contact form in the OmaM2-service found"; },
        instructionsLink: function(d) { return "here."; },
        laundry: function(d) { return "There is no laundry room available in your home building. "; }
      },
      moreInfo: function(d) { return "Additional info"; },
      yes: function(d) { return "Yes"; },
      no: function(d) { return "No"; },
      open: function(d) { return "Open"; },
      readmore: function(d) { return "Learn more"; },
      sauna: {
        label: function(d) { return "Sauna"; },
        title: function(d) { return "Sauna bookings"; }
      },
      booking: {
        moreInfo: function(d) { return "Read more"; }
      },
      safety: {
        title: function(d) { return "Safety and evacuation"; },
        download: function(d) { return "Evacuation plan, Safetum"; },
        rules: function(d) { return "Rules of conduct"; }
      },
      parking: {
        title: function(d) { return "Parking"; },
        header: function(d) { return "Resident Parking"; }
      },
      ownhouse: {
        title: function(d) { return "Own house"; }
      },
      notices: {
        title: function(d) { return "Notices"; }
      },
      events: {
        title: function(d) { return "Events"; }
      },
      reportFault: function(d) { return "Report a fault"; },
      latestnews: {
        title: function(d) { return "Latest news"; }
      },
      laundry: {
        title: function(d) { return "Laundry room"; }
      },
      internet: {
        title: function(d) { return "Internet connection"; },
        "no-internet": function(d) { return "No internet connection"; },
        dna: function(d) { return "50 Mbit/s Laajakaista, DNA"; },
        "dna-ethernet": function(d) { return "50 Mbit/s Ethernet, DNA"; },
        "dna-cabelmodem": function(d) { return "50 Mbit/s cabel modem, DNA"; },
        elisa: function(d) { return "50 Mbit/s Ethernet, Elisa"; }
      },
      storage: {
        title: function(d) { return "Storage"; }
      },
      externalnews: {
        title: function(d) { return "News from m2kodit.fi"; }
      },
      maintenanceCompany: function(d) { return "Maintenance company"; },
      rentSummary: {
        title: function(d) { return "Information on rent formation"; }
      }
    },
    bookings: {
      calendar: {
        title: function(d) { return "My reservations"; },
        pincode: function(d) { return "Your pin code:"; },
        userManual: function(d) { return "One4all Mobile user manual"; },
        noexist: function(d) { return "Reservation calendar not found!"; },
        navigate: function(d) { return "To my reservations"; }
      },
      list: {
        upcoming: function(d) { return "Upcoming reservations"; },
        noexist: function(d) { return "No upcoming reservations."; },
        link: function(d) { return "To my reservations."; },
        showall: function(d) { return "Show all"; }
      }
    },
    profile: {
      title: function(d) { return "Update your information"; },
      description: function(d) { return "Check that your contact details are up to date."; },
      contactinfoheader: function(d) { return "Contact details"; },
      phone: function(d) { return "Phone number"; },
      phonerequired: function(d) { return "Enter telephone number"; },
      phoneinvalid: function(d) { return "Check telephone number"; },
      email: function(d) { return "Email address"; },
      emailrequired: function(d) { return "Enter e-mail address"; },
      emailinvalid: function(d) { return "Check e-mail address"; },
      save: function(d) { return "Save"; },
      savesuccess: function(d) { return "Thank you, your information has been saved!"; },
      error: function(d) { return "Something went wrong! Please, try again."; },
      newsletter: function(d) { return "Subscribe to the M2-Kodit newsletter!"; },
      newsletterSubtitle: function(d) { return "You will be given current information about M2-Kodit apartments, tenant activities and services available to tenants."; },
      newsletterBtn: function(d) { return "Subscribe"; },
      protectionOrder: function(d) { return "Order of non-disclosure"; },
      protectionOrderText: function(d) { return "You have been set under an order of non-disclosure."; }
    },
    ownForms: {
      title: function(d) { return "My forms"; },
      description: function(d) { return "You can find your saved forms here."; },
      table: {
        name: function(d) { return "Name"; },
        state: function(d) { return "State"; },
        updated: function(d) { return "Updated"; },
        update: function(d) { return "Update"; }
      },
      noForms: function(d) { return "No saved documents"; },
      state: {
        Draft: function(d) { return "Draft"; },
        Published: function(d) { return "Published"; },
        AwaitingApproval: function(d) { return "Awaiting approval"; },
        Rejected: function(d) { return "Rejected"; },
        Approved: function(d) { return "Approved"; }
      }
    },
    footer: {
      housing: {
        defaultcontact: function(d) { return "Contact details"; },
        contact: function(d) { return "Your property’s contact information"; },
        manager: function(d) { return "Property manager"; },
        maintenance: function(d) { return "Maintenance company"; },
        customerservice: {
          title: function(d) { return "Customer service"; },
          name: function(d) { return "M2-Kodit"; },
          address: function(d) { return "Pitkänsillanranta 3 A, 00530, Helsinki"; },
          phone: function(d) { return "09 7742 5500"; },
          email: function(d) { return "m2.asiakaspalvelu@ysaatio.fi"; }
        },
        myhousing: function(d) { return "Information"; },
        news: function(d) { return "Bulletins"; },
        safety: function(d) { return "Safety and evacuation plan"; },
        parking: function(d) { return "Parking"; },
        laundry: function(d) { return "Laundry"; },
        sauna: function(d) { return "Sauna"; },
        internet: function(d) { return "Internet connection"; }
      },
      externalLinks: {
        facebook: function(d) { return "Follow us on Facebook"; },
        instagram: function(d) { return "Follow on Instagram"; }
      },
      copyright: function(d) { return "© 2024 M2-Kodit"; },
      dataprotection: function(d) { return "Data security"; },
      terms: function(d) { return "Terms of use and personal data protection"; },
      linkbutton: function(d) { return "See contact details"; },
      text: function(d) { return "M2-Kodit is a house rental company wholly owned by the Y Foundation, which manages more than ten thousand rental apartments throughout Finland. We offer rental homes that residents can afford. Our rents are determined according to ARA’s cost principle and are genuinely reasonable. We are not for profit."; },
      contact: {
        description: function(d) { return "Contact us from the link below. We will get back to you as soon as possible."; },
        button: function(d) { return "Contact us"; }
      },
      titles: {
        omam2: function(d) { return "OmaM2"; },
        apartment: function(d) { return "My apartment"; },
        housing: function(d) { return "My Building"; },
        fault: {
          reports: function(d) { return "Fault reports"; }
        },
        contact: function(d) { return "Contact"; }
      },
      apartment: {
        contract: function(d) { return "My lease agreement"; },
        billing: function(d) { return "My rent and payment information"; },
        maintenance: function(d) { return "User manuals and documents"; },
        apartmentchange: function(d) { return "Apartment exchange"; },
        watermeter: function(d) { return "Information on water billing"; },
        bookingsCalendar: function(d) { return "My reservations"; }
      }
    },
    signin: {
      title: function(d) { return "Welcome to OmaM2"; },
      step1: {
        descriptionTitle: function(d) { return "OmaM2 is the resident portal for M2-Kodit, where you can manage various aspects of your housing. Through the service, you can:"; },
        descriptionItems: function(d) { return "View your rent and payment details \n Submit a maintenance request \n Sign up for resident events open to everyone \n Manage your building's resident committee \n Get in touch with us."; },
        authdescription: function(d) { return "If you're using the service for the first time, please create an account. To register, you will need strong authentication, a valid email address, and an active lease agreement."; },
        placeholder: function(d) { return "Enter your phone number"; },
        label: function(d) { return "Phone number"; },
        error: function(d) { return "Check your phonenumber"; },
        forbidden: function(d) { return "User not found. Please contact the M2-Kodit customer service on +358 (0)9 7742 5500 or m2.asiakaspalvelu@ysaatio.fi."; },
        "continue": function(d) { return "Continue"; }
      },
      step2: {
        description: function(d) { return "Enter the single-use code sent to you as an SMS to sign in to the service."; },
        placeholder: function(d) { return "Enter code"; },
        label: function(d) { return "Single-use code"; },
        error: function(d) { return "Check the single-use sign in code"; },
        back: function(d) { return "Re-enter your phone number"; },
        doSignIn: function(d) { return "Sign in"; },
        acceptservice: function(d) { return "I accept"; },
        termsofuse: function(d) { return "the terms of use of the service."; }
      },
      step3: {
        description: function(d) { return "Verify your identity with your online banking credentials or your Mobile ID."; },
        error: function(d) { return "There was an error with the authentication. Please try again."; },
        forbidden: function(d) { return "User not found. Please contact the M2-Kodit customer service on +358 (0)9 7742 5500 or m2.asiakaspalvelu@ysaatio.fi."; },
        "continue": function(d) { return "Continue to authentication"; }
      },
      step4: {
        title: function(d) { return "Update your contact details"; },
        description: function(d) { return "Check that your contact details are up to date."; },
        phoneplaceholder: function(d) { return "Telephone number"; },
        phonerequired: function(d) { return "Enter telephone number"; },
        phoneinvalid: function(d) { return "Check telephone number"; },
        emailplaceholder: function(d) { return "E-mail address"; },
        noemail: function(d) { return "I have no e-mail address."; },
        emailrequired: function(d) { return "Enter e-mail address"; },
        emailinvalid: function(d) { return "Check e-mail address"; },
        save: function(d) { return "Save"; }
      },
      redirectToM2: function(d) { return "< Back to the m2kodit.fi front page"; },
      cancel: function(d) { return "Cancel"; },
      toRegistration: function(d) { return "Register"; },
      email: function(d) { return "Email address"; },
      username: function(d) { return "Email"; },
      password: function(d) { return "Password"; },
      submit: {
        button: function(d) { return "Sign in"; }
      },
      send: {
        button: function(d) { return "Send"; }
      },
      forgotPassword: function(d) { return "Forgot your password?"; },
      forgotPasswordInfo: function(d) { return "Enter your email address, and we will send you a code to reset your password."; },
      forgotPasswordError: function(d) { return "Sending link failed. Please, try again."; },
      setNewPassword: function(d) { return "Set new password"; },
      setNewPasswordInfo: function(d) { return "Enter the code you received by email and set a new password."; },
      save: function(d) { return "Save"; },
      newCode: function(d) { return "New code"; },
      newPasswordSaved: function(d) { return "New password saved"; },
      continueToLogin: function(d) { return "Continue to login"; },
      error: {
        incorrectCredentials: function(d) { return "Login failed: Invalid email or password."; },
        contractNotStarted: function(d) { return "Login failed: Your contract has not started yet. You will be able to log in on " + d.startDate + ", the official start date of your contract."; },
        contractExpired: function(d) { return "Login failed: Your contract has expired more than 30 days ago."; },
        contractNotFound: function(d) { return "Login failed: No active contract was found."; },
        general: function(d) { return "Login failed. Please, try again."; }
      },
      oneTimePassword: {
        title: function(d) { return "Confirm your account"; },
        instructions: function(d) { return "Almost there! Enter the one-time code you received in your email to confirm your account and you will be redirected to OmaM2. Didn't receive the code? Check your spam folder or"; },
        instructionsLink: function(d) { return "request a new code here."; },
        code: function(d) { return "Code"; },
        submit: function(d) { return "Submit"; },
        cancel: function(d) { return "Cancel"; },
        generalError: function(d) { return "Something went wrong. Please, check the code and try again."; },
        codeSent: function(d) { return "New code sent"; },
        codeSendFailed: function(d) { return "Could not send a new code. Please, try again later."; }
      }
    },
    ysaatio: {
      signin: {
        title: function(d) { return "Sign in"; },
        description: function(d) { return "Sign in with the credentials you created earlier. If you are a resident of M2-Kodit, you can log in using your OmaM2 service credentials."; }
      },
      signup: {
        title: function(d) { return "Lease termination"; },
        instructions1: function(d) { return "Create an account or log in to terminate your rental agreement for a Y-Säätiö or M2-Kodit apartment, or to accept a termination notice made by another tenant. Y-Säätiö and M2-Kodit are part of the Y-Säätiö Group."; },
        instructions2: function(d) { return "If you are a resident of M2-Kodit, you can log in using your OmaM2 account."; },
        instructions3: function(d) { return "Here you can also see the status of the termination notice."; },
        instructionsListTitle: function(d) { return "Creating an account consists of three steps:"; },
        instructionsList1: function(d) { return "Authenticate with strong identification."; },
        instructionsList2: function(d) { return "Enter your email and password."; },
        instructionsList3: function(d) { return "Enter the confirmation code sent to your email."; },
        "continue": function(d) { return "Create account"; },
        toSignIn: function(d) { return "Sign in"; },
        credentials: {
          title: function(d) { return "Enter your email and password"; },
          description: function(d) { return "Enter an email address and set a new password."; },
          afterPasswordDescription: function(d) { return "Please ensure you have entered your email and password correctly before proceeding. "; }
        },
        code: {
          title: function(d) { return "Enter your email and password"; },
          description: function(d) { return "Finish creating your account by entering the confirmation code sent to your email. It may take a few minutes for the code to arrive. Please remember to check your spam folder as well."; }
        },
        success: {
          title: function(d) { return "Registration successful "; },
          description: function(d) { return "You will now be directed to the contract termination form. You can log in later using these same credentials to check the status of your contract termination."; },
          button: function(d) { return "Continue "; }
        }
      }
    },
    validation: {
      signin: {
        username: function(d) { return "Email address is required."; },
        password: function(d) { return "Password is required."; },
        email: function(d) { return "Enter valid email address."; }
      },
      signup: {
        termsAccepted: function(d) { return "You must accept the terms of use to proceed with authentication."; },
        username: function(d) { return "Username must be valid email address."; },
        password: function(d) { return "The password must meet the requirements described below."; },
        confirmPassword: function(d) { return "Passwords must match."; },
        code: function(d) { return "Invalid code. Please check the code and try again."; }
      },
      forms: {
        contact: {
          subject: function(d) { return "Subject is required"; },
          content: function(d) { return "Message is required"; },
          subcategory: function(d) { return "Choose subcategory"; }
        },
        meetingMinutes: {
          name: function(d) { return "Meeting name is required"; },
          date: function(d) { return "Meeting date is required"; },
          time: function(d) { return "Meeting time is required"; },
          location: function(d) { return "Meeting location is required"; },
          participants: function(d) { return "At least two participants is required"; },
          items: {
            title: function(d) { return "Title is required"; },
            text: function(d) { return "Text is required"; }
          },
          chairperson: function(d) { return "Fill in first and last name"; },
          secretary: function(d) { return "Fill in first and last name"; },
          signatoryConfirmation: function(d) { return "You must confirm that you are the undersigned person"; }
        },
        actionPlan: {
          activities: {
            name: function(d) { return "Name of the event is required"; },
            month: function(d) { return "Month of the event is required"; },
            responsiblePersons: function(d) { return "Responsible persons are required"; }
          }
        },
        actionReport: {
          activities: {
            name: function(d) { return "Name of the event is required"; },
            month: function(d) { return "Month of the event is required"; },
            day: function(d) { return "Day of the event is required"; },
            additionalInformation: function(d) { return "Additional information is required"; }
          }
        },
        generalExpenseReport: {
          contactInfo: {
            name: function(d) { return "Name is required"; },
            address: function(d) { return "Address is required"; },
            zip: function(d) { return "ZIP code is required"; },
            city: function(d) { return "City is required"; },
            phone: function(d) { return "Phone number is required"; },
            email: function(d) { return "Email is required"; },
            iban: function(d) { return "Bank account in IBAN format is required"; }
          },
          event: {
            name: function(d) { return "Name of the event is required"; },
            date: function(d) { return "Date of the event is required"; }
          },
          purchaseReports: {
            report: function(d) { return "Purchase is required"; },
            amount: function(d) { return "Amount is required"; }
          }
        },
        travelExpenseReport: {
          contactInfo: {
            name: function(d) { return "Name is required"; },
            address: function(d) { return "Address is required"; },
            zip: function(d) { return "Zip code is required"; },
            city: function(d) { return "City is required"; },
            phone: function(d) { return "Phone number is required"; },
            email: function(d) { return "Email is required"; },
            iban: function(d) { return "Bank account in IBAN format is required"; }
          },
          event: {
            name: function(d) { return "Event name is required"; },
            location: function(d) { return "Location is required"; },
            travelRoute: function(d) { return "Travel route is required"; }
          },
          publicExpenseReports: {
            date: function(d) { return "Date is required"; },
            time: function(d) { return "Time is required"; },
            amount: function(d) { return "Amount is required"; },
            vehicle: function(d) { return "Vehicle is required"; }
          },
          ownCarExpenseReports: {
            date: function(d) { return "Date is required"; },
            time: function(d) { return "Time is required"; },
            numberOfPeople: function(d) { return "Number of people is required"; },
            totalKm: function(d) { return "Total kilometers are required"; }
          }
        },
        defectNotice: {
          title: function(d) { return "Title is required"; },
          description: function(d) { return "Description is required"; },
          affectedArea: function(d) { return "Choose affected area"; },
          defectClass: function(d) { return "Choose defect type"; }
        },
        terminateLease: {
          endDate: function(d) { return "Contract end date is required."; },
          movingOutDate: function(d) { return "Move-out date must be between the current date and the end date of the agreement."; },
          terminationReason: function(d) { return "Select primary reason for termination."; },
          displayStartDate: function(d) { return "Earliest date for apartment viewing is required."; },
          displayEndDate: function(d) { return "The latest apartment viewing date must before the contract end date."; },
          newAddress: {
            recipientName: function(d) { return "Recipient name is required."; },
            streetAddress: function(d) { return "Street address is required."; },
            postalCode: function(d) { return "Postal code is required."; },
            city: function(d) { return "City is required."; }
          },
          beneficiaries: {
            beneficiaryName: function(d) { return "Account holder name is required."; },
            email: function(d) { return "Email address is required."; },
            phoneNumber: function(d) { return "Phone number is required."; },
            iban: function(d) { return "BIC code is required with foreign bank accounts."; }
          }
        },
        termination: {
          instructionsRead: function(d) { return "Confirm that you have read and understood the termination instructions."; }
        }
      }
    },
    signup: {
      title: function(d) { return "Sign up to OmaM2 service"; },
      instructions: function(d) { return "You can register for the OmaM2 service once your agreement has started. To create an account, you need a valid email address that you have access to. Registration requires strong authentication using online banking credentials or a mobile certificate."; },
      instructions2: function(d) { return "Already registered? Continue to login by clicking"; },
      alreadySignedupLink: function(d) { return "here"; },
      accept: function(d) { return "Accept the service's"; },
      termsOfUse: function(d) { return "terms of use"; },
      "continue": function(d) { return "Continue to authentication"; },
      cancel: function(d) { return "Cancel"; },
      createAccount: function(d) { return "Create an account to OmaM2 service"; },
      accountInstructions: function(d) { return "After registering, you can sign in to the service with your email address and password."; },
      username: function(d) { return "Email address"; },
      password: function(d) { return "Password"; },
      passwordRequirements: function(d) { return "The password must be at least 8 characters long and must include at least one uppercase letter, at least one lowercase letter, at least one number, and at least one special character."; },
      confirmPassword: function(d) { return "Confirm password"; },
      saveAndContinue: function(d) { return "Save and continue"; },
      usernameplaceholder: function(d) { return "Your email address"; },
      credentialsError: function(d) { return "Creating an account failed. Please, try again."; },
      usernameError: function(d) { return "This email is not available."; },
      passwordError: function(d) { return "This password did not meet the requirements."; },
      code: function(d) { return "Code"; },
      codeInstructions: function(d) { return "Enter the one-time code you received by email to confirm your registration for the service."; },
      successStep: function(d) { return "Registration successful. You can now sign in to OmaM2."; },
      returnToLogin: function(d) { return "To login"; },
      generalError: function(d) { return "Something went wrong. Please, try again."; },
      invalidCodeError: function(d) { return "Invalid code. Check the code you received by email and try again."; },
      expiredCodeError: function(d) { return "Expired code. Request a new code and try again."; },
      limitExceededError: function(d) { return "Too many failed attempts. Wait for a while and try again."; },
      signup: function(d) { return "Sign up"; }
    },
    feedback: {
      step1: {
        title: function(d) { return "You have signed out of OmaM2."; },
        question: function(d) { return "Did you find OmaM2 helpful?"; },
        yes: function(d) { return "Yes"; },
        no: function(d) { return "No"; },
        placeholder: function(d) { return "Please give us feedback so we can improve our service. Your feedback will be kept anonymous."; },
        send: function(d) { return "Send"; }
      },
      step2: {
        title: function(d) { return "Thank you for your feedback!"; },
        login: function(d) { return "Login"; }
      },
      redirectToM2: function(d) { return "< Back to the m2kodit.fi front page"; }
    },
    messages: {
      "new": {
        title: function(d) { return "Housing-Related Questions"; },
        desc: function(d) { return "Use the form below to send a message to our customer service."; },
        info: function(d) { return "Our customer service is here to help you with any questions related to housing and rent payments via email and phone on weekdays from 9 AM to 3 PM."; },
        choose: function(d) { return "Choose the topic"; },
        housing: {
          "": function(d) { return "if your issue is regarding problematic situations with housing (eg. housing allowance or other benefits, managing finances, maintaining neighbour relations, keeping your home clean)"; },
          debtassistance: function(d) { return "Advice in debt issues"; },
          benefitapplication: function(d) { return "Help in applying benefits (e.g., general housing allowence)"; },
          tooexpensive: function(d) { return "Too expensive apartment"; },
          neighbourdispute: function(d) { return "Help in resolving a neighbor dispute"; },
          evictionassistance: function(d) { return "Advice in an eviction situation"; },
          dailyerrandsassistance: function(d) { return "Advice in handling challenges in life"; },
          mentalhealthandsubstanceabuse: function(d) { return "Advice in mental health or substance abuse issues"; }
        },
        billing: {
          "": function(d) { return "if your issue is related to paying rent"; },
          latepayment: function(d) { return "Small delay in rent payment"; },
          paymentissues: function(d) { return "Difficulties in paying the rent"; },
          debtrepayment: function(d) { return "Settling existing debt / Negotiating a payment plan"; }
        },
        customerservice: {
          "": function(d) { return "if your issue is regarding other issues"; },
          apartmentapplications: function(d) { return "Application for an apartment"; },
          sauna_laundry_parking: function(d) { return "Sauna-, laundry room- or parking space reservations"; },
          contracttermination: function(d) { return "Termination of lease/moving out"; },
          propertymanagement: function(d) { return "Issues concerning property management"; },
          faultreports: function(d) { return "Request for maintenance / Report a fault"; },
          other: function(d) { return "Other matters"; }
        },
        faultreportstart: function(d) { return "Fault reports"; },
        faultreport: function(d) { return "are used to report issues or problems regarding your apartment or your building and its common spaces. Faults reports are intended for non-urgent repair and maintenance requests. In urgent situations call your building's"; },
        faultreportlink: function(d) { return "maintenance company."; },
        replysoon: function(d) { return "We will reply by e-mail as soon as possible."; },
        form: {
          email: function(d) { return "E-mail address"; },
          emailrequired: function(d) { return "Enter e-mail address"; },
          emailinvalid: function(d) { return "Check e-mail address"; },
          phone: function(d) { return "Telephone number"; },
          phonerequired: function(d) { return "Enter telephone number"; },
          phoneinvalid: function(d) { return "Check telephone number"; },
          name: function(d) { return "Name"; },
          subject: function(d) { return "Header"; },
          subjectrequired: function(d) { return "Enter header"; },
          contentrequired: function(d) { return "Enter message"; },
          button: function(d) { return "Send message"; },
          messagesent: function(d) { return "Your message has been sent!"; },
          messagefailure: function(d) { return "Failed to send message. Please, try again."; },
          categories: {
            "471": function(d) { return "Customer service"; },
            "473": function(d) { return "Payment of rent"; },
            "859": function(d) { return "Housing counselling"; },
            problemhouse: function(d) { return "Fault report concerning the building"; }
          }
        },
        instruction: {
          latepayment: function(d) { return "If you want to discuss a possibility to pay your rent in a longer term, choose 'Settling existing debt / Negotiating a payment plan' if you want to inform a small delay (maximum 3 days) in rent payment, continue filling in the form."; },
          sauna_laundry_parking: function(d) { return "In sauna, laundry room and parking space reservations please contact your own"; },
          faultreports: function(d) { return "In case of a water-, smoke- or fire damages, or if your refrigerator/freezer doesn't work, call immediately to your"; },
          faultreportsother: function(d) { return "In other maintenance/fault situations"; },
          ariafaultreport: function(d) { return "Navigate to fault report form in m2-kodit.fi (open in new tab)"; },
          scrolltomaintenance: function(d) { return "Scroll to maintenance company's contact information."; },
          linktofaultreport: function(d) { return "report a fault"; },
          propertymanagement: function(d) { return "Your message will be directed to our customer service, where questions concerning property management are primarily dealt with. If your issue can only be resolved by the property manager, our customer service ensures that your message will reach the property manager."; }
        },
        instructions: {
          toMaintenanceCompany: function(d) { return "maintenance company"; }
        }
      },
      title: function(d) { return "Fault reports"; },
      maindescription: function(d) { return "View the status of the fault reports of your apartment or building."; },
      description: function(d) { return "Fault reports for your apartment, received through the online form"; },
      disclaimer1: function(d) { return "Fault reports made by phone or email will not be shown in OmaM2."; },
      deschousing: function(d) { return "Fault reports for your building, received through the online form"; },
      disclaimer2: function(d) { return "Fault reports made by phone or email will not be shown in OmaM2."; },
      disclaimer3: function(d) { return "Please note that the list includes every fault report concerning the common areas in your building."; },
      emptylist: function(d) { return "No fault reports."; },
      subject: function(d) { return "Subject"; },
      messageStatuses: {
        "0": function(d) { return "Received"; },
        "1": function(d) { return "Pending"; },
        "2": function(d) { return "Completed"; },
        Sent: function(d) { return "Received"; },
        InProgress: function(d) { return "Pending"; },
        Ready: function(d) { return "Completed"; }
      },
      showmore: function(d) { return "Show all"; },
      newmessage: function(d) { return "Report a problem"; }
    },
    message: {
      success: {
        success: function(d) { return "Message was sent successfully!"; },
        description: function(d) { return "You will be redirected to the front page shortly. You can also return immediately by clicking the Front Page button below."; },
        button: function(d) { return "Frontpage"; }
      }
    },
    billing: {
      title: function(d) { return "Rent and payment information"; },
      history: {
        title: function(d) { return "Payment history"; },
        period: function(d) { return "Payment period"; },
        billed: function(d) { return "Invoiced"; },
        paid: function(d) { return "Payments"; },
        duedate: function(d) { return "Due date"; },
        paiddate: function(d) { return "Payment date"; },
        sum: function(d) { return "Total"; },
        advance: function(d) { return "excess amount paid remaining"; },
        remaining: function(d) { return "overdue payments remaining"; },
        uptodate: function(d) { return "your payments are up to date"; },
        prevAdvance: function(d) { return "Excess amount paid in previous payment periods"; },
        prevRemaining: function(d) { return "Overdue payments in previous payment periods"; },
        prevUnknown: function(d) { return "No information on excess paid amounts or overdue payments from previous payment periods"; }
      },
      description: function(d) { return "OmaM2 service has been updated! Due to the update, you will see your payment information here starting from April 1, 2025."; },
      description2: function(d) { return "Your payment will appear in OmaM2 and in M2-Kodit rent control within 3-5 banking days. Please note that holidays are not considered as banking days."; },
      print: {
        description: function(d) { return "Your rent invoice and the payment details can be found by clicking or tapping the button below."; },
        title: function(d) { return "Print your rent invoice"; },
        parkingLot: function(d) { return "Print your parking space invoice"; },
        page: function(d) { return "Print"; }
      },
      filter: {
        startdate: function(d) { return "Start report from month"; },
        enddate: function(d) { return "End report at month"; },
        applyrange: function(d) { return "Show the time range"; },
        showall: function(d) { return "Show all"; },
        showbilled: function(d) { return "Show invoices"; },
        showpaid: function(d) { return "Show payments"; }
      },
      gotopayment: function(d) { return "Make a payment"; },
      payment: {
        title: function(d) { return "Pay the rent"; },
        description: function(d) { return "After a successful payment transaction, you will receive a confirmation message in your email. Your payment will appear in OmaM2 and in M2-Kodit rent control within 3-5 banking days."; },
        description2: function(d) { return "You can pay your debt in full or in installments. <b>NOTE! When paying through OmaM2, always start a new payment transaction below.</b> Start a new payment transaction, even if the transaction concerns a previous payment installment. <b>Do not use the payment information of an old payment paid in the OmaM2 service.</b>"; },
        errorhelptext: function(d) { return "There is a problem with the transaction. Please use your online bank or a bill to make the payment."; },
        error: function(d) { return "Payment initialization failed. Please, try again."; },
        subtitle1: function(d) { return "1. Give the payment amount"; },
        description1: function(d) { return "You are due"; },
        tobepaid: function(d) { return "Amount to be paid"; },
        amounttoolow: function(d) { return "Minimum payment amount is 1 €"; },
        subtitle2: function(d) { return "2. Choose your payment method"; },
        paymentinfo: function(d) { return "Payment details"; },
        paymentreceiver: function(d) { return "Receiver"; },
        paymentreceiver2: function(d) { return "Kiinteistö Oy M2-Kodit"; },
        referencenumber: function(d) { return "Reference number"; },
        sum: function(d) { return "Amount to be paid"; },
        gotopayment: function(d) { return "Make a payment"; },
        showbilling: function(d) { return "Show debt details"; },
        paytrailinfo: function(d) { return "We use Paytrail as our payment processor. Note! On your own account statement, Paytrail Oyj is shown as the recipient of the payment, and a different reference is shown as the payment reference. These account and reference information should not be copied or used again to pay the debt in your own online bank."; },
        success: function(d) { return "Your payment has been registered and will be visible in the OmaM2 service within 3-5 banking days. You will receive a confirmation message in your email."; },
        failure: function(d) { return "The transaction was terminated."; },
        "continue": function(d) { return "Continue"; },
        recent: function(d) { return "You have paid " + d.amount + " € on " + d.time + ". Please note that your payment will be visible in OmaM2 once the bank transfer has been completed in the M2-Kodit rent control (at least three (3) banking days). Holidays and weekends are not counted as bank days, which means that it may take several days for the payment to appear."; }
      },
      current: {
        period: function(d) { return "Current payment period"; },
        advance: function(d) { return "Excess amount paid in advance"; },
        remaining: function(d) { return "Payments currently overdue"; },
        uptodate: function(d) { return "Your payments are up to date"; }
      },
      itemized: function(d) { return "Show debt report"; },
      months: {
        "0": function(d) { return "January"; },
        "1": function(d) { return "February"; },
        "2": function(d) { return "March"; },
        "3": function(d) { return "April"; },
        "4": function(d) { return "May"; },
        "5": function(d) { return "June"; },
        "6": function(d) { return "July"; },
        "7": function(d) { return "August"; },
        "8": function(d) { return "September"; },
        "9": function(d) { return "October"; },
        "10": function(d) { return "November"; },
        "11": function(d) { return "December"; }
      },
      historyloadfailure: function(d) { return "Failed to load payment history. Please try again later."; }
    },
    agreement: {
      title: function(d) { return "My lease agreement"; },
      label: function(d) { return "Lease agreement"; },
      istemporary: function(d) { return "Fixed term"; },
      month: function(d) { return "Monthly"; },
      personmonth: function(d) { return "per person per month"; },
      permonth: function(d) { return "per month"; },
      day: function(d) { return "day"; },
      last: function(d) { return "last"; },
      apartment: {
        title: function(d) { return "Apartment information"; },
        address: function(d) { return "Address"; },
        type: function(d) { return "Apartment type"; },
        sqfoot: function(d) { return "Floor area"; },
        sqfootFull: function(d) { return "Apartment floor area"; },
        houseowner: function(d) { return "Lessor"; }
      },
      tenants: {
        title: function(d) { return "Residents"; },
        title2: function(d) { return "Tenant information"; },
        contract: function(d) { return "Tenant / Tenants:"; },
        partiesUnavailable: function(d) { return "Information about other tenants/residents is not available at the moment."; },
        other: function(d) { return "Other residents:"; }
      },
      print: function(d) { return "Print the information"; },
      download: function(d) { return "Download the lease agreement terms"; },
      terminate: function(d) { return "Terminate your lease"; },
      terminateTitle: function(d) { return "Lease termination"; },
      terminateInfo: function(d) { return "Due to a system update, lease termination temporarily requires you to create a separate login. After registering you will find the termination form."; },
      lease: {
        title: function(d) { return "Rent and water tariff"; },
        title2: function(d) { return "Rent and water tariff"; },
        infoUnavailable: function(d) { return "The rent information is not available at the moment."; },
        price: function(d) { return "Rent"; },
        waterPrePayment: function(d) { return "Advance water tariff"; },
        waterPerPerson: function(d) { return "Water tariff"; },
        waterPaymentUnavailable: function(d) { return "Water tariff information is not available at the moment."; },
        waterPerConsumption: function(d) { return "Water tariff according to water consumption"; },
        duedate: function(d) { return "Due date"; }
      },
      period: {
        title: function(d) { return "Rent period"; },
        type: function(d) { return "Lease"; },
        startdate: function(d) { return "Lease valid from"; },
        enddate: function(d) { return "Lease valid until"; },
        paiddeposit: function(d) { return "Paid security deposit"; }
      },
      deposit: {
        title: function(d) { return "Security deposit payment"; },
        moneyAmount: function(d) { return "Cash amount"; },
        voucher: function(d) { return "Security deposit voucher"; },
        info: function(d) { return "The security deposit will be refunded approximately one month after the end of the lease, provided that no billable damages were found during the apartment inspection, all keys have been returned, and no invoices remain unpaid."; },
        infoUnavailable: function(d) { return "The rent deposit information is not available at the moment."; },
        noDeposit: function(d) { return "This contract does not include a security deposit."; }
      },
      history: {
        title: function(d) { return "History"; },
        text: function(d) { return "Tenant since " + d.startDate; }
      }
    },
    modal: {
      redirect: function(d) { return "The service will be opened in a new tab."; },
      "continue": function(d) { return "Continue"; },
      cancel: function(d) { return "Cancel"; },
      close: function(d) { return "Close"; }
    },
    onboarding: {
      welcome: function(d) { return "Welcome"; },
      info1: function(d) { return "The OmaM2 service is an online service open to all residents of M2-Kodit.\n \nLearn more by clicking or tapping the arrows or numbers."; },
      uptodate: function(d) { return "Information up to date"; },
      info2: function(d) { return "Update your contact details, view the information of your property or contact M2-Kodit."; },
      rental: function(d) { return "My tenancy information"; },
      info3: function(d) { return "The rent payment page contains a summary of your rent payments. Here, you can also print your rent invoice."; },
      developing: function(d) { return "OmaM2 is being developed"; },
      info4: function(d) { return "We are developing the OmaM2 service continuously. New features will be added. Please provide us feedback when you sign out."; }
    },
    debt: {
      title: function(d) { return "Debt report"; },
      description: function(d) { return "Your debt report includes all unpaid invoices. Payments are always allocated to the unpaid invoice with the earliest date of issue. You can suggest a payment plan to M2-Kodit."; },
      paytype: function(d) { return "Unpaid payments"; },
      rent: function(d) { return "Rent"; },
      collectioncharge: function(d) { return "Collection costs"; },
      penaltyinterest: function(d) { return "Late payment interest"; },
      saunapayment: function(d) { return "Sauna room fee"; },
      debtamount: function(d) { return "Debt"; },
      duedate: function(d) { return "Due date"; },
      sum: function(d) { return "Total"; },
      print: function(d) { return "Print invoice"; },
      contact: {
        title: function(d) { return "Suggest a payment plan"; },
        description: function(d) { return "If you are unable to pay your entire debt at once, you can discuss a payment plan by calling our customer service."; },
        description2: function(d) { return "Phone: 09 7742 5500, open Monday to Friday from 9–15"; },
        paysuggestion: function(d) { return "Payment plan suggestion"; },
        placeholder: function(d) { return "Enter the precise sums and dates for repayment and the rent due during the payment plan."; },
        subject: function(d) { return "Message subject"; },
        email: function(d) { return "E-mail address"; },
        phonenumber: function(d) { return "Telephone number"; },
        name: function(d) { return "Name"; },
        send: function(d) { return "Send"; },
        copymessage: function(d) { return "If you have entered an e-mail address, a copy of the message you sent will be sent to this address. You can update your contact details in the My information page."; }
      },
      error: function(d) { return "Failed to load debt report."; },
      goToPayment: function(d) { return "Make a payment"; },
      goToBilling: function(d) { return "Rent and payment information"; }
    },
    m2: {
      about: {
        title: function(d) { return "About M2-Kodit"; }
      },
      sustainability: {
        title: function(d) { return "Sustainability"; }
      }
    },
    living: {
      home: {
        title: function(d) { return "Living in M2-Kodit"; }
      },
      benefits: {
        title: function(d) { return "Tenant benefits"; }
      },
      events: {
        title: function(d) { return "Tenant events"; },
        upcoming: function(d) { return "Upcoming events"; },
        noupcoming: function(d) { return "No upcoming events"; }
      },
      activities: {
        title: function(d) { return "Community activities"; }
      },
      committee: {
        title: function(d) { return "Resident committee"; }
      }
    },
    myBuilding: {
      notices: {
        title: function(d) { return "Notices"; },
        noData: function(d) { return "No published notices"; },
        committee: function(d) { return "Resident committee"; },
        readMore: function(d) { return "Read more"; },
        actionPlan: {
          title: function(d) { return "Action plan " + d.year; }
        },
        actionReport: {
          title: function(d) { return "Action report " + d.year; }
        }
      },
      events: {
        title: function(d) { return "Building's events"; },
        noData: function(d) { return "No published events"; }
      },
      documents: {
        title: function(d) { return "Guides and documents"; },
        heading: function(d) { return "M2-Kodit"; },
        description: function(d) { return "From this page you will find important information and instructions regarding your home's appliances, upkeeping and maintenance."; },
        downloadPdf: function(d) { return "Download PDF"; },
        noDocuments: function(d) { return "No documents"; }
      }
    },
    forms: {
      title: function(d) { return "Forms to simplify your business"; },
      pdf: {
        powerofattorney: function(d) { return "Power of attorney to represent the tenant (PDF)"; },
        keytransferagreement: function(d) { return "Key handover agreement (PDF)"; },
        personaldataconsent: function(d) { return "Tenant's consent to disclosure of personal data (PDF)"; },
        estateinstructions: function(d) { return "Instructions for the estate (PDF)"; }
      },
      committee: {
        title: function(d) { return "Forms for resident committee"; },
        description: function(d) { return "You can find digital resident committee forms here."; }
      },
      save: function(d) { return "Save"; },
      preview: function(d) { return "Preview"; },
      publish: function(d) { return "Publish"; },
      send: function(d) { return "Send"; },
      emptyForm: function(d) { return "Empty form"; },
      closePreview: function(d) { return "Close preview"; },
      edit: function(d) { return "Edit"; },
      error: {
        general: function(d) { return "Something went wrong, please try again in a moment."; },
        save: function(d) { return "An error occurred while saving, please try again in a moment."; },
        publish: function(d) { return "An error occurred while publishing, please try again in a moment."; },
        submit: function(d) { return "An error occurred while sending the form, please try again in a moment."; }
      },
      info: {
        published: function(d) { return "The form has been submitted for approval to M2-Kodit. Publication occurs within approximately 3 days."; },
        submitted: function(d) { return "The form has been submitted for approval to M2-Kodit."; },
        saved: function(d) { return "Form has been saved."; }
      },
      approve: function(d) { return "Approve"; },
      reject: function(d) { return "Reject"; },
      files: {
        error: {
          invalidImageOrPdf: function(d) { return "Only PDF and image files are allowed. The maximum file size is " + d.maxSize + " MB."; }
        }
      },
      review: {
        tokenExpired: function(d) { return "Link has expired."; },
        tokenNotFound: function(d) { return "404: Form has already been reviewed or the link is invalid."; },
        error: function(d) { return "Something went wrong. Please, try again."; },
        formApproved: function(d) { return "Form approved"; },
        formRejected: function(d) { return "Form rejected"; },
        orderNewToken: function(d) { return "Order new link "; },
        newTokenSent: function(d) { return "New link has been sent by email."; }
      },
      contact: {
        category: function(d) { return "Topic"; },
        subcategory: function(d) { return "Specific topic"; },
        subject: function(d) { return "Subject"; },
        contentPlaceholder: function(d) { return "State your matter, or ask anything about housing and rent payments."; },
        content: function(d) { return "Message"; }
      },
      meetingMinutes: {
        title: function(d) { return "Memo or meeting minutes"; },
        description: {
          part1: function(d) { return "By filling in the required fields"; },
          part2: function(d) { return "you can publish memos and meeting minutes in OmaM2. The content will be sent to a moderator for approval before being published. Publication occurs within approximately 3 days."; }
        },
        create: function(d) { return "Create memo"; },
        name: function(d) { return "Name of the meeting"; },
        date: function(d) { return "Date"; },
        time: function(d) { return "Time"; },
        location: function(d) { return "Location"; },
        locationPlaceholder: function(d) { return "Meeting location"; },
        participants: function(d) { return "The number of participants"; },
        content: {
          title: function(d) { return "Content"; },
          description: function(d) { return "If you are drafting the meeting minutes, please include the required topics such as meeting organization and the selection of minute checkers. There are no limits on the number of headings or paragraphs."; }
        },
        items: {
          title: function(d) { return "Heading"; },
          text: function(d) { return "Content"; },
          textPlaceholder: function(d) { return "Content"; }
        },
        addNewHeading: function(d) { return "Add new heading"; },
        removeHeading: function(d) { return "Remove heading"; },
        signatures: {
          title: function(d) { return "Signatures"; }
        },
        chairperson: function(d) { return "Chairperson"; },
        secretary: function(d) { return "Secretary"; },
        signature: {
          placeholder: function(d) { return "Firstname Lastname"; }
        },
        signatoryConfirmation: {
          description: function(d) { return "By submitting the form, I can confirm that I am the undersigned person"; }
        },
        emptyForm: function(d) { return "Clear the form"; }
      },
      actionPlan: {
        title: function(d) { return "Action plan"; },
        previewTitle: function(d) { return "Action plan " + d.year; },
        description: {
          part1: function(d) { return "By filling in the required fields"; },
          part2: function(d) { return "you can publish memos and meeting minutes in OmaM2. The plan will be sent to a moderator for approval before being published. Publication occurs within approximately 3 days."; }
        },
        year: function(d) { return "Plan for the year"; },
        create: function(d) { return "Create action plan"; },
        budgetEstimate: function(d) { return "Budget estimate"; },
        plannedActivities: {
          title: function(d) { return "Planned activities and events"; },
          description: function(d) { return "Add all the events planned for the year. You can add as many events as needed."; }
        },
        activities: {
          name: function(d) { return "Activity or event"; },
          month: function(d) { return "Month"; },
          day: function(d) { return "Day"; },
          time: function(d) { return "Time"; },
          responsiblePersons: function(d) { return "Responsible persons"; },
          budgetEstimate: function(d) { return "Budget estimate"; }
        },
        addNewEvent: function(d) { return "Add new event"; },
        removeEvent: function(d) { return "Remove"; },
        eventCount: function(d) { return d.count + " event"; },
        eventCount_plural: function(d) { return d.count + " events"; },
        totalBudgetEstimate: function(d) { return "Total budget estimate"; },
        totalBudgetEstimateWithAmount: function(d) { return "Total budget estimate " + d.amount + " €"; }
      },
      actionReport: {
        title: function(d) { return "Action report"; },
        description: {
          part1: function(d) { return "By filling in the required fields"; },
          part2: function(d) { return "you can publish the report in OmaM2. The report will be sent to a moderator for approval before being published. Publication occurs within approximately 3 days."; }
        },
        year: function(d) { return "Report for the year"; },
        create: function(d) { return "Create action report"; },
        expenses: function(d) { return "Expenses"; },
        completedActivities: {
          title: function(d) { return "Completed activities and events"; },
          description: function(d) { return "Add all completed events"; }
        },
        activities: {
          name: function(d) { return "Action or event"; },
          month: function(d) { return "Month"; },
          day: function(d) { return "Day"; },
          time: function(d) { return "Time"; },
          additionalInformation: function(d) { return "Additional information"; },
          additionalInformationPlaceholder: function(d) { return "Description of activity or event"; },
          expenses: function(d) { return "Expenses, €"; }
        },
        addNewEvent: function(d) { return "Add new event"; },
        removeEvent: function(d) { return "Remove"; },
        eventCount: function(d) { return d.count + " event"; },
        eventCount_plural: function(d) { return d.count + " events"; },
        totalExpenses: function(d) { return "Total expenses"; },
        totalExpensesWithAmount: function(d) { return "Total expenses " + d.amount + " €"; },
        previewTitle: function(d) { return "Action report " + d.year; }
      },
      generalExpenseReport: {
        title: function(d) { return "Expense report"; },
        description: function(d) { return "The report will be sent to M2-Kodit for processing."; },
        contactInfo: {
          title: function(d) { return "Resident's contact information"; },
          name: function(d) { return "Name"; },
          address: function(d) { return "Address"; },
          zip: function(d) { return "ZIP code"; },
          city: function(d) { return "City"; },
          phone: function(d) { return "Phone number"; },
          email: function(d) { return "Email"; },
          iban: function(d) { return "Bank account (IBAN)"; }
        },
        create: function(d) { return "Fill out expense report"; },
        event: {
          title: function(d) { return "Event"; },
          name: function(d) { return "Name of the event"; },
          date: function(d) { return "Date"; },
          additionalInformation: function(d) { return "Additional clarification"; }
        },
        purchaseReports: {
          title: function(d) { return "Report on purchases"; },
          description: function(d) { return "E.g., refreshments for a volunteer event or crafting materials. Scan or take a photo of the original receipt and attach it to the form under 'Attach receipt.' Reimbursement requires a receipt."; },
          report: function(d) { return "Purchase"; },
          amount: function(d) { return "Amount, €"; },
          addReceipt: function(d) { return "Add receipt"; },
          addNewPurchase: function(d) { return "Add new purchase"; },
          limitReached: function(d) { return "You can add a maximum of 3 expense reports per form. "; },
          removePurchase: function(d) { return "Remove"; },
          total: function(d) { return "Total " + d.amount + " €"; }
        }
      },
      travelExpenseReport: {
        title: function(d) { return "Travel expense report"; },
        description: function(d) { return "Fill in your personal information and travel expenses. The report will be sent to M2-Kodit for processing."; },
        create: function(d) { return "Fill out travel expense report"; },
        contactInfo: {
          title: function(d) { return "Resident's contact information"; },
          name: function(d) { return "Name"; },
          address: function(d) { return "Address"; },
          zip: function(d) { return "ZIP code"; },
          city: function(d) { return "City"; },
          phone: function(d) { return "Phone number"; },
          email: function(d) { return "Email"; },
          iban: function(d) { return "Bank account (IBAN)"; }
        },
        event: {
          title: function(d) { return "Purpose and location of the trip"; },
          name: function(d) { return "Event name"; },
          location: function(d) { return "Location"; },
          travelRoute: function(d) { return "Travel route"; }
        },
        reports: {
          title: function(d) { return "Travel expenses"; },
          description: function(d) { return "Travel expenses are reimbursed according to the costs of public transportation unless otherwise agreed in advance."; },
          publicTransportationTitle: function(d) { return "Public transport expenses"; },
          addPublicTransportationExpense: function(d) { return "Add public transport expense"; },
          ownTransportationTitle: function(d) { return "Private car expenses"; },
          addOwnTransportationExpense: function(d) { return "Add private car expense"; },
          limitReached: function(d) { return "You can add a maximum of 3 expense reports per form."; },
          remove: function(d) { return "Remove"; }
        },
        publicExpenseReports: {
          date: function(d) { return "Date"; },
          time: function(d) { return "Time"; },
          amount: function(d) { return "Amt. €"; },
          vehicle: function(d) { return "Mode of transportation"; },
          receiptInfo: function(d) { return "Scan or take a photo of the original receipts and attach them to the form using the \"Add Receipt\" button."; },
          additionalInformation: function(d) { return "Additional details"; }
        },
        ownCarExpenseReports: {
          date: function(d) { return "Date"; },
          time: function(d) { return "Time"; },
          numberOfPeople: function(d) { return "Number of people"; },
          totalKm: function(d) { return "Km, Total"; },
          compensationInfo: function(d) { return "The mileage allowance and other travel expenses are reimbursed in accordance with the Tax Administration's decision for each year. Check the amounts"; },
          additionalInformation: function(d) { return "Names of the people in the car / report from a possible trailer"; },
          ownCar: function(d) { return "Private car"; }
        },
        info: function(d) { return "Info"; },
        addReceipt: function(d) { return "Add receipt"; },
        ownCarInfoPopup: {
          subject: function(d) { return "Travel expenses by your own car"; },
          description: function(d) { return "Expenses will only be reimbursed if agreed upon in advance. The kilometer allowance is taxable income and must be reported in your taxation."; }
        }
      },
      eventInvite: {
        title: function(d) { return "Event invitation"; },
        description: {
          part1: function(d) { return "By filling in the required fields"; },
          part2: function(d) { return "you can publish an event invitation in the OmaM2 service. Invitations are sent to moderators for approval. Content is published on weekdays between 9 AM and 3 PM, and it is recommended to send the invitation at least 2 weeks in advance."; }
        },
        create: function(d) { return "Create event invite"; },
        eventType: function(d) { return "Event type"; },
        name: function(d) { return "Event name"; },
        subject: function(d) { return "Event subject"; },
        date: function(d) { return "Date"; },
        time: function(d) { return "Time"; },
        location: function(d) { return "Location"; },
        locationPlaceholder: function(d) { return "Location of the meeting"; },
        eventDescription: function(d) { return "Description"; },
        eventDescriptionPlaceholder: function(d) { return "What will happen at the event? Will there be refreshments? Will the communal sauna be heated? How can we encourage residents to join?"; },
        agenda: function(d) { return "Agenda"; },
        agendaNote: function(d) { return "Note: Only matters listed on the agenda can be officially decided in the minutes."; },
        regards: function(d) { return "Regards"; },
        regardsPlaceholder: function(d) { return "Greetings,\n \n Resident Committee"; },
        contactPerson: function(d) { return "Contact person"; },
        contactPersonPlaceholder: function(d) { return "Name or email"; },
        property: function(d) { return "Property"; },
        propertyPlaceholder: function(d) { return "Property's address"; },
        coverImage: function(d) { return "Cover image"; },
        coverImageOption: {
          propertyImage: function(d) { return "Property image"; },
          noImage: function(d) { return "No image"; }
        },
        publication: {
          title: function(d) { return "Publication settings"; },
          publicationRepeat: function(d) { return "Repeat event"; },
          repeatEndDate: function(d) { return "Repeat ends"; }
        },
        communityMeeting: function(d) { return "Community meeting"; },
        eventTypes: {
          communityWorkDay: function(d) { return "Community work day"; },
          party: function(d) { return "Party"; },
          communityMeeting: function(d) { return "Community meeting"; },
          otherEvent: function(d) { return "Other resident event"; }
        }
      },
      defectNotice: {
        formTitle: function(d) { return "Fault report"; },
        formDescription1: function(d) { return "Report a fault concerning your apartment or the shared and general areas of your building. The fault report is intended for non-urgent repairs and maintenance actions. In urgent cases (e.g., water damage), call your building's maintenance company immediately."; },
        formDescription2: function(d) { return "Maintenance work is carried out on weekdays between 8 AM and 4 PM."; },
        title: function(d) { return "Title"; },
        defectClass: function(d) { return "Type of fault"; },
        class: {
          hvac: function(d) { return "HVAC"; },
          electrical: function(d) { return "Electrical"; },
          locks: function(d) { return "Locks"; },
          repair: function(d) { return "Repair"; },
          other: function(d) { return "Other"; }
        },
        affectedArea: function(d) { return "Affected area"; },
        apartment: function(d) { return "Apartment"; },
        courtyard: function(d) { return "Courtyard"; },
        publicSpaces: function(d) { return "Public spaces"; },
        description: function(d) { return "Describe the fault"; },
        descriptionPlaceholder: function(d) { return "Describe where the fault or problem is located and how it appears."; },
        hasPetsInApartment: function(d) { return "Pets in the apartment"; },
        masterKeyAccessAllowed: function(d) { return "Access to the apartment is allowed with the master key for maintenance work"; },
        petsDescription: function(d) { return "Additional information about pets"; },
        addImage: function(d) { return "Add image"; },
        error: {
          tooManyFiles: function(d) { return "The maximum number of files allowed is " + d.maxFiles + "."; }
        },
        submitted: function(d) { return "Fault report has been submitted to your building's maintenance company. Non-urgent maintenance work is carried out on weekdays between 8 AM and 4 PM."; }
      },
      terminateLease: {
        title: function(d) { return "Termination of Contract"; },
        apartment: function(d) { return "Apartment"; },
        addressDescription: function(d) { return "You are terminating the lease for"; },
        addressDescription2: function(d) { return "Please note the following:"; },
        addressDescription3: function(d) { return "If the lease has multiple contractual tenants, all tenants must approve the termination before Y-Säätiö or M2-Kodit can process the form."; },
        addressDescription4: function(d) { return "If one of the tenants will remain in the apartment, include their name and date of birth in the Additional Details field."; },
        addressDescription5: function(d) { return "By default, the lease ends on the last day of the calendar month. If you prefer a different end date, specify it in the Additional Details field."; },
        description: function(d) { return "Fill in the information below. Fields marked with an asterisk are required."; },
        movingOutDate: function(d) { return "Moving-out date"; },
        terminationReason: function(d) { return "Primary reason for termination"; },
        endDate: function(d) { return "Contract end date"; },
        givingContactInfoAllowed: function(d) { return "My contact details may be given to a person interested in the apartment for the purpose of a viewing. The contact details will be given to only one applicant at a time."; },
        masterKeyAccessAllowed: function(d) { return "Access with master key allowed for apartment viewing and inspection purposes. We will be in contact before visiting the apartment."; },
        display: function(d) { return "Apartment viewing"; },
        additionalDetails: function(d) { return "Additional details"; },
        additionalDetailsLabel: function(d) { return "If there are multiple tenants and one will remain in the apartment, enter that person’s name and date of birth below. If you would like the contract to end on a different date, please specify your preferred end date here."; },
        hasPetsInApartment: function(d) { return "Pets in apartment"; },
        newAddress: {
          title: function(d) { return "New address"; },
          recipientName: function(d) { return "Recipient name"; },
          streetAddress: function(d) { return "Street address"; },
          postalCode: function(d) { return "Postal code"; },
          city: function(d) { return "City"; }
        },
        apartment_size: function(d) { return "Apartment size"; },
        area_poor_services: function(d) { return "Poor area services or public transit options"; },
        buying_property: function(d) { return "Purchase of own home"; },
        disturbing_neighbours_or_building: function(d) { return "Disturbing neighbours / disturbance in the building"; },
        family_size_change: function(d) { return "Family size change"; },
        housing_costs: function(d) { return "Rental cost"; },
        move_due_work: function(d) { return "Move due to work or studies"; },
        move_to_another_apartment_of_same_owner: function(d) { return "Move to another Y-Säätiö or M2-Kodit apartment"; },
        move_to_another_municipality: function(d) { return "Move to another municipality"; },
        move_to_care_home_or_hospital: function(d) { return "Move to care home or hospital"; },
        move_to_right_of_occupancy: function(d) { return "Move to right of occupancy apartment"; },
        poor_apartment_condition: function(d) { return "Poor apartment condition"; },
        poor_apartment_equipment_or_properties: function(d) { return "Poor apartment equipment or properties"; },
        poor_property_condition: function(d) { return "Poor property condition"; },
        poor_property_maintenance: function(d) { return "Poor property maintenance"; },
        poor_transportation_options: function(d) { return "Poor transportation options"; },
        beneficiary: function(d) { return "Bank details for the refund of the deposit"; },
        depositInfo: function(d) { return "The security deposit will be refunded approximately one month after the end of the lease."; },
        addNewBeneficiary: function(d) { return "Add beneficiary"; },
        removeBeneficiary: function(d) { return "Remove beneficiary"; },
        beneficiaries: {
          beneficiaryName: function(d) { return "Account holder"; },
          email: function(d) { return "Email address"; },
          phoneNumber: function(d) { return "Phone number"; },
          iban: function(d) { return "Bank account in IBAN format"; },
          bic: function(d) { return "BIC code"; }
        },
        send: function(d) { return "Submit"; },
        noticeInReview: function(d) { return "Termination of your lease is being reviewed by Y-Säätiö."; },
        tenantApprovalRequired: function(d) { return "Termination of your lease has been saved and is awaiting your approval."; },
        awaitingOtherTenantApproval: function(d) { return "Termination of your lease is awaiting approval from other tenants."; },
        noticeApproved: function(d) { return "Termination of your lease has been confirmed."; },
        acceptNotice: function(d) { return "Confirm termination of lease"; },
        rejectNotice: function(d) { return "Reject termination of lease"; }
      }
    },
    "resident-activity": {
      title: function(d) { return "Resident activity"; }
    },
    maintenance: {
      financial: {
        generic: function(d) { return "Rental and payment information is currently not available in the OmaM2 service and is not available through customer service. We are working to make the information available as soon as possible."; },
        paymentPage: function(d) { return "Rent payment is currently not possible through the OmaM2 service. Please pay the rent through your online bank for the time being."; },
        rentCard: function(d) { return "Rent payment information is currently not available."; }
      }
    },
    termination: {
      title: function(d) { return "Termination of Lease Agreement"; },
      description: function(d) { return "Here you can terminate your rental apartment agreement with Y-Säätiö and M2-Kodit. Y-Säätiö and M2-Kodit are part of the Y-Säätiö group."; },
      description2: function(d) { return "Termination requires strong authentication via bank credentials or mobile certificate from all contractual residents."; },
      residents: {
        title: function(d) { return "Residents in the apartment"; },
        withContract: function(d) { return "Contractual residents"; },
        other: function(d) { return "Other residents"; }
      },
      instructions: {
        title: function(d) { return "How to terminate a rental agreement with Y-Säätiö and M2-Kodit"; },
        step1: {
          title: function(d) { return "Logging into the service"; },
          description: function(d) { return "All parties to the contract must create credentials for the termination service before completing the termination form. M2-Kodit residents can log in using their OmaM2 service credentials."; }
        },
        step2: {
          title: function(d) { return "Approval from all parties"; },
          description: function(d) { return "If the lease agreement is in the names of multiple people, all parties must approve the termination before it can be processed by Y-Foundation or M2-Kodit."; },
          description1: function(d) { return "If the lease agreement has multiple contractual tenants, only one tenant can fill the form. The other tenants must wait until the form is submitted before they can proceed."; },
          description2: function(d) { return "After submitting the form, the other tenants may proceed to accept the termination. The termination will then be processed by Y-Säätiö or M2-Kodit."; }
        },
        step3: {
          title: function(d) { return "Termination by another party"; },
          description: function(d) { return "If only one tenant terminates the agreement and the other remains, please record this information in the form’s additional details."; }
        },
        step4: {
          title: function(d) { return "Termination notice period"; },
          description: function(d) { return "The notice period for termination is at least one calendar month. The notice period is calculated from the end of the termination month."; }
        },
        step5: {
          title: function(d) { return "Vacating and cleaning the apartment"; },
          description: function(d) { return "Upon termination, the tenant gives permission for the apartment to be vacated and items disposed of after the agreement ends, if the apartment has not been vacated and cleaned by the tenant by the agreement's end date."; }
        }
      },
      "continue": function(d) { return "Continue"; },
      instructionsRead: function(d) { return "I have read and understood the termination instructions."; },
      kenno_termination_disallowed_reason: {
        contract_terminated: function(d) { return "Contract has already been terminated."; },
        pending_termination_tenant_approvals: function(d) { return "Another party has sent termination form, please continue in order to confirm termination of lease."; },
        pending_termination_review: function(d) { return "Termination is in review."; },
        is_estate_contract: function(d) { return "Can not make termination request due to apartment type."; },
        has_guardian_of_interests: function(d) { return "Can not process termination request due to contract having guardian of interest."; },
        missing_resident_users: function(d) { return "Can not make termination request due to other contacr party has not created account for the service."; },
        not_contract_party: function(d) { return "Can not make termination request due to sender not being a contract party."; },
        tenants_with_undetermined_age: function(d) { return "Contract has underage tenants, could not process termination request."; },
        has_company_tenant: function(d) { return "Can not make termination request due to contract having company ownership."; },
        pending_modification_request: function(d) { return "Can not make termination request due to contract change request being in process."; },
        general: function(d) { return "Unable to process termination request"; },
        help: function(d) { return "Please try again later or contact customer support"; }
      }
    },
    admin: {
      impersonation: {
        title: function(d) { return "Sign in"; },
        form: {
          email: function(d) { return "Employee email "; },
          ssn: function(d) { return "Tenant SSN"; },
          targetTenantId: function(d) { return "Tenant identifier number"; }
        },
        signIn: function(d) { return "Sign in"; },
        systemNotification: function(d) { return "You are signed in as an admin viewing a tenant's profile. Please note that you cannot make any changes on behalf of the tenant."; }
      }
    },
    input: {
      showPassword: function(d) { return "Show password"; },
      hidePassword: function(d) { return "Hide password"; },
      addAttachment: function(d) { return "Add attachment"; },
      dropdown: {
        monthOption: function(d) { return d.amount + " months"; },
        choose: function(d) { return "Choose"; },
        repeatOptions: {
          never: function(d) { return "Never"; },
          weekly: function(d) { return "Weekly"; },
          biweekly: function(d) { return "Biweekly"; },
          monthly: function(d) { return "Monthly"; },
          yearly: function(d) { return "Yearly"; }
        }
      }
    },
    pagination: {
      previousPage: function(d) { return "Previous page"; },
      nextPage: function(d) { return "Next page"; },
      pageNumber: function(d) { return "Page " + d.page; }
    },
    time: {
      clock: function(d) { return "at"; }
    },
    months: {
      january: function(d) { return "January"; },
      february: function(d) { return "February"; },
      march: function(d) { return "March"; },
      april: function(d) { return "April"; },
      may: function(d) { return "May"; },
      june: function(d) { return "June"; },
      july: function(d) { return "July"; },
      august: function(d) { return "August"; },
      september: function(d) { return "September"; },
      october: function(d) { return "October"; },
      november: function(d) { return "November"; },
      december: function(d) { return "December"; }
    }
  },
  fi: {
    common: {
      back: function(d) { return "Takaisin"; },
      print: function(d) { return "Tulosta"; },
      readMore: function(d) { return "Lue lisää"; },
      signOut: function(d) { return "Kirjaudu ulos"; },
      yes: function(d) { return "Kyllä"; },
      no: function(d) { return "Ei"; }
    },
    navigation: {
      m2koditLink: function(d) { return "Siirry M2-Kotien sivulle"; },
      omaM2Link: function(d) { return "Siirry OmaM2-kotisivulle"; },
      home: {
        title: function(d) { return "Etusivu"; }
      },
      apartment: {
        title: function(d) { return "Oma asumiseni"; },
        agreement: function(d) { return "Vuokrasopimukseni"; },
        billing: function(d) { return "Vuokra- ja maksutietoni"; },
        change: function(d) { return "Asunnon­vaihto"; },
        watermeter: function(d) { return "Veden kulutus ja laskutus"; },
        termination: function(d) { return "Vuokrasopimuksen irtisanominen"; },
        bookingsCalendar: function(d) { return "Varaukseni"; },
        messages: function(d) { return "Vikailmoitukseni"; },
        forms: function(d) { return "Lomakkeita"; }
      },
      housing: {
        title: function(d) { return "Taloni"; },
        myhousing: function(d) { return "Taloni tiedot"; },
        news: function(d) { return "Tiedotteet"; },
        safety: function(d) { return "Turvallisuus ja pelastautuminen"; },
        laundry: function(d) { return "Talopesula"; },
        ownhouse: function(d) { return "Oma talo"; },
        storage: function(d) { return "Varastointi ja säilytys"; },
        internet: function(d) { return "Nettiyhteys"; },
        rentSummary: function(d) { return "Vuokran muodostuminen"; },
        bookingsCalendar: function(d) { return "Varaukseni"; },
        manuals: function(d) { return "Ohjeet ja dokumentit"; }
      },
      living: {
        title: function(d) { return "Asuminen M2-Kodeilla"; },
        benefits: function(d) { return "Asukasedut"; },
        events: function(d) { return "Asukastapahtumat"; },
        activities: function(d) { return "Asukastoiminta"; }
      },
      work: {
        title: function(d) { return "Töitä asukkaille"; }
      },
      m2homes: {
        title: function(d) { return "M2-Kodit"; },
        about: function(d) { return "Tietoa M2-Kodeista"; },
        sustainability: function(d) { return "Vastuullisuus M2-Kodeilla"; }
      },
      messages: {
        title: function(d) { return "Vikailmoitukseni"; }
      },
      profileAlt: {
        title: function(d) { return "Omat tiedot"; }
      },
      signout: {
        title: function(d) { return "Kirjaudu ulos"; }
      },
      profileMain: {
        title: function(d) { return "Omat tiedot"; }
      },
      profileMenu: {
        forms: function(d) { return "Omat lomakkeet"; }
      },
      finnish: function(d) { return "Suomeksi"; },
      english: function(d) { return "In English"; }
    },
    faultformbulletin: {
      title: function(d) { return "Kotonasi saattaa vielä olla jotain viimeistelemättä. Jos näin on, pahoittelemme!"; },
      description: function(d) { return "Kotiisi on toimitettu paperinen Takuutarkastuskysely. Paperisen lomakkeen sijaan, voit ilmoittaa asunnossa mahdollisesti havaitsemistasi vioista ja puutteista alle avautuvalla sähköisellä lomakkeella. Tiedot ohjautuvat rakentajalle, joka huolehtii, että viimeistelyä vaativat asiat tulevat hoidetuiksi."; },
      description2: function(d) { return "Palauta lomake, vaikka puutteita ei olisikaan. Lomake on täytettävissä kaksi viikkoa vuokrasopimuksen voimaanastumispäivästä."; },
      open: function(d) { return "Avaa Takuutarkastuskysely"; },
      close: function(d) { return "Sulje Takuutarkastuskysely"; }
    },
    moveinnotice: {
      description: function(d) { return "Uusi kotitalosi valmistuu " + d.startDate + " mennessä. Täydennämme Kodin kansioiden sisältöä sitä mukaa kun saamme urakoitsijoilta tarvittavia materiaaleja. Tavoitteemme on, että kaikki sisältö on käytettävissäsi viimeistään muuttopäivänä."; }
    },
    wordpress: {
      errorpage: {
        title: function(d) { return "Sivua ei löydetty!"; },
        post: function(d) { return "Ole hyvä ja lataa sivu uudelleen tai yritä myöhemmin!"; }
      }
    },
    search: {
      queryplaceholder: function(d) { return "Hae sivustolta"; },
      buttontext: function(d) { return "Hae"; },
      title: function(d) { return "Hakutulokset"; },
      resultsummary: function(d) { return "Haulla " + d.query + " " + plural(d.resultCount, 0, fi, { "0": "ei löytynyt yhtään osumaa.", "1": "löytyi yksi osuma.", other: "löytyi " + number(d.resultCount, "resultCount") + " osumaa." }); },
      apartment: {
        title: function(d) { return "Vuokrasopimukseni"; },
        description: function(d) { return "Vuokrasopimuksesi tiedot"; }
      },
      billing: {
        title: function(d) { return "Vuokra- ja maksutietoni"; },
        description: function(d) { return "Tarkastele vuokra- ja maksutietojasi."; }
      },
      change: {
        title: function(d) { return "Asunnon­vaihto"; },
        description: function(d) { return "Voit hakea vaihtoasuntoa vapautuvista M2-Kotien asunnoista, kun asunnonvaihdolle on perusteltu tarve. Tällaisia voivat olla esimerkiksi perhekoon tai taloudellisen tilanteen muutos tai terveydellinen syy."; }
      },
      contact: {
        title: function(d) { return "Yhteyden­otto"; },
        description: function(d) { return "Lähetä viesti asiakaspalveluumme alla olevalla lomakkeella. Vastaamme sinulle sähköpostitse mahdollisimman pian."; }
      },
      contactinformation: {
        title: function(d) { return "Yhteystiedot"; },
        description: function(d) { return "Tietoa talosi yhteystiedoista."; }
      },
      fault: {
        title: function(d) { return "Vikailmoitus"; },
        description: function(d) { return "Ilmoita asuntoasi tai talon yhteisiä tiloja koskevasta kiireettömästä viasta."; }
      },
      internet: {
        title: function(d) { return "Netti"; },
        description: function(d) { return "Tietoa taloyhtiön netistä."; }
      },
      laundry: {
        title: function(d) { return "Talopesula"; },
        description: function(d) { return "Tietoa taloyhtiön pesutuvasta, varauksista ja käytöstä."; }
      },
      manuals: {
        title: function(d) { return "Ohjeet ja dokumentit"; },
        description: function(d) { return "Selaa asunnon ohjeita ja dokumentteja."; }
      },
      news: {
        title: function(d) { return "Tiedotteet"; },
        description: function(d) { return "Selaa taloyhtiösi tiedotteita."; }
      },
      parking: {
        title: function(d) { return "Asukaspysäköinti"; },
        description: function(d) { return "Tietoa taloyhtiösi asukaspysäköinnistä."; }
      },
      safety: {
        title: function(d) { return "Turvallisuus ja pelastautuminen"; },
        description: function(d) { return "Tietoa taloyhtiösi turvallisuudesta ja pelastautumisesta."; }
      },
      sauna: {
        title: function(d) { return "Saunavuorot"; },
        description: function(d) { return "Tietoa taloyhtiösi saunasta, saunavuoroista ja varauksista."; }
      },
      storage: {
        title: function(d) { return "Varastointi"; },
        description: function(d) { return "Tietoa taloyhtiösi varastoinnista."; }
      }
    },
    home: {
      title: function(d) { return "Tervetuloa OmaM2-palveluun!"; },
      description: function(d) { return "OmaM2-palvelussa voit kätevästi hoitaa asumiseesi liittyviä asioita."; },
      address: {
        title: function(d) { return "Osoite"; }
      },
      contact: {
        title: function(d) { return "Ota yhteyttä"; },
        intro: function(d) { return "Lähetä viesti asiakaspalveluumme alla olevalla lomakkeella. Vastaamme sinulle sähköpostitse mahdollisimman pian."; },
        email: function(d) { return "Sähköpostiosoite"; },
        phone: function(d) { return "Puhelinnumero"; },
        subject: function(d) { return "Aihe"; },
        header: function(d) { return "Otsikko"; },
        desc: function(d) { return "Viesti"; },
        send: function(d) { return "Lähetä"; }
      },
      residentpricelist: function(d) { return "Asukaslaskuhinnasto"; },
      hello: function(d) { return "Hei"; },
      grid: {
        bookings: {
          title: function(d) { return "Tulevat varaukset"; },
          secondary_action: {
            label: function(d) { return "Varauskalenteriin"; }
          }
        },
        contact: {
          title: function(d) { return "Ota yhteyttä"; },
          action: {
            label: function(d) { return "Lähetä viesti"; }
          },
          customer_service: function(d) { return "Asiakaspalvelu"; },
          customer_service_active: function(d) { return "Arkisin klo " + d.hour_range; },
          maintenance: function(d) { return "Huoltoyhtiö"; },
          manager: function(d) { return "Isännöitsijä"; }
        },
        events: {
          title: function(d) { return "Talon tapahtumat"; },
          action: {
            label: function(d) { return "Katso kaikki"; }
          }
        },
        events_for_all: {
          title: function(d) { return "Yleiset asukastapahtumat"; },
          action: {
            label: function(d) { return "Katso kaikki"; }
          }
        },
        rent: {
          title: function(d) { return "Kuluva maksukausi"; },
          action: {
            label: function(d) { return "Maksa"; }
          },
          action2: {
            label: function(d) { return "Vuokra- ja maksutietoni"; }
          },
          monthly_rent: function(d) { return "Vuokra"; },
          debt_negative: function(d) { return "Maksettu ennakkoon"; },
          total_to_pay: function(d) { return "Maksettavaa jäljellä yht."; },
          total_paid: function(d) { return "Maksettu ennakkoon yht."; },
          due_date_label: function(d) { return "Eräpäivä"; },
          paid_in_advance: function(d) { return "Olet maksanut ennakkoon/liikaa"; },
          loadfailure: function(d) { return "Maksutietojen lataaminen epäonnistui. Yritä myöhemmin uudelleen."; },
          payment_delay_description: function(d) { return "Maksusuorituksien näkyminen OmaM2-palvelussa kestää noin 3-5 pankkipäivää."; }
        },
        debt: {
          title: function(d) { return "Vuokravelka"; },
          action: {
            label: function(d) { return "Velkaerittely"; }
          },
          unpaid: {
            label: function(d) { return "Erääntynyttä maksettavaa yht."; }
          },
          payment_delay_description: function(d) { return "Jos maksoit jo, tieto näkyy OmaM2-palvelussa 3-5 pankkipäivässä."; },
          loadfailure: function(d) { return "Velkatietojen lataaminen epäonnistui. Yritä myöhemmin uudelleen."; }
        },
        news: {
          title: function(d) { return "Uutiset"; },
          action: {
            label: function(d) { return "Katso kaikki"; }
          },
          readmore: function(d) { return "Lue lisää"; }
        },
        faults: {
          title: function(d) { return "Vikailmoitukset"; },
          action: {
            label: function(d) { return "Katso kaikki"; }
          },
          secondary_action: {
            label: function(d) { return "Tee vikailmoitus"; }
          }
        }
      }
    },
    links: {
      fault: function(d) { return "Ilmoita viasta"; },
      agreement: function(d) { return "Tarkastele sopimustasi"; },
      messages: function(d) { return "Ota yhteyttä"; },
      payments: function(d) { return "Vuokranmaksu"; },
      terminate: function(d) { return "Irtisano sopimuksesi"; },
      exchange: function(d) { return "Vaihda asuntoa"; }
    },
    linkshome: {
      parking: {
        title: function(d) { return "Tietoa pysäköinnistä"; },
        description: function(d) { return "Tietoa taloyhtiösi asukaspysäköinnistä"; }
      },
      sauna: {
        title: function(d) { return "Tietoa saunavuoroista"; },
        description: function(d) { return "Tietoa taloyhtiösi saunasta, saunavuoroista ja varauksista"; }
      },
      laundry: {
        title: function(d) { return "Tietoa talopesulasta"; },
        description: function(d) { return "Tietoa taloyhtiön talopesulasta, varauksista ja käytöstä"; }
      },
      fault: {
        title: function(d) { return "Vikailmoitus"; },
        description: function(d) { return "Ilmoita asuntoasi tai talon yhteisiä tiloja koskevasta kiireettömästä viasta."; }
      },
      disorder: {
        title: function(d) { return "Häiriöt ja tiedotteet"; },
        description: function(d) { return "Metelöinti, lemmikkien aiheuttamat häiriöt, tupakointi"; }
      },
      forms: {
        title: function(d) { return "Lomakkeet"; },
        description: function(d) { return "Erilaisia lomakkeita kuten esimerkiksi valtakirja tai avaintenluovutussopimus"; }
      },
      change: {
        title: function(d) { return "Asunnon­vaihto"; },
        description: function(d) { return "Voit hakea vaihtoasuntoa vapautuvista M2-Kotien asunnoista, kun asunnonvaihdolle on perusteltu tarve. Tällaisia voivat olla esimerkiksi perhekoon tai taloudellisen tilanteen muutos tai terveydellinen syy."; },
        linktext: function(d) { return "Vaihda asuntoa"; }
      },
      billing: {
        linktext: function(d) { return "Maksa vuokra"; }
      },
      urgent: {
        title: function(d) { return "Ilmoita viasta"; },
        description: function(d) { return "Soita heti huoltoyhtiöösi, jos huomaat talossasi tai asunnossasi kiireellisesti korjattavan vian. Heti korjattavia vikoja ovat esimerkiksi vesivuoto tai muut viat, jotka vaarantavat asumista."; },
        linktext: function(d) { return "Ilmoita viasta"; },
        contactbutton: function(d) { return "Katso huolto­yhtiösi yhteys­tiedot"; }
      },
      contact: {
        title: function(d) { return "Yhteyden­otto"; },
        description: function(d) { return "Lähetä viesti asiakaspalveluumme alla olevalla lomakkeella. Vastaamme sinulle sähköpostitse mahdollisimman pian."; },
        linktext: function(d) { return "Ota yhteyttä"; }
      }
    },
    warning: {
      debt: function(d) { return "Sinulla on erääntynyttä maksettavaa"; },
      conditional: function(d) { return "Jos olet jo suorittanut maksusi, tämä huomautus on aiheeton."; },
      proceedings: function(d) { return "Velka on siirtynyt oikeudelliseen perintään. Otathan heti yhteyttä vuokravalvontaan puh. 09 7742 5513, puhelinaika ma–pe klo 9–15."; },
      distraint: function(d) { return "Koko velka tai osa velasta on perinnässä ulosottovirastossa. Ulosottovirastossa perinnässä olevaa velkaa ei voi maksaa M2-Kotien tilille. Otathan heti yhteyttä vuokravalvontaan, niin saat ohjeet velan maksamiselle. Vuokravalvonta puh. 09 7742 5513, puhelinaika ma–pe klo 9–15."; },
      close: function(d) { return "Sulje"; },
      uuras: {
        text: function(d) { return "Lisätienestiä Uuras-työllistymisohjelman kautta."; },
        linktext: function(d) { return "Lue lisää."; }
      },
      gotopayment: function(d) { return "Siirry maksamaan"; }
    },
    apartment: {
      title: function(d) { return "Asuntoni tiedot"; }
    },
    change: {
      title: function(d) { return "Asunnonvaihto"; },
      description: function(d) { return "Jos elämäntilanteesi muuttuu, voit hakea asunnon vaihtoa toiseen M2-Kotien asuntoon kahdella tapaa"; },
      alternative1: function(d) { return "1. Asukkaiden tekemän keskinäisen vaihdon kautta"; },
      alt1description: function(d) { return "Nykyiset M2-Kotien asukkaat voivat sopia vaihtavansa nykyisiä koteja keskenään. Vaihtoehto on toimiva silloin kun tarvitset esim. itse pienemmän kodin ja toinen M2-Kotien asukas puolestaan suuremman kodin. Lue lisää..."; },
      alternative2: function(d) { return "2. Jättämällä kokonaan uuden asuntohakemuksen M2-Kodeille"; },
      alt2description: function(d) { return "Hae uutta kotia kaikkien vapaiden tai vapautumassa olevien M2-Kotien joukosta. Lue lisää..."; },
      apartmentchangelink: function(d) { return "https://hakemus.tampuuri.fi/m2kodit/"; },
      descriptiontitle2: function(d) { return "Keskinäinen asunnonvaihto"; },
      changeinstructionslink: function(d) { return "http://m2kodit.fi/asukkaalle/asunnon-vaihto/"; },
      descriptioncontact: function(d) { return "Selaa asunnonvaihtoilmoituksia tai jätä oma ilmoituksesi asunnonvaihtotoiveesta. Keskinäisessä asunnonvaihdossa asukkaat etsivät sopivan vaihtoasunnon itse. Jos sopiva vaihtopari löytyy, pyydä vaihtoa lähettämällä M2-Kodeille viesti osoitteeseen"; },
      descriptionmakechangelinktext: function(d) { return "kodit@ysaatio.fi"; },
      descriptionmakechangelinkhref: function(d) { return "kodit@ysaatio.fi"; },
      descriptionmakechangeend: function(d) { return "."; },
      descriptioninstructionslinktext: function(d) { return "Katso ohjeet keskinäiseen asunnon vaihtoon."; },
      descriptiontitle3: function(d) { return "Asunnon vaihto M2-Kotien kautta"; },
      searchvacantapartments: function(d) { return "Selaa vaihtoasuntoja vapautuvien M2-Kotien asuntojen joukosta"; },
      searchvacantlink: function(d) { return "https://asunnot.m2kodit.fi"; },
      and: function(d) { return "ja"; },
      fillapartmentform: function(d) { return "täytä asuntohakemus."; },
      fillapartmentformlink: function(d) { return "https://hakemus.tampuuri.fi/m2kodit/?_ga=2.31850682.540683483.1587125277-1894718168.1581421105"; },
      description3content: function(d) { return "Voit hakea vaihtoasuntoa vapautuvista M2-Kotien asunnoista, kun asunnonvaihdolle on perusteltu tarve. Tällaisia voivat olla esimerkiksi perhekoon tai taloudellisen tilanteen muutos tai terveydellinen syy."; },
      enlistedapartments: function(d) { return "Vaihtoon ilmoitetut asunnot"; },
      instructions: {
        title: function(d) { return "Ohje asunnonvaihtajalle"; }
      },
      instructions1: {
        text: function(d) { return "Asuntojen vaihtaminen keskenään on mahdollista. Kun olet löytänyt sopivan vaihtoasunnon, ota suoraan yhteyttä ilmoituksen jättäneeseen asukkaaseen."; },
        text2: function(d) { return "Sovi asuntonäyttö suoraan vaihtokumppanin kanssa. Jos sopiva vaihtokumppani löytyy, olkaa yhteydessä asiasta M2-Kodeille osoitteeseen"; },
        textlink: function(d) { return "kodit@ysaatio.fi"; },
        textend: function(d) { return "."; },
        text3: function(d) { return "M2-Kodit käsittelee keskinäisen asunnonvaihdon ARAn ohjeiden mukaisesti. Samalla katsotaan nykyisen vuokrasuhteen maksu- ja asumishistoria sekä tarkistetaan luottotiedot. Mahdolliset luottotietomerkinnät vaikuttavat uuden vuokra-asunnon vakuuden määrään. Vaihto voidaan suorittaa, kun vaihdon edellytykset täyttyvät. \nIrtisano nykyisen asuntosi vuokrasopimus vasta, kun halutun vaihtoasunnon saaminen on vahvistettu. Keskinäisissä vaihdoissa M2-Kodit ei tee erillisiä muuttotarkastuksia."; }
      },
      instructions2: {
        title: function(d) { return "Vaihtoilmoituksen tekeminen"; },
        text: function(d) { return "Ilmoita asuntosi vaihtoon OmaM2-palvelun lomakkeella. Ilmoitus käsitellään ja julkaistaan palvelussa, jos vaihto on mahdollinen. Huomio, että ilmoittaessasi asuntosi vaihtoon, asuntosi tiedot, omat yhteystietosi ja ilmoitusteksti julkaistaan kaikkien OmaM2-palvelun käyttäjien nähtäväksi. \nIlmoituksesi on näkyvissä kuusi kuukautta tai kunnes poistat sen. Jos vaihdat asuntoa tai lopetat palvelun käytön, ilmoitus poistuu automaattisesti."; }
      },
      adsent: function(d) { return "Ilmoituksesi on lähetetty tarkistettavaksi!"; },
      gotonewad: function(d) { return "Tee asunnonvaihtoilmoitus"; },
      allcities: function(d) { return "Kaikki kaupungit"; },
      emptyadlist: function(d) { return "Ei asunnonvaihtoilmoituksia"; },
      close: function(d) { return "Sulje"; },
      ad: {
        current: {
          title: function(d) { return "Asukkaan kertomaa vaihtoon ilmoittamastaan kodista"; }
        },
        desired: {
          title: function(d) { return "Tällaista kotia etsin vaihdossa"; }
        },
        buildingtitle: function(d) { return "Vaihdettavan asunnon tiedot"; },
        name: function(d) { return "Ilmoittajan nimi"; },
        phone: function(d) { return "Puhelinnumero"; },
        email: function(d) { return "Sähköposti"; },
        address: function(d) { return "Kotiosoite"; },
        description: function(d) { return "Kerro millaista asuntoa etsit ja milloin haluaisit muuttaa. Ilmoitusteksti julkaistaan vaihtoilmoituksesi yhteydessä."; },
        newtitle: function(d) { return "Tee asunnonvaihtoilmoitus"; },
        newdescstart: function(d) { return "Ilmoittaessasi asuntosi vaihtoon, asuntosi tiedot, yhteystietosi ja ilmoitusteksti julkaistaan tässä palvelussa."; },
        newdesclinktext: function(d) { return "Katso ohjeet asunnon vaihtoon"; },
        newdescend: function(d) { return "."; },
        publish: function(d) { return "Lähetä"; },
        status: {
          published: function(d) { return "Julkaistu: " + d.published; },
          "new": function(d) { return "Odottaa hyväksyntää"; },
          deleted: function(d) { return "Poistettu"; }
        },
        icontext: function(d) { return "Vaihtoilmoitus"; },
        removebtn: function(d) { return "Poista"; },
        housinginfobtn: function(d) { return "Katso talon esittely"; },
        rooms: function(d) { return "Huoneistotyyppi"; },
        squares: function(d) { return "Pinta-ala"; },
        lease: function(d) { return "Vuokra"; },
        water: function(d) { return "Vesiennakko"; },
        buildingtype: function(d) { return "Rakennustyyppi"; },
        year: function(d) { return "Valmistumisvuosi"; },
        apartments: function(d) { return "Asuntoja"; },
        floors: function(d) { return "Asuinkerroksia"; },
        elevator: function(d) { return "Hissi"; },
        yes: function(d) { return "Kyllä"; },
        no: function(d) { return "Ei"; }
      },
      disabled: function(d) { return "Sinulla on voimassa oleva vaihtoilmoitus. Jos haluat luoda uuden ilmoituksen, poista ensin vanha."; },
      swap: {
        label: function(d) { return "Vaihto"; },
        title: function(d) { return "Vaihtoehto 1 – M2-Kodin asukkaiden keskinäinen asunnonvaihto"; },
        description: function(d) { return "Jokainen M2-Kotien asukas voi ilmoittaa halukkuudesta vaihtaa kotia keskenään toisen M2-Kodin asukkaan kanssa. Kun valitset tämän vaihtoehdon, toimi näin:"; },
        step1: function(d) { return "Tutustu alla näkyviin asunnonvaihtajaehdokkaiden asuntoihin ja katso löytyisikö niistä sinua kiinnostava koti (Jos alla ei näy asuntoja, ei tällä hetkellä kukaan asukas ole ilmoittanut kotiaan keskinäiseen asunnonvaihtoon. Voit käydä tarkistamassa ilmoitustilanne uudestaan aina kun haluat.)"; },
        step2: function(d) { return "Kun löydät alta sopivan kodin, ole yhteydessä suoraa asukkaaseen, joka ilmoituksen on jättänyt ja sovi hänen kanssaan tutustumisesta asuntoon. Asuntoon tutustuminen sovitaan aina asukkaiden kesken."; },
        step3: function(d) { return "Kun löydät kumppanin asunnonvaihtoon, lähettäkää viestiä vaihtohalukkuudesta osoitteeseen: kodit@ysaatio.fi"; },
        step4: function(d) { return "Tarkastamme hakijoiden luottotiedot, asumis- ja maksuhistorian ja käsittelemme asukkaiden keskinäisen asunnonvaihdon ARAn ohjeiden mukaisesti. Mahdolliset luottotietomerkinnät vaikuttavat uuden vuokra-asunnon vakuuden määrään."; },
        step5: function(d) { return "Mikäli ehdot täyttyvät, voidaan keskinäinen asunnonvaihto toteuttaa."; },
        notice: function(d) { return "Huom! Älä irtisano nykyistä asuntoasi ennen kuin saat keskinäinen asunnonvaihto on vahvistettu M2-Kotien puolelta. M2-Kodit ei tee muuttotarkastuksia kun muutto toteutuu asukkaiden keskinäisen asunnonvaihdon kautta."; },
        instructionlink: function(d) { return "Haluatko ilmoittaa oman nykyisen kotisi asukkaiden keskinäiseen asunnonvaihtoon?"; },
        link: function(d) { return "Klikkaa tästä ohjeisiin."; },
        newtitle: function(d) { return "Tee asunnonvaihtoilmoitus"; },
        newswapinfo1: function(d) { return "Nykyisen M2-kotisi tiedot tulevat ilmoitukseen automaattisesti. Tiedot ovat: huoneistotyyppi, pinta-ala, vuokra, vesiennakko (myös tieto, jos huoneistossa on oma vedenkulutuksen mittaus), rakennustyyppi, valmistumisvuosi, asuntojen lukumäärä ja asuinkerrosten määrä."; },
        newswapinfo2: function(d) { return "Huomioi, että kaikki ilmoitukseen kirjoittamasi tieto julkaistaan. Älä siis kirjoita mitään sellaista, mitä et halua muiden asukkaiden näkevän. Älä esim. koskaan kirjoita henkilötunnustasi ilmoitukseen. Asuntoosi liittyvät tiedot ja yhteystietosi julkaistaan osana asunnonvaihtoilmoitusta."; },
        newswapinfo3: function(d) { return "Vain ilmoitukset, joissa keskinäinen vaihto on asukastietojen mukaan mahdollista, julkaistaan. Ilmoituksesi on voimassa kolme (3) kuukautta, tai kunnes poistat sen. Jos muutat pois, asunnonvaihtoilmoituksesi poistuu automaattisesti."; },
        currentapttitle: function(d) { return "Lisätietoja vaihtoon ilmoittamastasi kodista."; },
        currentaptplaceholder: function(d) { return "Tässä voit mainostaa kotiasi. Kerro miksi vaihtaja innostuisi muuttamaan nykyiseen kotiisi. Kuuluuko siihen esim. parveke, löytyykö läheltä koirapuisto, vai ehkä jotain muuta? Teksti julkaistaan asunnonvaihtoilmoituksessasi."; },
        desiredapttitle: function(d) { return "Millaista kotia etsit vaihdossa?"; },
        desiredaptplaceholder: function(d) { return "Kirjoita tähän millaista kotia etsit, mihin ja milloin haluaisit muuttaa. Ilmoitusteksti julkaistaan asunnonvaihtoilmoituksessasi, asunto- ja talotietojen lisäksi."; },
        termscheckbox: function(d) { return "Olen ymmärtänyt, että nykyisen asuntoni tiedot ja omat kontaktitietoni julkaistaan osana asunnonvaihtoilmoitusta. Myös yllä oleviin tekstikenttiin kirjoittamani tieto julkaistaan ilmoituksessa kaikkien OmaM2-palvelun käyttäjien näkyviin."; },
        send: function(d) { return "Lähetä"; },
        backtotop: function(d) { return "Palaa sivun alkuun"; }
      },
      newapplication: {
        label: function(d) { return "Uusi hakemus"; },
        title: function(d) { return "Vaihtoehto 2 - Kokonaan uusi asuntohakemus M2-Kodeille"; },
        description: function(d) { return "Kun haluat hakea uutta asuntoa M2-Kotien kaikkien vapaiden tai vapautumassa olevien kotien joukosta, toimi näin:"; },
        step1: function(d) { return "Mene osoitteeseen"; },
        step2: function(d) { return "Kun löydät kodin/kodit, jotka sopisivat paremmin nykyiseen elämäntilanteeseesi, lisää ne hakemukselle ja lähetä hakemus sivuston ohjeiden mukaisesti."; },
        step3: function(d) { return "Käsittelemme hakemuksesi muiden hakemusten joukossa, ARA-ohjeiden mukaisesti."; },
        step4: function(d) { return "Mahdolliset luottotietomerkinnät vaikuttavat uuden vuokra-asunnon vakuuden määrään."; },
        notice: function(d) { return "Huomioi, että voit hakea uutta kotia vain, jos se on perusteltua, esim. perheen koko tai taloudellinen tilanne on muuttunut. Muutokset terveydentilassa voivat myös toimia perusteena uudelle kodille."; }
      }
    },
    watermeter: {
      title: function(d) { return "Veden kulutus ja laskutus"; },
      noexist: {
        description: function(d) { return "Asunnossa ei ole vesimittaria."; }
      }
    },
    housing: {
      title: function(d) { return "Taloni tiedot"; },
      update: {
        title: function(d) { return "Päivitämme talosi tietoja"; },
        description: function(d) { return "Tällä sivulla voit jatkossa tarkastella oman talosi perustietoja sekä lisätietoja talon yleisistä tiloista ja niiden käytöstä."; }
      },
      description: function(d) { return "OmaM2-palvelussa voit kätevästi hoitaa asumiseesi liittyviä asioita."; },
      basicinfo: {
        buildingtype: function(d) { return "Rakennustyyppi"; },
        year: function(d) { return "Valmistumisvuosi"; },
        apartmentcounts: function(d) { return "Asuntoja"; },
        floors: function(d) { return "Asuinkerroksia"; },
        elevator: function(d) { return "Hissi"; }
      },
      basicInfo: {
        amount: function(d) { return "kpl"; },
        energyClass: function(d) { return "Energialuokka"; }
      },
      housefeat: {
        title: function(d) { return "Talon yleiset tilat"; },
        laundryroom: function(d) { return "Talopesula"; },
        dryingroom: function(d) { return "Kuivaushuone"; },
        bikestorage: function(d) { return "Pyörävarasto"; },
        clubroom: function(d) { return "Kerhohuone"; },
        wasteroom: function(d) { return "Jätehuone"; },
        buildingsauna: function(d) { return "Talosauna"; },
        locker: function(d) { return "Pukuhuone"; },
        apartmentstorage: function(d) { return "Irtainvarastot"; },
        outdoorstorage: function(d) { return "Ulkoiluvälinevarasto"; },
        babycarriage: function(d) { return "Lastenvaunuvarasto"; },
        none: function(d) { return "Ei tietoa"; },
        book: function(d) { return "Varaa"; }
      },
      altText: {
        tenantBuilding: function(d) { return "Asuinrakennuksesi ja sen pihapiiri"; }
      },
      contacts: {
        title: function(d) { return "Yhteystiedot"; },
        manager: function(d) { return "Asiaa isännöitsijälle?"; },
        managerInfo: function(d) { return "Ota yhteyttä isännöitsijään talosi hallinnollisissa asioissa."; },
        descriptionLeft: function(d) { return "M2-Kodeilla isännöintiin liittyvissä kysymyksissä auttaa ensisijaisesti osaava asiakaspalvelumme. Asiakaspalvelumme yhteystiedot löytyvät vasemmalta."; },
        descriptionAbove: function(d) { return "M2-Kodeilla isännöintiin liittyvissä kysymyksissä auttaa ensisijaisesti osaava asiakaspalvelumme. Asiakaspalvelumme yhteystiedot löytyvät yläpuolelta."; },
        maintenance: function(d) { return "Huoltoyhtiö"; },
        maintenanceNotFound: function(d) { return "Huoltoyhtiön tiedot eivät ole tällä hetkellä saatavilla. Tarkista tiedot rapun ilmoitustaululta."; },
        maintenanceInfo: function(d) { return "Ota yhteyttä huoltoyhtiöön, jos tarvitset huolto- ja korjaustöitä asunnossasi tai yhteisissä tiloissa."; },
        callMaintenance: function(d) { return "Soita huoltoyhtiöön"; },
        customerservice: function(d) { return "Asiakaspalvelu"; },
        customerserviceopen: function(d) { return "Arkisin klo 9-15"; },
        customerservicename: function(d) { return "M2-Kodit"; },
        email: {
          customerservice: {
            aria: function(d) { return "Avaa oletuksena olevan sähköposti-sovelluksen valmiina lähettämään viestin M2-Kotien asiakaspalveluun."; }
          }
        },
        phone: {
          customerservice: {
            aria: function(d) { return "Avaa puhelin-sovelluksen valmiina soittamaan M2-Kotien asiakaspalveluun."; }
          },
          maintenance: {
            aria: function(d) { return "Avaa puhelin-sovelluksen valmiina soittamaan huoltoyhtiösi asiakaspalveluun."; }
          }
        },
        emergencyphone: {
          maintenance: {
            aria: function(d) { return "Avaa puhelin-sovelluksen valmiina soittamaan huoltoyhtiösi päivystysnumeroon."; }
          }
        },
        customerserviceInfo: function(d) { return "Puhelu maksaa operaattorisi määrittelemän hinnan."; },
        emergency: function(d) { return "Päivystys"; },
        phonenumber: function(d) { return "puh."; },
        urgentRequest: function(d) { return "Kiireellinen huoltopyyntö"; },
        urgentRequestInfo: function(d) { return "Soita heti huoltoyhtiöösi, jos huomaat talossasi tai asunnossasi kiireellisesti korjattavan vian, kuten vesivuodon tai muun sellaisen vian, joka vaarantaa asumista. Huoltoyhtiösi yhteystiedot löydät alta."; },
        temporaryUrgentRequestInfo: function(d) { return "Soita heti huoltoyhtiöösi, jos huomaat talossasi tai asunnossasi kiireellisesti korjattavan vian, kuten vesivuodon tai muun sellaisen vian, joka vaarantaa asumista."; },
        nonurgentRequest: function(d) { return "Kiireetön huoltopyyntö"; },
        nonurgentRequestInfo: function(d) { return "Ilmoita kiireettömistä vioista täyttämällä vikailmoitus verkossa. Kiireettömät viat ovat sellaisia, jotka eivät vaaranna asumista."; }
      },
      briefings: {
        title: function(d) { return "Tiedotteet"; }
      },
      showall: {
        placeholder: function(d) { return "Näytä kaikki"; }
      },
      documents: {
        title: function(d) { return "Dokumentit"; }
      },
      instructions: {
        title: function(d) { return "Ladattavat ohjeet"; }
      },
      emergencyplan: {
        title: function(d) { return "Talon pelastussuunnitelma"; },
        documentname: function(d) { return "Pelastussuunnitelma"; }
      },
      noexist: {
        emergencyplan: function(d) { return "Pelastussuunnitelma tulossa."; },
        briefings: function(d) { return "Ei tiedotteita."; },
        documents: function(d) { return "Ei dokumentteja."; },
        residentpricelist: function(d) { return "Ei asukaslaskuhinnastoja."; },
        instructions: function(d) { return "Alla tärkeimmät yhteystiedot arjen tilanteiden hoitamiseen kanssamme. Voit halutessasi lähettää meille yhteydenottopyynnön myös täältä OmaM2-palvelun kautta. Klikkaa lomakkeeseen"; },
        instructionsLink: function(d) { return "tästä."; },
        laundry: function(d) { return "Kotitalossasi ei ole asukkaiden käyttöön varattua talopesulaa. "; }
      },
      moreInfo: function(d) { return "Lisätiedot"; },
      sauna: {
        label: function(d) { return "Sauna"; },
        title: function(d) { return "Saunavuorot"; }
      },
      yes: function(d) { return "Kyllä"; },
      no: function(d) { return "Ei"; },
      open: function(d) { return "Avaa"; },
      readmore: function(d) { return "Lue lisää"; },
      booking: {
        moreInfo: function(d) { return "Tutustu ja varaa"; }
      },
      safety: {
        title: function(d) { return "Turvallisuus"; },
        download: function(d) { return "Pelastussuunnitelma, Safetum"; },
        rules: function(d) { return "Järjestyssäännöt"; }
      },
      parking: {
        title: function(d) { return "Pysäköinti"; },
        header: function(d) { return "Asukaspysäköinti"; }
      },
      ownhouse: {
        title: function(d) { return "Oma talo"; }
      },
      notices: {
        title: function(d) { return "Tiedotteet"; }
      },
      reportFault: function(d) { return "Tee vikailmoitus"; },
      events: {
        title: function(d) { return "Tapahtumat"; }
      },
      latestnews: {
        title: function(d) { return "Talokohtaiset tiedotteet"; }
      },
      externalnews: {
        title: function(d) { return "m2kodit.fi-uutiset"; }
      },
      laundry: {
        title: function(d) { return "Talopesula"; }
      },
      internet: {
        title: function(d) { return "Nettiyhteys"; },
        "no-internet": function(d) { return "Ei nettiyhteyttä"; },
        dna: function(d) { return "50 Mbit/s Laajakaista, DNA"; },
        "dna-ethernet": function(d) { return "50 Mbit/s Ethernet, DNA"; },
        "dna-cabelmodem": function(d) { return "50 Mbit/s Kaapelimodeemi, DNA"; },
        elisa: function(d) { return "50 Mbit/s Ethernet, Elisa"; }
      },
      storage: {
        title: function(d) { return "Varastointi ja säilytys"; }
      },
      maintenanceCompany: function(d) { return "Kiinteistöhuolto"; },
      rentSummary: {
        title: function(d) { return "Vuokran muodostuminen"; }
      }
    },
    bookings: {
      calendar: {
        title: function(d) { return "Varaukseni"; },
        pincode: function(d) { return "Pin-koodisi:"; },
        userManual: function(d) { return "One4all Mobile käyttöohje"; },
        noexist: function(d) { return "Varauskalenteria ei löydetty!"; },
        navigate: function(d) { return "Varauskalenteriin"; }
      },
      list: {
        upcoming: function(d) { return "Tulevat varaukset"; },
        noexist: function(d) { return "Sinulla ei ole voimassa olevia varauksia."; },
        link: function(d) { return "Varauskalenteriin"; },
        showall: function(d) { return "Näytä kaikki"; }
      }
    },
    profile: {
      title: function(d) { return "Päivitä omat tietosi"; },
      description: function(d) { return "Tarkista, että yhteystietosi ovat ajan tasalla."; },
      contactinfoheader: function(d) { return "Yhteystiedot"; },
      phone: function(d) { return "Puhelinnumero"; },
      phonerequired: function(d) { return "Anna puhelinnumero"; },
      phoneinvalid: function(d) { return "Tarkista puhelinnumero"; },
      email: function(d) { return "Sähköpostiosoite"; },
      emailrequired: function(d) { return "Anna sähköpostiosoite"; },
      emailinvalid: function(d) { return "Tarkista sähköpostiosoite"; },
      save: function(d) { return "Tallenna"; },
      savesuccess: function(d) { return "Kiitos, tiedot on tallennettu!"; },
      error: function(d) { return "Jokin meni pieleen. Yritä uudelleen."; },
      newsletter: function(d) { return "Tilaa M2-Kotien uutiskirje!"; },
      newsletterSubtitle: function(d) { return "Saat ajankohtaista tietoa M2-Kotien asunnoista, asukkaan palveluista ja asukastoiminnasta."; },
      newsletterBtn: function(d) { return "Tilaa uutiskirje"; },
      protectionOrder: function(d) { return "Turvakielto"; },
      protectionOrderText: function(d) { return "Sinulle on asetettu turvakielto."; }
    },
    ownForms: {
      title: function(d) { return "Omat lomakkeet"; },
      description: function(d) { return "Löydät tallentamasi lomakkeet täältä."; },
      table: {
        name: function(d) { return "Nimi"; },
        state: function(d) { return "Tila"; },
        updated: function(d) { return "Muokattu"; }
      },
      update: function(d) { return "Muokkaa"; },
      noForms: function(d) { return "Ei tallennettuja dokumentteja"; },
      state: {
        Draft: function(d) { return "Luonnos"; },
        Published: function(d) { return "Julkaistu"; },
        AwaitingApproval: function(d) { return "Käsittelyssä"; },
        Rejected: function(d) { return "Hylätty"; },
        Approved: function(d) { return "Hyväksytty"; }
      }
    },
    footer: {
      housing: {
        defaultcontact: function(d) { return "Yhteystiedot"; },
        contact: function(d) { return "Talosi yhteystiedot"; },
        manager: function(d) { return "Isännöitsijä"; },
        maintenance: function(d) { return "Huoltoyhtiö"; },
        customerservice: {
          title: function(d) { return "Asiakaspalvelu"; },
          name: function(d) { return "M2-Kodit"; },
          phone: function(d) { return "09 7742 5500"; },
          email: function(d) { return "m2.asiakaspalvelu@ysaatio.fi"; }
        },
        myhousing: function(d) { return "Tiedot"; },
        news: function(d) { return "Ajankohtaista"; },
        safety: function(d) { return "Turvallisuus ja pelastautuminen"; },
        parking: function(d) { return "Pysäköinti"; },
        laundry: function(d) { return "Talopesula"; },
        sauna: function(d) { return "Saunavuorot"; },
        internet: function(d) { return "Nettiyhteys"; }
      },
      externalLinks: {
        facebook: function(d) { return "Seuraa meitä Facebookissa"; },
        instagram: function(d) { return "Seuraa Instagramissa"; }
      },
      copyright: function(d) { return "© 2024 M2-Kodit"; },
      dataprotection: function(d) { return "Tietosuoja"; },
      terms: function(d) { return "Käyttöehdot ja henkilötietosuoja"; },
      linkbutton: function(d) { return "Katso yhteystiedot"; },
      text: function(d) { return "OmaM2 on asukkaiden palvelu, jossa voi hoitaa asumiseen liittyviä asioita kellonajasta riippumatta; maksaa vuokran, tehdä vikailmoituksen, lähettää viestiä M2-asiakaspalveluun, lukea lisää sauna- tai talopesulavuorojen varauskäytännöistä, tarkastaa huoltoyhtiön tai asiakaspalvelun yhteystiedot."; },
      contact: {
        description: function(d) { return "Lähetä viesti asiakaspalveluumme alla olevalla lomakkeella. Vastaamme sinulle sähköpostitse mahdollisimman pian."; },
        button: function(d) { return "Ota yhteyttä"; }
      },
      titles: {
        omam2: function(d) { return "OmaM2"; },
        apartment: function(d) { return "Oma asumiseni"; },
        housing: function(d) { return "Taloni"; },
        fault: {
          reports: function(d) { return "Vikailmoitukseni"; }
        },
        contact: function(d) { return "Yhteydenotto"; }
      },
      apartment: {
        contract: function(d) { return "Vuokrasopimukseni"; },
        billing: function(d) { return "Vuokra- ja maksutietoni"; },
        maintenance: function(d) { return "Ohjeet ja dokumentit"; },
        apartmentchange: function(d) { return "Asunnonvaihto"; },
        watermeter: function(d) { return "Veden kulutus ja laskutus"; },
        bookingsCalendar: function(d) { return "Varaukseni"; }
      }
    },
    signin: {
      title: function(d) { return "Tervetuloa OmaM2-palveluun"; },
      step1: {
        descriptionTitle: function(d) { return "OmaM2 on M2-Kotien asukassivusto, jossa voit hoitaa asumiseen liittyviä asioita. Palvelussa voit mm."; },
        descriptionItems: function(d) { return "katsoa vuokra- ja maksutietojasi \ntehdä vikailmoituksen \n ilmoittautua kaikille avoimiin asukastapahtumiin \n pyörittää talosi asukastoimikuntaa \n ottaa meihin yhteyttä."; },
        authdescription: function(d) { return "Luo tunnukset, jos käytät palvelua ensimmäistä kertaa. Tunnuksien luominen edellyttää vahvaa tunnistautumista, käytössäsi olevaa sähköpostiosoitetta sekä voimassa olevaa vuokrasopimusta."; },
        placeholder: function(d) { return "Anna puhelinnumerosi"; },
        label: function(d) { return "Puhelinnumerosi"; },
        error: function(d) { return "Tarkista puhelinnumero"; },
        forbidden: function(d) { return "Käyttäjää ei löytynyt. Ota tarvittaessa yhteys M2-Kotien asiakaspalveluun puh. 09 7742 5500 tai m2.asiakaspalvelu@ysaatio.fi."; },
        "continue": function(d) { return "Jatka"; }
      },
      step2: {
        description: function(d) { return "Kirjoita tekstiviestinä saamasi kertakäyttöinen kirjautumiskoodi, niin pääset kirjautumaan asukassivuillesi."; },
        placeholder: function(d) { return "Syötä koodi"; },
        label: function(d) { return "Kirjautumiskoodi"; },
        error: function(d) { return "Tarkista kirjautumiskoodi"; },
        back: function(d) { return "Anna puhelinnumero uudestaan"; },
        doSignIn: function(d) { return "Kirjaudu"; },
        acceptservice: function(d) { return "Hyväksyn palvelun"; },
        termsofuse: function(d) { return "käyttöehdot."; }
      },
      step3: {
        description: function(d) { return "Seuraavaksi vahvistamme henkilöllisyytesi pankkitunnuksilla tai mobiilivarmenteella."; },
        error: function(d) { return "Tunnistautumisessa tapahtui virhe, ole hyvä ja yritä uudelleen."; },
        forbidden: function(d) { return "Käyttäjää ei löytynyt. Ota tarvittaessa yhteys M2-Kotien asiakaspalveluun puh. 09 7742 5500 tai m2.asiakaspalvelu@ysaatio.fi."; },
        "continue": function(d) { return "Siirry tunnistautumaan"; }
      },
      step4: {
        title: function(d) { return "Päivitä yhteystietosi"; },
        description: function(d) { return "Tarkista, että yhteystietosi ovat ajan tasalla."; },
        phoneplaceholder: function(d) { return "Puhelinnumero"; },
        phonerequired: function(d) { return "Anna puhelinnumero"; },
        phoneinvalid: function(d) { return "Tarkista puhelinnumero"; },
        emailplaceholder: function(d) { return "Sähköpostiosoite"; },
        noemail: function(d) { return "Minulla ei ole sähköpostia."; },
        emailrequired: function(d) { return "Anna sähköpostiosoite"; },
        emailinvalid: function(d) { return "Tarkista sähköpostiosoite"; },
        save: function(d) { return "Tallenna"; }
      },
      redirectToM2: function(d) { return "< Takaisin m2kodit.fi-etusivulle"; },
      cancel: function(d) { return "Peruuta"; },
      toRegistration: function(d) { return "Rekisteröidy"; },
      email: function(d) { return "Sähköpostiosoite"; },
      username: function(d) { return "Sähköpostiosoite"; },
      password: function(d) { return "Salasana"; },
      submit: {
        button: function(d) { return "Kirjaudu"; }
      },
      send: {
        button: function(d) { return "Lähetä"; }
      },
      forgotPassword: function(d) { return "Unohtuiko salasanasi?"; },
      forgotPasswordInfo: function(d) { return "Syötä sähköpostiosoitteesi, niin lähetämme sinulle koodin salasanan uusimista varten."; },
      forgotPasswordError: function(d) { return "Linkin lähetys epäonnistui. Yritä uudelleen."; },
      setNewPassword: function(d) { return "Aseta uusi salasana"; },
      setNewPasswordInfo: function(d) { return "Syötä sähköpostitse saamasi koodi ja aseta uusi salasana."; },
      save: function(d) { return "Tallenna"; },
      newCode: function(d) { return "Uusi koodi"; },
      newPasswordSaved: function(d) { return "Uusi salasana tallennettu"; },
      continueToLogin: function(d) { return "Jatka kirjautumiseen"; },
      error: {
        incorrectCredentials: function(d) { return "Kirjautuminen epäonnistui: Väärä käyttäjätunnus tai salasana."; },
        contractNotStarted: function(d) { return "Kirjautuminen epäonnistui, koska sopimuksesi ei ole vielä alkanut. Pääset kirjautumaan " + d.startDate + ", kun sopimuksesi alkaa."; },
        contractExpired: function(d) { return "Kirjautuminen epäonnistui, koska sopimuksesi päättymisestä on kulunut yli 30 päivää."; },
        contractNotFound: function(d) { return "Virhe kirjautumisessa. Vuokrasopimusta ei löytynyt."; },
        general: function(d) { return "Kirjautuminen epäonnistui. Yritä hetken kuluttua uudelleen."; }
      },
      oneTimePassword: {
        title: function(d) { return "Vahvista tunnuksesi"; },
        instructions: function(d) { return "Melkein perillä! Kirjoita vielä sähköpostiisi saamasi kertakäyttöinen koodi vahvistaaksesi tunnuksesi, minkä jälkeen sinut ohjataan OmaM2-palveluun. Etkö saanut koodia? Tarkista roskapostikansio tai"; },
        instructionsLink: function(d) { return "tilaa uusi koodi tästä."; },
        code: function(d) { return "Koodi"; },
        submit: function(d) { return "Lähetä"; },
        cancel: function(d) { return "Peruuta"; },
        generalError: function(d) { return "Jokin meni pieleen. Tarkista koodi ja yritä uudelleen."; },
        codeSent: function(d) { return "Uusi koodi lähetetty"; },
        codeSendFailed: function(d) { return "Uutta koodia ei juuri nyt voitu lähettää. Ole hyvä ja yritä myöhemmin uudelleen."; }
      }
    },
    ysaatio: {
      signin: {
        title: function(d) { return "Kirjaudu sisään"; },
        description: function(d) { return "Kirjaudu sisään aiemmin luomilla tunnuksillasi. Jos olet M2-Kotien asukas, voit kirjautua sisään OmaM2-palvelun tunnuksillasi."; }
      },
      signup: {
        title: function(d) { return "Vuokrasopimuksen irtisanominen"; },
        instructions1: function(d) { return "Luo tunnukset tai kirjaudu sisään irtisanoaksesi Y-Säätiön tai M2-Kotien vuokra-asunnon vuokrasopimuksen tai hyväksyäksesi toisen sopimusosapuolen tekemän irtisanomisilmoituksen. Y-Säätiö ja M2-Kodit kuuluvat Y-Säätiö -konserniin."; },
        instructions2: function(d) { return "Jos olet M2-Kotien asukas, voit kirjautua sisään käyttämällä OmaM2-palvelun tunnuksiasi."; },
        instructions3: function(d) { return "Täällä pääset myös näkemään irtisanomisilmoituksen tilan. "; },
        instructionsListTitle: function(d) { return "Tunnusten luominen on kolmivaiheista:"; },
        instructionsList1: function(d) { return "Tunnistaudu vahvalla tunnistautumisella. "; },
        instructionsList2: function(d) { return "Syötä sähköposti ja salasana. "; },
        instructionsList3: function(d) { return "Syötä sähköpostiisi tullut vahvistuskoodi. "; },
        "continue": function(d) { return "Luo tunnukset"; },
        toSignIn: function(d) { return "Kirjaudu sisään"; },
        credentials: {
          title: function(d) { return "Syötä sähköpostiosoite ja salasana"; },
          description: function(d) { return "Syötä käytössäsi oleva sähköpostiosoite ja luo salasana.  "; },
          afterPasswordDescription: function(d) { return "Tarkistathan kirjoitusasun olevan varmasti oikein ennen kuin jatkat eteenpäin."; }
        },
        code: {
          title: function(d) { return "Viimeistele tunnusten luonti"; },
          description: function(d) { return "Viimeistele tunnusten luonti syöttämällä sähköpostiisi lähetetty kertakäyttöinen koodi. Koodin lähettämisessä voi mennä muutama minuutti. Muista tarkistaa myös roskapostikansiosi."; }
        },
        success: {
          title: function(d) { return "Rekisteröinti onnistui"; },
          description: function(d) { return "Sinut ohjataan seuraavaksi irtisanomisen lomakkeelle. Voit myöhemmin kirjautua samoilla tunnuksilla tarkistaaksesi sopimuksesi irtisanomisen tilan."; },
          button: function(d) { return "Jatka "; }
        }
      }
    },
    validation: {
      signin: {
        username: function(d) { return "Sähköpostiosoite on vaadittu."; },
        password: function(d) { return "Salasana on vaadittu."; },
        email: function(d) { return "Syötä sähköpostiosoite."; }
      },
      signup: {
        termsAccepted: function(d) { return "Hyväksy käyttöehdot jatkaaksesi vahvaan tunnistautumiseen."; },
        username: function(d) { return "Sähköpostiosoite on vaadittu."; },
        password: function(d) { return "Salasanan on täytettävä alla kuvatut vaatimukset."; },
        confirmPassword: function(d) { return "Salasanojen on täsmättävä."; },
        code: function(d) { return "Virheellinen koodi. Tarkista koodi ja yritä uudelleen."; }
      },
      forms: {
        contact: {
          subject: function(d) { return "Otsikko on vaadittu"; },
          content: function(d) { return "Viesti on vaadittu"; },
          subcategory: function(d) { return "Valitse tarkempi aihe"; }
        },
        meetingMinutes: {
          name: function(d) { return "Kokouksen nimi on vaadittu"; },
          date: function(d) { return "Kokouksen päivämäärä on vaadittu"; },
          time: function(d) { return "Kokouksen kellonaika on vaadittu"; },
          location: function(d) { return "Kokouksen paikka on vaadittu"; },
          participants: function(d) { return "Vähintään kaksi osallistujaa on vaadittu"; },
          items: {
            title: function(d) { return "Otsikko on vaadittu"; },
            text: function(d) { return "Teksti on vaadittu"; }
          },
          chairperson: function(d) { return "Täytä etunimi ja sukunimi"; },
          secretary: function(d) { return "Täytä etunimi ja sukunimi"; },
          signatoryConfirmation: function(d) { return "Sinun on vahvistettava olevasi allekirjoittanut henkilö"; }
        },
        actionPlan: {
          activities: {
            name: function(d) { return "Tapahtuman nimi on vaadittu"; },
            month: function(d) { return "Tapahtuman kuukausi on vaadittu"; },
            responsiblePersons: function(d) { return "Vastuuhenkilöt pitää olla lueteltuna"; }
          }
        },
        actionReport: {
          activities: {
            name: function(d) { return "Tapahtuman nimi on vaadittu"; },
            month: function(d) { return "Tapahtuman kuukausi on vaadittu"; },
            day: function(d) { return "Tapahtuman päivä on vaadittu"; },
            additionalInformation: function(d) { return "Lisätiedot on vaadittu"; }
          }
        },
        generalExpenseReport: {
          contactInfo: {
            name: function(d) { return "Nimi on vaadittu"; },
            address: function(d) { return "Osoite on vaadittu"; },
            zip: function(d) { return "Postinumero on vaadittu"; },
            city: function(d) { return "Kaupunki on vaadittu"; },
            phone: function(d) { return "Puhelinnumero on vaadittu"; },
            email: function(d) { return "Sähköposti on vaadittu"; },
            iban: function(d) { return "Tilinumero IBAN-muodossa on vaadittu"; }
          },
          event: {
            name: function(d) { return "Tilaisuuden nimi on vaadittu"; },
            date: function(d) { return "Tilaisuuden päivämäärä on vaadittu"; }
          },
          purchaseReports: {
            report: function(d) { return "Selvitys hankinnasta on vaadittu"; },
            amount: function(d) { return "Hankinnan summa on vaadittu"; }
          }
        },
        travelExpenseReport: {
          contactInfo: {
            name: function(d) { return "Nimi on vaadittu"; },
            address: function(d) { return "Osoite on vaadittu"; },
            zip: function(d) { return "Postinumero on vaadittu"; },
            city: function(d) { return "Kaupunki on vaadittu"; },
            phone: function(d) { return "Puhelinnumero on vaadittu"; },
            email: function(d) { return "Sähköposti on vaadittu"; },
            iban: function(d) { return "Tilinumero IBAN-muodossa on vaadittu"; }
          },
          event: {
            name: function(d) { return "Tilaisuuden nimi on vaadittu"; },
            location: function(d) { return "Paikkakunta on vaadittu"; },
            travelRoute: function(d) { return "Matkareitti on vaadittu"; }
          },
          publicExpenseReports: {
            date: function(d) { return "Päivämäärä on vaadittu"; },
            time: function(d) { return "Kellonaika on vaadittu"; },
            amount: function(d) { return "Summa on vaadittu"; },
            vehicle: function(d) { return "Ajoneuvo on vaadittu"; }
          },
          ownCarExpenseReports: {
            date: function(d) { return "Päivämäärä on vaadittu"; },
            time: function(d) { return "Kellonaika on vaadittu"; },
            numberOfPeople: function(d) { return "Henkilömäärä on vaadittu"; },
            totalKm: function(d) { return "Kilometrien yhteismäärä on vaadittu"; }
          }
        },
        defectNotice: {
          title: function(d) { return "Otsikko on vaadittu"; },
          description: function(d) { return "Kuvaus on vaadittu"; },
          affectedArea: function(d) { return "Valitse vian sijainti"; },
          defectClass: function(d) { return "Valitse vian tyyppi"; }
        },
        terminateLease: {
          endDate: function(d) { return "Sopimuksen päättymispäivä on vaadittu."; },
          movingOutDate: function(d) { return "Poismuuttopäivän on oltava tämän päivän ja sopimuksen päättymispäivän välillä."; },
          terminationReason: function(d) { return "Valitse ensisijainen irtisanomisen syy."; },
          displayStartDate: function(d) { return "Asuntonäytölle sopiva ajankohta on vaadittu."; },
          displayEndDate: function(d) { return "Asuntonäytön päivämäärän on oltava ennen sopimuksen päättymispäivää."; },
          newAddress: {
            recipientName: function(d) { return "Vastaanottajan nimi on vaadittu."; },
            streetAddress: function(d) { return "Katuosoite on vaadittu."; },
            postalCode: function(d) { return "Postinumero on vaadittu."; },
            city: function(d) { return "Kaupunki on vaadittu."; }
          },
          beneficiaries: {
            beneficiaryName: function(d) { return "Tilinomistajan nimi on vaadittu."; },
            email: function(d) { return "Sähköpostiosoite on vaadittu."; },
            phoneNumber: function(d) { return "Puhelinnumero on vaadittu."; },
            iban: function(d) { return "Tilinumero IBAN-muodossa on vaadittu."; },
            bic: function(d) { return "BIC-koodi on vaadittu ulkomaisille pankkitileille."; }
          }
        }
      },
      termination: {
        instructionsRead: function(d) { return "Vahvista, että olet lukenut ja ymmärtänyt irtisanomisen ohjeet"; }
      }
    },
    signup: {
      title: function(d) { return "Rekisteröidy OmaM2-palveluun"; },
      instructions: function(d) { return "Pääset rekisteröitymään OmaM2-palveluun, kun sopimuksesi on alkanut. Tunnuksien luomista varten tarvitset toimivan sähköpostiosoitteen, johon sinulla on pääsy. Rekisteröityminen edellyttää vahvaa tunnistautumista verkkopankkitunnuksilla tai mobiilivarmenteella."; },
      instructions2: function(d) { return "Oletko jo rekisteröitynyt? Siirry kirjautumaan"; },
      alreadySignedupLink: function(d) { return "tästä"; },
      accept: function(d) { return "Hyväksyn palvelun"; },
      termsOfUse: function(d) { return "käyttöehdot"; },
      "continue": function(d) { return "Siirry tunnistautumaan"; },
      cancel: function(d) { return "Peruuta"; },
      createAccount: function(d) { return "Luo tunnukset OmaM2-palveluun"; },
      accountInstructions: function(d) { return "Rekisteröitymisen jälkeen voit kirjautua palveluun sähköpostiosoitteella ja salasanalla."; },
      username: function(d) { return "Sähköpostiosoite"; },
      password: function(d) { return "Salasana"; },
      passwordRequirements: function(d) { return "Salasanan täytyy olla vähintään 8 merkkiä pitkä ja sen tulee sisältää vähintään yksi iso kirjain, vähintään yksi pieni kirjain, vähintään yksi numero ja vähintään yksi erikoismerkki."; },
      confirmPassword: function(d) { return "Vahvista salasana"; },
      saveAndContinue: function(d) { return "Tallenna ja jatka"; },
      credentialsError: function(d) { return "Tunnuksien luominen epäonnistui. Yritä hetken kuluttua uudelleen."; },
      usernameError: function(d) { return "Tämä sähköposti ei ole käytettävissä."; },
      passwordError: function(d) { return "Salasana ei täyttänyt vaatimuksia."; },
      code: function(d) { return "Koodi"; },
      codeInstructions: function(d) { return "Kirjoita sähköpostitse saamasi kertakäyttöinen koodi, niin rekisteröitymisesi palveluun vahvistetaan."; },
      successStep: function(d) { return "Rekisteröityminen onnistui. Voit nyt kirjautua sisään OmaM2-palveluun"; },
      returnToLogin: function(d) { return "Kirjaudu sisään"; },
      generalError: function(d) { return "Jokin meni pieleen. Yritä uudelleen."; },
      invalidCodeError: function(d) { return "Virheellinen koodi. Tarkista sähköpostitse saamasi koodi ja yritä uudelleen."; },
      expiredCodeError: function(d) { return "Syöttämäsi koodi on vanhentunut. Tilaa uusi koodi ja yritä uudelleen."; },
      limitExceededError: function(d) { return "Liian monta virheellistä yritystä. Yritä hetken kuluttua uudelleen."; },
      signup: function(d) { return "Rekisteröidy"; }
    },
    feedback: {
      step1: {
        title: function(d) { return "Kirjauduit ulos OmaM2 -palvelusta."; },
        question: function(d) { return "Saitko hoidettua asiat, joita varten kirjauduit palveluun?"; },
        yes: function(d) { return "Kyllä"; },
        no: function(d) { return "Ei"; },
        placeholder: function(d) { return "Anna meille palautetta palvelun kehittämiseksi. Palautteet käsitellään anonyymisti."; },
        send: function(d) { return "Lähetä"; }
      },
      step2: {
        title: function(d) { return "Kiitos palautteestasi!"; },
        login: function(d) { return "Kirjaudu sisään"; }
      },
      redirectToM2: function(d) { return "< Takaisin m2kodit.fi-etusivulle"; }
    },
    messages: {
      "new": {
        title: function(d) { return "Asumiseen liittyvät kysymykset"; },
        desc: function(d) { return "Lähetä meille viesti alla olevalla lomakkeella."; },
        info: function(d) { return "Asiakaspalvelumme auttaa sinua kaikissa asumiseen ja vuokranmaksuun liittyvissä kysymyksissä sähköpostitse ja puhelimitse arkisin klo 9–15."; },
        choose: function(d) { return "Valitse aiheeksi"; },
        housing: {
          "": function(d) { return "jos asiasi koskee asumisen ongelmatilanteita (mm. asumistuen ja etuuksien hakeminen, oman talouden hallinta, naapurisopu, kodin puhtaanapito)"; },
          debtassistance: function(d) { return "Apua velkaantumistilanteessa"; },
          benefitapplication: function(d) { return "Etuuksien hakeminen (esim. asumistuki)"; },
          tooexpensive: function(d) { return "Liian kallis asunto"; },
          neighbourdispute: function(d) { return "Apua naapurikiistan ratkaisemiseen"; },
          evictionassistance: function(d) { return "Apua häätötilanteen selvittämiseen"; },
          dailyerrandsassistance: function(d) { return "Neuvoa arjen haasteellisuuteen"; },
          mentalhealthandsubstanceabuse: function(d) { return "Neuvontaa mielenterveys- tai päihdeasioissa"; }
        },
        billing: {
          "": function(d) { return "jos asiasi koskee vuokranmaksuun liittyviä asioita"; },
          latepayment: function(d) { return "Vuokranmaksun viivästyminen"; },
          paymentissues: function(d) { return "Vuokranmaksuvaikeudet"; },
          debtrepayment: function(d) { return "Vuokravelasta sopiminen"; }
        },
        customerservice: {
          "": function(d) { return "mikäli asiasi koskee muita asioita"; },
          apartmentapplications: function(d) { return "Asuntohakemus"; },
          sauna_laundry_parking: function(d) { return "Sauna-, talopesula- tai autopaikkavaraukset"; },
          contracttermination: function(d) { return "Asunnon irtisanominen/poismuutto"; },
          propertymanagement: function(d) { return "Isännöintiin liittyvät asiat"; },
          faultreports: function(d) { return "Vikailmoitus"; },
          other: function(d) { return "Muut asiat"; }
        },
        faultreportstart: function(d) { return "Vikailmoituksella"; },
        faultreport: function(d) { return "voit ilmoittaa huoneistoasi tai talosi yhteis- sekä yleistiloja koskevan vian tai haitan. Vikailmoitus on tarkoitettu kiireettömiin korjaus- ja huoltotoimenpiteisiin. Kiireellisissä tapauksissa soita"; },
        faultreportlink: function(d) { return "talosi kiinteistöhuoltoon."; },
        replysoon: function(d) { return "Vastaamme yhteydenottopyyntöösi sähköpostitse mahdollisimman pian."; },
        form: {
          email: function(d) { return "Sähköposti"; },
          emailrequired: function(d) { return "Anna sähköpostiosoite"; },
          emailinvalid: function(d) { return "Tarkista sähköpostiosoite"; },
          phone: function(d) { return "Puhelinnumero"; },
          phonerequired: function(d) { return "Anna puhelinnumero"; },
          phoneinvalid: function(d) { return "Tarkista puhelinnumero"; },
          name: function(d) { return "Nimi"; },
          subjectrequired: function(d) { return "Anna otsikko"; },
          contentrequired: function(d) { return "Kirjoita viestisi"; },
          button: function(d) { return "Lähetä viesti"; },
          messagesent: function(d) { return "Viestisi on lähetetty!"; },
          messagefailure: function(d) { return "Viestin lähetys epäonnistui. Yritä hetken kuluttua uudelleen."; },
          categories: {
            "471": function(d) { return "Asiakaspalvelu"; },
            "473": function(d) { return "Vuokranmaksu"; },
            "859": function(d) { return "Asumisneuvonta"; },
            problemhouse: function(d) { return "Vikailmoitus talosta"; }
          }
        },
        instruction: {
          latepayment: function(d) { return "Jos haluat keskustella mahdollisuudesta maksaa vuokrasummaa pidemmällä aikavälillä, valitse 'Vuokravelasta sopiminen'. Jos kyseessä on vuokranmaksun viivästyminen muutamalla päivällä (enintään 3 päivää), jatka lomakkeen täyttämistä."; },
          sauna_laundry_parking: function(d) { return "Sauna-, talopesula- ja autopaikkavarauksiin liittyvissä asioissa ole yhteydessä"; },
          faultreports: function(d) { return "Vesi-, savu- tai palovahingoissa sekä toimimattoman kylmälaitteen osalta, soita välittömästi"; },
          toMaintenanceCompany: function(d) { return "huoltoyhtiöösi"; },
          faultreportsother: function(d) { return "Muissa vika-/huoltopyyntöasioissa"; },
          ariafaultreport: function(d) { return "Siirry vikailmoituslomakkeelle m2-kodit.fi sivulle (avaa uudelle välilehdelle)"; },
          scrolltomaintenance: function(d) { return "Siirry huoltoyhtiösi yhteystietoihin."; },
          linktofaultreport: function(d) { return "tee vikailmoitus"; },
          propertymanagement: function(d) { return "Viestisi ohjataan asiakaspalveluumme, joka ensisijaisesti auttaa isännöintiin liittyvissä kysymyksissä. Jos viestisi aihe on sellainen, että vain isännöitsijä voi auttaa, varmistaa asiakaspalvelu, että se tavoittaa kotitalosi isännöitsijän."; }
        }
      },
      title: function(d) { return "Vikailmoitukseni"; },
      maindescription: function(d) { return "Seuraa oman asuntosi ja talosi vikailmoituksia"; },
      description: function(d) { return "Asunnostasi sähköisella lomakkeella tehdyt vikailmoitukset"; },
      disclaimer1: function(d) { return "Jos olet tehnyt vikailmoituksia puhelimitse tai sähköpostilla, ne eivät näy OmaM2-palvelussa"; },
      deschousing: function(d) { return "Talostasi sähköisella lomakkeella tehdyt vikailmoitukset"; },
      disclaimer2: function(d) { return "Jos Talostasi on tehty vikailmoituksia puhelimitse tai sähköpostilla, ne eivät näy OmaM2-palvelussa"; },
      disclaimer3: function(d) { return "Huomaathan, että listassa näkyvät kaikki talosi yhteistiloja koskevat vikailmoitukset."; },
      emptylist: function(d) { return "Ei vikailmoituksia"; },
      subject: function(d) { return "Aihe"; },
      messageStatuses: {
        "0": function(d) { return "Vastaanotettu"; },
        "1": function(d) { return "Käsittelyssä"; },
        "2": function(d) { return "Valmis"; },
        Sent: function(d) { return "Vastaanotettu"; },
        InProgress: function(d) { return "Käsittelyssä"; },
        Ready: function(d) { return "Valmis"; }
      },
      showmore: function(d) { return "Näytä kaikki"; },
      newmessage: function(d) { return "Ilmoita viasta"; }
    },
    message: {
      success: {
        success: function(d) { return "Viesti lähetetty onnistuneesti!"; },
        description: function(d) { return "Sinut ohjataan takaisin etusivulle hetken kuluttua. Voit myös palata takaisin painamalla Etusivu-painiketta."; },
        button: function(d) { return "Etusivu"; }
      }
    },
    billing: {
      title: function(d) { return "Vuokra- ja maksutietoni"; },
      history: {
        title: function(d) { return "Maksuhistoria"; },
        period: function(d) { return "Maksukausi"; },
        billed: function(d) { return "Laskutettu"; },
        paid: function(d) { return "Suoritukset"; },
        duedate: function(d) { return "Eräpäivä"; },
        paiddate: function(d) { return "Maksupäivä"; },
        sum: function(d) { return "Yhteensä"; },
        advance: function(d) { return "jälkeen olit maksanut liikaa / ennakkoa"; },
        remaining: function(d) { return "jälkeen sinulla oli erääntynyttä maksettavaa"; },
        uptodate: function(d) { return "jälkeen maksusi olivat ajan tasalla"; },
        prevAdvance: function(d) { return "Edellisillä maksukausilla maksettu liikaa / ennakkoa"; },
        prevRemaining: function(d) { return "Edellisillä maksukausilla maksamatta jäänyt"; },
        prevUnknown: function(d) { return "Edellisiltä maksukausilta maksamatta jääneistä tai liikaa maksetuista summista ei ole tietoa"; }
      },
      description: function(d) { return "OmaM2-palvelu on uudistunut! Uudistuksen vuoksi näet maksutietosi täällä 1.4.2025 alkaen."; },
      description2: function(d) { return "Suorituksesi näkyy OmaM2-palvelussa ja M2-Kotien vuokravalvonnassa 3-5 pankkipäivän kuluessa. Huomioithan, että pyhiä ja arkipyhiä ei lasketa pankkipäiviksi."; },
      print: {
        description: function(d) { return "Vuokralaskusi maksutietoineen löydät alla olevasta painikkeesta."; },
        title: function(d) { return "Tulosta vuokralaskusi"; },
        parkingLot: function(d) { return "Tulosta autopaikkalaskusi"; },
        page: function(d) { return "Tulosta"; }
      },
      filter: {
        startdate: function(d) { return "Aloita tarkastelu kuukaudesta"; },
        enddate: function(d) { return "Lopeta tarkastelu kuukauteen"; },
        applyrange: function(d) { return "Näytä aikaväli"; },
        showall: function(d) { return "Näytä kaikki"; },
        showbilled: function(d) { return "Näytä laskut"; },
        showpaid: function(d) { return "Näytä suoritukset"; }
      },
      gotopayment: function(d) { return "Siirry maksamaan"; },
      payment: {
        title: function(d) { return "Maksa vuokra"; },
        description: function(d) { return "Onnistuneen maksutapahtuman jälkeen saat vahvistusviestin sähköpostiisi. Suorituksesi näkyy OmaM2-palvelussa ja M2-Kotien vuokravalvonnassa 3-5 pankkipäivän kuluessa."; },
        description2: function(d) { return "Voit maksaa joko koko maksun tai osan siitä. <b>HUOM! Aloita OmaM2-palvelussa maksaessasi aina uusi maksutapahtuma alta.</b> Aloita uusi maksutapahtuma, vaikka suoritus koskisikin aiempaa maksuerää. <b>Älä käytä OmaM2-palvelussa maksetun vanhan suorituksen maksutietoja.</b> "; },
        errorhelptext: function(d) { return "Maksaminen ei valitettavasti onnistu. Käytä verkkopankkiasi tai laskua maksamiseen."; },
        error: function(d) { return "Maksun luominen epäonnistui. Yritä hetken kuluttua uudelleen."; },
        subtitle1: function(d) { return "1. Anna maksettava summa"; },
        description1: function(d) { return "Sinulla on erääntynyttä maksettavaa"; },
        tobepaid: function(d) { return "Maksetaan"; },
        amounttoolow: function(d) { return "Maksettavan summan pitää olla vähintään 1 €"; },
        subtitle2: function(d) { return "2. Valitse maksutapa"; },
        paymentinfo: function(d) { return "Maksun tiedot"; },
        paymentreceiver: function(d) { return "Maksun saaja"; },
        paymentreceiver2: function(d) { return "Kiinteistö Oy M2-Kodit"; },
        referencenumber: function(d) { return "Viitenumero"; },
        sum: function(d) { return "Maksettava summa"; },
        gotopayment: function(d) { return "Siirry maksamaan"; },
        showbilling: function(d) { return "Näytä velkaerittely"; },
        paytrailinfo: function(d) { return "Maksupalvelumme on Paytrail. Huom! Omalla tiliotteellasi maksun saajana näkyy Paytrail Oyj ja maksun viitteenä eri viite. Näitä tili- ja viitetietoja ei pidä kopioida eikä käyttää enää uudelleen velan maksamiseen omassa verkkopankissa."; },
        success: function(d) { return "Maksusi on rekisteröity ja näkyy OmaM2-palvelussa 3-5 pankkipäivän kuluessa. Saat maksutapahtumasta vahvistusviestin sähköpostiisi."; },
        failure: function(d) { return "Maksutapahtuma on keskeytynyt."; },
        "continue": function(d) { return "Jatka"; },
        proceed: function(d) { return "[TRANSLATE ME] Proceed"; },
        recent: function(d) { return "Olet " + d.time + " maksanut " + d.amount + " €. Huomioithan, että suorituksesi näkyy OmaM2:ssa vasta kun pankkisuoritus on kirjautunut M2-Kotien vuokravalvontaan (vähintään kolme (3) pankkipäivää). Pyhiä ja arkipyhiä tai viikonloppuja ei lasketa pankkipäiviksi, jolloin suorituksen näkymiseen voi mennä useampi päivä."; }
      },
      current: {
        period: function(d) { return "Kuluva maksukausi"; },
        advance: function(d) { return "Tällä hetkellä olet maksanut liikaa / ennakkoa"; },
        remaining: function(d) { return "Tällä hetkellä sinulla on erääntynyttä maksettavaa"; },
        uptodate: function(d) { return "Tällä hetkellä maksusi ovat ajan tasalla"; }
      },
      itemized: function(d) { return "Näytä velkaerittely"; },
      months: {
        "0": function(d) { return "Tammikuu"; },
        "1": function(d) { return "Helmikuu"; },
        "2": function(d) { return "Maaliskuu"; },
        "3": function(d) { return "Huhtikuu"; },
        "4": function(d) { return "Toukokuu"; },
        "5": function(d) { return "Kesäkuu"; },
        "6": function(d) { return "Heinäkuu"; },
        "7": function(d) { return "Elokuu"; },
        "8": function(d) { return "Syyskuu"; },
        "9": function(d) { return "Lokakuu"; },
        "10": function(d) { return "Marraskuu"; },
        "11": function(d) { return "Joulukuu"; }
      },
      historyloadfailure: function(d) { return "Maksuhistorian lataus epäonnistui. Yritä myöhemmin uudelleen."; }
    },
    agreement: {
      title: function(d) { return "Vuokrasopimukseni"; },
      label: function(d) { return "Vuokrasopimus"; },
      subtitle: function(d) { return "Vuokrasopimuksesi tiedot"; },
      istemporary: function(d) { return "Määräaikainen"; },
      month: function(d) { return "kuukauden"; },
      personmonth: function(d) { return "/ hlö / kk"; },
      permonth: function(d) { return "/ kk"; },
      day: function(d) { return "päivä"; },
      last: function(d) { return "viimeinen"; },
      apartment: {
        title: function(d) { return "Huoneiston tiedot"; },
        address: function(d) { return "Osoite"; },
        type: function(d) { return "Asuntotyyppi"; },
        sqfoot: function(d) { return "Pinta-ala"; },
        sqfootFull: function(d) { return "Asunnon pinta-ala"; },
        houseowner: function(d) { return "Vuokranantaja"; }
      },
      tenants: {
        title: function(d) { return "Asukkaat"; },
        title2: function(d) { return "Vuokralaisen tiedot"; },
        contract: function(d) { return "Vuokralainen / Vuokralaiset"; },
        partiesUnavailable: function(d) { return "Muiden vuokralaisten/asukkaiden tiedot eivät ole tällä hetkellä saatavilla."; },
        other: function(d) { return "Muut asukkaat"; }
      },
      print: function(d) { return "Tulosta tiedot"; },
      download: function(d) { return "Lataa sopimusehdot"; },
      terminateTitle: function(d) { return "Vuokrasopimuksen irtisanominen"; },
      terminateInfo: function(d) { return "Sähköinen irtisanominen vaatii väliaikaisesti toisien tunnusten tekemistä järjestelmämuutoksen takia, kirjautumisen jälkeen löydät irtisanomislomakkeen."; },
      terminate: function(d) { return "Irtisano sopimus"; },
      lease: {
        title: function(d) { return "Vuokra ja vesimaksu"; },
        title2: function(d) { return "Vuokra ja vesimaksu"; },
        infoUnavailable: function(d) { return "Vuokran tiedot eivät ole tällä hetkellä saatavilla."; },
        price: function(d) { return "Vuokra"; },
        waterPrePayment: function(d) { return "Vesimaksuennakko"; },
        waterPerPerson: function(d) { return "Vesimaksu"; },
        waterPaymentUnavailable: function(d) { return "Vesimaksun tiedot eivät ole tällä hetkellä saatavilla."; },
        waterPerConsumption: function(d) { return "Vesimaksu kulutuksen mukaan"; },
        duedate: function(d) { return "Eräpäivä"; }
      },
      period: {
        title: function(d) { return "Vuokra-aika"; },
        type: function(d) { return "Sopimus"; },
        startdate: function(d) { return "Sopimus alkaa"; },
        enddate: function(d) { return "Sopimus päättyy"; },
        paiddeposit: function(d) { return "Maksettu vakuus"; }
      },
      deposit: {
        title: function(d) { return "Vakuusmaksu"; },
        moneyAmount: function(d) { return "Rahavakuus"; },
        voucher: function(d) { return "Maksusitoumus"; },
        info: function(d) { return "Vakuusmaksu palautetaan noin kuukauden kuluessa vuokrasuhteen päättymisestä, jos asunnon tarkastuksessa ei ole havaittu laskutettavia vahinkoja, kaikki avaimet on palautettu ja laskuja ei ole jäänyt maksamatta."; },
        infoUnavailable: function(d) { return "Vakuusmaksun tiedot eivät ole tällä hetkellä saatavilla."; },
        noDeposit: function(d) { return "Tällä sopimuksella ei ole vakuusmaksua."; }
      },
      history: {
        title: function(d) { return "Historia"; },
        text: function(d) { return "Vuokralaisena " + d.startDate + " alkaen"; }
      }
    },
    modal: {
      redirect: function(d) { return "Palveluun siirtyminen avaa uuden välilehden."; },
      "continue": function(d) { return "Jatka"; },
      cancel: function(d) { return "Peruuta"; },
      close: function(d) { return "Sulje"; }
    },
    onboarding: {
      welcome: function(d) { return "Tervetuloa"; },
      info1: function(d) { return "OmaM2 on M2-Kotien asukkaiden asiointisivusto.\n \nLue lisää klikkaamalla nuolia tai numeroita."; },
      uptodate: function(d) { return "Tiedot ajan tasalla"; },
      info2: function(d) { return "Päivitä yhteystietosi, katso talosi tietoja tai ota yhteyttä M2-Koteihin."; },
      rental: function(d) { return "Omat vuokratiedot"; },
      info3: function(d) { return "Vuokranmaksu -osiossa näet vuokranmaksutilanteesi yhdellä silmäyksellä. Voit myös tulostaa vuokralaskusi."; },
      developing: function(d) { return "OmaM2 kehittyy"; },
      info4: function(d) { return "Kehitämme OmaM2-palvelua jatkuvasti. Tulossa on uusia ominaisuuksia. Anna meille palautetta palvelusta uloskirjautumisen yhteydessä."; }
    },
    debt: {
      title: function(d) { return "Velkaerittely"; },
      description: function(d) { return "Velkaerittelystä näet maksamattomat laskut. Maksusuoritukset kohdistuvat aina vanhimpaan maksamattomaan laskuun. Voit myös tehdä maksusuunnitelmaehdotuksen M2-Kodeille."; },
      paytype: function(d) { return "Maksettavaa"; },
      rent: function(d) { return "Vuokra"; },
      collectioncharge: function(d) { return "Perintäkulu"; },
      penaltyinterest: function(d) { return "Viivästyskorko"; },
      saunapayment: function(d) { return "Saunamaksu"; },
      debtamount: function(d) { return "Velka"; },
      duedate: function(d) { return "Eräpäivä"; },
      sum: function(d) { return "Yhteensä"; },
      print: function(d) { return "Tulosta lasku"; },
      contact: {
        title: function(d) { return "Ehdota maksusuunnitelmaa"; },
        description: function(d) { return "Mikäli et pysty maksamaan koko velkaerää kerralla, voit neuvotella maksusuunnitelmasta soittamalla asiakaspalveluumme."; },
        description2: function(d) { return "Puhelin: 09 7742 5500, auki maanantaista perjantaihin klo 9–15"; },
        paysuggestion: function(d) { return "Maksusuunnitelmaehdotus"; },
        placeholder: function(d) { return "Ilmoita tarkat summat ja maksupäivät velan lyhennyksille ja maksusuunnitelman aikana erääntyville vuokrille."; },
        subject: function(d) { return "Viestin aihe"; },
        email: function(d) { return "Sähköpostiosoite"; },
        phonenumber: function(d) { return "Puhelinnumero"; },
        name: function(d) { return "Nimi"; },
        send: function(d) { return "Lähetä"; },
        copymessage: function(d) { return "Jos olet antanut sähköpostiosoitteesi, saat lähettämästäsi viestistä kopion sähköpostiisi. Yhteystietosi voit päivittää omat tiedot -osiossa."; }
      },
      error: function(d) { return "Velkaerittelyn lataaminen epäonnistui."; },
      goToPayment: function(d) { return "Siirry maksamaan"; },
      goToBilling: function(d) { return "Vuokra- ja maksutietoni"; }
    },
    work: {
      title: function(d) { return "Töitä asukkaille"; },
      more: function(d) { return "Lue lisää"; },
      work: function(d) { return "Haluatko töitä?"; }
    },
    m2: {
      about: {
        title: function(d) { return "Tietoa M2-Kodeista"; }
      },
      sustainability: {
        title: function(d) { return "M2-Kotien vastuullisuus"; }
      }
    },
    living: {
      home: {
        title: function(d) { return "Asuminen M2-Kodeilla"; }
      },
      benefits: {
        title: function(d) { return "Asukasedut"; }
      },
      events: {
        title: function(d) { return "Asukastapahtumat"; },
        upcoming: function(d) { return "Tulevat tapahtumat"; },
        noupcoming: function(d) { return "Ei tulevia tapahtumia"; }
      },
      activities: {
        title: function(d) { return "Asukastoiminta"; }
      },
      committee: {
        title: function(d) { return "Asukastoimikunta"; }
      }
    },
    myBuilding: {
      notices: {
        title: function(d) { return "Tiedotteet"; },
        noData: function(d) { return "Ei julkaistuja tiedotteita"; },
        committee: function(d) { return "Asukastoimikunta"; },
        readMore: function(d) { return "Lue lisää"; },
        actionPlan: {
          title: function(d) { return "Toimintasuunnitelma " + d.year; }
        },
        actionReport: {
          title: function(d) { return "Toimintakertomus " + d.year; }
        }
      },
      events: {
        title: function(d) { return "Talon tapahtumat"; },
        noData: function(d) { return "Ei julkaistuja tapahtumia"; }
      },
      documents: {
        title: function(d) { return "Ohjeet ja dokumentit"; },
        heading: function(d) { return "M2-Kodit"; },
        description: function(d) { return "Tältä sivulta löydät tärkeää tietoa ja ohjeita kotisi laitteisiin, ylläpitoon ja huoltoon liittyen."; },
        downloadPdf: function(d) { return "Lataa PDF"; },
        noDocuments: function(d) { return "Ei dokumentteja"; }
      }
    },
    forms: {
      title: function(d) { return "Lomakkeita asiontisi helpottamiseksi"; },
      pdf: {
        powerofattorney: function(d) { return "Valtakirja vuokralaisen edustamiseen (PDF)"; },
        keytransferagreement: function(d) { return "Avaintenluovutussopimus (PDF)"; },
        personaldataconsent: function(d) { return "Vuokralaisen suostumus henkilötietojen luovuttamiseen (PDF)"; },
        estateinstructions: function(d) { return "Ohjeita kuolinpesälle (PDF)"; }
      },
      committee: {
        title: function(d) { return "Asukastoimikunnan lomakkeet"; },
        description: function(d) { return "Asukastoimikunnan sähköiset lomakkeet löydät tästä."; }
      },
      save: function(d) { return "Tallenna"; },
      preview: function(d) { return "Esikatsele"; },
      publish: function(d) { return "Julkaise"; },
      send: function(d) { return "Lähetä"; },
      emptyForm: function(d) { return "Tyhjennä lomake"; },
      closePreview: function(d) { return "Sulje esikatselu"; },
      edit: function(d) { return "Muokkaa"; },
      error: {
        general: function(d) { return "Jokin meni pieleen, yritä hetken kuluttua uudelleen."; },
        save: function(d) { return "Tallentamisessa tapahtui virhe, yritä hetken kuluttua uudelleen."; },
        publish: function(d) { return "Julkaisussa tapahtui virhe, yritä hetken kuluttua uudelleen."; },
        submit: function(d) { return "Lähetyksessä tapahtui virhe, yritä hetken kuluttua uudelleen."; }
      },
      info: {
        published: function(d) { return "Lomake on lähetetty hyväksyttäväksi M2-Kodeille. Sisältöjä julkaistaan arkisin klo 9-15 välillä. Julkaisu tapahtuu noin 3 vuorokauden kuluessa."; },
        submitted: function(d) { return "Lomake on lähetetty hyväksyttäväksi M2-Kodeille."; },
        saved: function(d) { return "Lomake tallennettu."; }
      },
      approve: function(d) { return "Hyväksy"; },
      reject: function(d) { return "Hylkää"; },
      files: {
        error: {
          invalidImageOrPdf: function(d) { return "Vain PDF- ja kuvatiedostot ovat sallittuja. Tiedoston maksimikoko on " + d.maxSize + " Mt."; }
        }
      },
      review: {
        tokenExpired: function(d) { return "Linkki on vanhentunut."; },
        tokenNotFound: function(d) { return "404: Lomake on jo käsitelty tai linkki on virheellinen."; },
        error: function(d) { return "Jokin meni pieleen, yritä uudelleen."; },
        formApproved: function(d) { return "Lomake hyväksytty"; },
        formRejected: function(d) { return "Lomake hylätty"; },
        orderNewToken: function(d) { return "Tilaa uusi linkki"; },
        newTokenSent: function(d) { return "Uusi linkki on toimitettu sähköpostitse."; }
      },
      contact: {
        category: function(d) { return "Aihe"; },
        subcategory: function(d) { return "Tarkempi aihe"; },
        subject: function(d) { return "Otsikko"; },
        contentPlaceholder: function(d) { return "Kerro asiasi, tai kysy mitä vain asumisesta ja vuokranmaksusta."; },
        content: function(d) { return "Viesti"; }
      },
      meetingMinutes: {
        title: function(d) { return "Muistio tai pöytäkirja"; },
        description: {
          part1: function(d) { return "Täyttämällä vaaditut tiedot"; },
          part2: function(d) { return "voit julkaista muistioita ja pöytäkirjoja OmaM2-palvelussa. Sisällöt lähetetään moderaattorille hyväksyttäväksi ennen julkaisua. Sisältöjä julkaistaan arkisin klo 9-15 välillä. Julkaisu tapahtuu noin 3 vuorokauden kuluessa."; }
        },
        create: function(d) { return "Luo muistio"; },
        name: function(d) { return "Kokouksen nimi"; },
        date: function(d) { return "Kokouksen päivä"; },
        time: function(d) { return "Kellonaika"; },
        location: function(d) { return "Paikka"; },
        locationPlaceholder: function(d) { return "Kokouksen paikka"; },
        participants: function(d) { return "Osallistujia, kpl"; },
        content: {
          title: function(d) { return "Sisältö"; },
          description: function(d) { return "Jos teet pöytäkirjaa, lisää viralliset aiheet kuten järjestäytyminen ja pöytäkirjan tarkastajien valinnat. Otsikoiden ja kappaleiden määrää ei ole rajoitettu."; }
        },
        items: {
          title: function(d) { return "Otsikko"; },
          text: function(d) { return "Teksti"; },
          textPlaceholder: function(d) { return "Muistion tai pöytäkirjan sisältö"; }
        },
        addNewHeading: function(d) { return "Lisää otsikko"; },
        removeHeading: function(d) { return "Poista"; },
        signatures: {
          title: function(d) { return "Allekirjoitukset"; }
        },
        chairperson: function(d) { return "Puheenjohtaja"; },
        secretary: function(d) { return "Sihteeri"; },
        signaturePlaceholder: function(d) { return "Etunimi Sukunimi"; },
        signatoryConfirmation: {
          description: function(d) { return "Lähettämällä lomakkeen vakuutan olevani allekirjoittanut henkilö."; }
        }
      },
      actionPlan: {
        title: function(d) { return "Toimintasuunnitelma"; },
        description: {
          part1: function(d) { return "Täyttämällä vaaditut tiedot"; },
          part2: function(d) { return "voit julkaista toimintasuunnitelman OmaM2-palvelussa. Suunnitelma lähetetään moderaattorille hyväksyttäväksi. Sisältöjä julkaistaan arkisin klo 9-15 välillä. Julkaisu tapahtuu noin 3 vuorokauden kuluessa."; }
        },
        year: function(d) { return "Suunnitelma vuodelle"; },
        create: function(d) { return "Tee toimintasuunnitelma"; },
        budgetEstimate: function(d) { return "Kustannusarvio"; },
        plannedActivities: {
          title: function(d) { return "Suunniteltu toiminta ja tapahtumat"; },
          description: function(d) { return "Lisää kaikki vuodelle suunnitellut tapahtumat. Voit lisätä niin monta tapahtumaa kuin haluat."; }
        },
        activities: {
          name: function(d) { return "Toiminta tai tapahtuma"; },
          month: function(d) { return "Kuukausi"; },
          day: function(d) { return "Päivä"; },
          time: function(d) { return "Kellonaika"; },
          responsiblePersons: function(d) { return "Vastuuhenkilöt"; },
          responsiblePersonsPlaceholder: function(d) { return "Luettele vastuuhenkilöt"; },
          budgetEstimate: function(d) { return "Kustannusarvio, €"; }
        },
        addNewEvent: function(d) { return "Lisää uusi tapahtuma"; },
        removeEvent: function(d) { return "Poista"; },
        eventCount: function(d) { return d.count + " tapahtuma"; },
        eventCount_plural: function(d) { return d.count + " tapahtumaa"; },
        totalBudgetEstimate: function(d) { return "Kustannusarvio yht."; },
        totalBudgetEstimateWithAmount: function(d) { return "Kustannusarvio yht. " + d.amount + " €"; },
        previewTitle: function(d) { return "Toimintasuunnitelma " + d.year; }
      },
      actionReport: {
        title: function(d) { return "Toimintakertomus"; },
        description: {
          part1: function(d) { return "Täyttämällä vaaditut tiedot"; },
          part2: function(d) { return "voit julkaista toimintakertomuksen OmaM2-palvelussa. Suunnitelma lähetetään moderaattorille hyväksyttäväksi. Sisältöjä julkaistaan arkisin klo 9-15 välillä. Julkaisu tapahtuu noin 3 vuorokauden kuluessa."; }
        },
        year: function(d) { return "Toimintakertomus vuodelle"; },
        create: function(d) { return "Tee toimintakertomus"; },
        expenses: function(d) { return "Kustannukset"; },
        completedActivities: {
          title: function(d) { return "Toteutunut toiminta ja tapahtumat"; },
          description: function(d) { return "Lisää kaikki toteutuneet tapahtumat."; }
        },
        activities: {
          name: function(d) { return "Toiminta tai tapahtuma"; },
          month: function(d) { return "Kuukausi"; },
          day: function(d) { return "Päivä"; },
          time: function(d) { return "Kellonaika"; },
          additionalInformation: function(d) { return "Lisätiedot"; },
          additionalInformationPlaceholder: function(d) { return "Toiminnan tai tapahtuman kuvaus"; },
          expenses: function(d) { return "Kustannukset, €"; }
        },
        addNewEvent: function(d) { return "Lisää uusi tapahtuma"; },
        removeEvent: function(d) { return "Poista"; },
        eventCount: function(d) { return d.count + " tapahtuma"; },
        eventCount_plural: function(d) { return d.count + " tapahtumaa"; },
        totalExpenses: function(d) { return "Kustannukset yht."; },
        totalExpensesWithAmount: function(d) { return "Kustannukset yht. " + d.amount + " €"; },
        previewTitle: function(d) { return "Toimintakertomus " + d.year; }
      },
      generalExpenseReport: {
        title: function(d) { return "Kuluselvitys"; },
        description: function(d) { return "Kuluselvitys lähetetään hyväksyttäväksi M2-Kodeille."; },
        create: function(d) { return "Tee kuluselvitys"; },
        contactInfo: {
          title: function(d) { return "Asukkaan yhteystiedot"; },
          name: function(d) { return "Nimi"; },
          address: function(d) { return "Osoite"; },
          zip: function(d) { return "Postinumero"; },
          city: function(d) { return "Postitoimipaikka"; },
          phone: function(d) { return "Puhelinnumero"; },
          email: function(d) { return "Sähköpostiosoite"; },
          iban: function(d) { return "Pankkitili IBAN-muodossa"; }
        },
        event: {
          title: function(d) { return "Tilaisuus"; },
          name: function(d) { return "Tilaisuuden nimi"; },
          date: function(d) { return "Päivämäärä"; },
          additionalInformation: function(d) { return "Lisäselvitys"; }
        },
        purchaseReports: {
          title: function(d) { return "Selvitys hankinnoista"; },
          description: function(d) { return "Esim. talkootarjottavat, askartelutarvikkeet. Skannaa tai ota kuva alkuperäisestä kuitista, ja liitä se lomakkeeseen kohdasta “Liitä kuitti”. Korvauksen maksaminen edellyttää kuitin."; },
          report: function(d) { return "Selvitys"; },
          amount: function(d) { return "Euroa"; },
          addReceipt: function(d) { return "Lisää kuitti"; },
          addNewPurchase: function(d) { return "Lisää uusi hankinta"; },
          limitReached: function(d) { return "Voit lisätä korkeintaan kolme kulukorvausta samalle lomakkeelle"; },
          removePurchase: function(d) { return "Poista"; },
          total: function(d) { return "Yhteensä " + d.amount + " €"; }
        }
      },
      travelExpenseReport: {
        title: function(d) { return "Matkalasku"; },
        description: function(d) { return "Täytä henkilötiedot ja matkaselvitys kuluineen. Lomake lähetetään M2-Kodeille hyväksyttäväksi."; },
        create: function(d) { return "Tee matkalasku"; },
        contactInfo: {
          title: function(d) { return "Asukkaan yhteystiedot"; },
          name: function(d) { return "Nimi"; },
          address: function(d) { return "Osoite"; },
          zip: function(d) { return "Postinumero"; },
          city: function(d) { return "Postitoimipaikka"; },
          phone: function(d) { return "Puhelinnumero"; },
          email: function(d) { return "Sähköpostiosoite"; },
          iban: function(d) { return "Pankkitili IBAN-muodossa"; }
        },
        event: {
          title: function(d) { return "Matkan tarkoitus ja paikkakunta"; },
          name: function(d) { return "Tilaisuuden nimi"; },
          location: function(d) { return "Paikkakunta"; },
          travelRoute: function(d) { return "Matkareitti"; }
        },
        reports: {
          title: function(d) { return "Matkakulut"; },
          description: function(d) { return "Matkakulut korvataan julkisen liikenteen maksujen mukaisesti, ellei etukäteen ole sovittu muusta käytännöstä."; },
          publicTransportationTitle: function(d) { return "Kulut julkisilla"; },
          addPublicTransportationExpense: function(d) { return "Lisää kulu julkisella"; },
          ownTransportationTitle: function(d) { return "Kulut omalla autolla"; },
          addOwnTransportationExpense: function(d) { return "Lisää kulu oma autolla"; },
          limitReached: function(d) { return "Voit lisätä korkeintaan kolme kulukorvausta samalle lomakkeelle"; },
          remove: function(d) { return "Poista"; }
        },
        publicExpenseReports: {
          date: function(d) { return "Päivämäärä"; },
          time: function(d) { return "Kellonaika"; },
          amount: function(d) { return "Euroa"; },
          vehicle: function(d) { return "Ajoneuvo"; },
          receiptInfo: function(d) { return "Skannaa tai ota kuva alkuperäisestä kuitista, ja liitä se lomakkeeseen kohdasta “Liitä kuitti”."; },
          additionalInformation: function(d) { return "Lisäselvityksiä"; }
        },
        ownCarExpenseReports: {
          date: function(d) { return "Päivämäärä"; },
          time: function(d) { return "Kellonaika"; },
          numberOfPeople: function(d) { return "Henkilömäärä"; },
          totalKm: function(d) { return "Km, yhteensä"; },
          compensationInfo: function(d) { return "Kilometrikorvaus ja muut matkakulut korvataan Verohallinnon kunkin vuoden päätöksen mukaisesti. Tarkista summat"; },
          additionalInformation: function(d) { return "Auton kyydissä olleiden henkilöiden nimet / selvitys mahd. peräkärrystä"; },
          ownCar: function(d) { return "Oma auto"; }
        },
        info: function(d) { return "Ohje"; },
        addReceipt: function(d) { return "Liitä kuitti"; },
        ownCarInfoPopup: {
          subject: function(d) { return "Matkakulu omalla autolla"; },
          description: function(d) { return "Kulut korvataan vain, jos etukäteen on sovittu. Kilometrikorvaus on veronalaista tuloa ja sinun on ilmoitettava se verotuksessa."; }
        }
      },
      eventInvite: {
        title: function(d) { return "Tapahtumakutsu"; },
        description: {
          part1: function(d) { return "Täyttämällä vaaditut tiedot"; },
          part2: function(d) { return "voit julkaista tapahtumakutsuja OmaM2-palvelussa. Kutsut lähetetään moderaattorille hyväksyttäväksi. Sisältöjä julkaistaan arkisin klo 9-15 välillä, joten on suositeltavaa lähettää kutsu vähintään 2 viikkoa aikaisemmin."; }
        },
        create: function(d) { return "Luo tapahtumakutsu"; },
        eventType: function(d) { return "Tapahtumatyyppi"; },
        name: function(d) { return "Tapahtuman nimi"; },
        subject: function(d) { return "Tapahtuman aihe"; },
        date: function(d) { return "Päivämäärä"; },
        time: function(d) { return "Aika"; },
        location: function(d) { return "Paikka"; },
        locationPlaceholder: function(d) { return "Kokouksen paikka"; },
        eventDescription: function(d) { return "Kuvaus"; },
        eventDescriptionPlaceholder: function(d) { return "Kirjoita tapahtuman kuvaus, mitä tehdään, onko tarjoilua, lämpiääkö talosauna yms. Miten saadaan asukkaat liikkeelle."; },
        agenda: function(d) { return "Esityslista"; },
        agendaNote: function(d) { return "Huom. Ainoastaan esityslistalla olevista asioista voidaan tehdä virallisia päätöksiä pöytäkirjaan."; },
        regards: function(d) { return "Terveiset"; },
        regardsPlaceholder: function(d) { return "Terveisin,\n \n Asukastoimikunta"; },
        contactPerson: function(d) { return "Yhteyshenkilö lisätietoja varten"; },
        contactPersonPlaceholder: function(d) { return "Nimi tai sähköpostiosoite"; },
        property: function(d) { return "Kiinteistö"; },
        propertyPlaceholder: function(d) { return "Kiinteistön osoite"; },
        coverImage: function(d) { return "Kuvituskuva"; },
        coverImageOption: {
          propertyImage: function(d) { return "Kiinteistön kuva"; },
          noImage: function(d) { return "Ei kuvaa"; }
        },
        publication: {
          title: function(d) { return "Julkaisuasetukset"; },
          publicationRepeat: function(d) { return "Toista tapahtuma"; },
          repeatEndDate: function(d) { return "Toisto päättyy"; }
        },
        communityMeeting: function(d) { return "Asukaskokous"; },
        eventTypes: {
          communityWorkDay: function(d) { return "Talkoot"; },
          party: function(d) { return "Juhlat"; },
          communityMeeting: function(d) { return "Asukaskokous"; },
          otherEvent: function(d) { return "Muu asukastapahtuma"; }
        }
      },
      defectNotice: {
        formTitle: function(d) { return "Vikailmoitus"; },
        formDescription1: function(d) { return "Tee ilmoitus asuntoasi tai talosi yhteis- sekä yleistiloja koskevasta viasta. Vikailmoitus on tarkoitettu kiireettömiin korjaus- ja huoltotoimenpiteisiin. Kiireellisissä tapauksissa (esim. vesivahingot) soita talosi huoltoyhtiöön välittömästi."; },
        formDescription2: function(d) { return "Huoltotöitä tehdään arkisin klo 8-16 välisenä aikana."; },
        title: function(d) { return "Otsikko"; },
        defectClass: function(d) { return "Vian tyyppi"; },
        class: {
          hvac: function(d) { return "LVI"; },
          electrical: function(d) { return "Sähkö"; },
          locks: function(d) { return "Lukot"; },
          repair: function(d) { return "Korjaus"; },
          other: function(d) { return "Muu"; }
        },
        affectedArea: function(d) { return "Vian sijainti"; },
        apartment: function(d) { return "Asunto"; },
        courtyard: function(d) { return "Piha-alueet"; },
        publicSpaces: function(d) { return "Yleiset tilat"; },
        description: function(d) { return "Kuvaile vika"; },
        descriptionPlaceholder: function(d) { return "Kuvaile, missä vika tai ongelma sijaitsee ja miten se ilmenee"; },
        hasPetsInApartment: function(d) { return "Asunnossa on lemmikkejä"; },
        masterKeyAccessAllowed: function(d) { return "Huoneistoon saa tulla yleisavaimella huoltotöitä varten"; },
        petsDescription: function(d) { return "Lisätiedot lemmikeistä"; },
        addImage: function(d) { return "Lisää kuva"; },
        error: {
          tooManyFiles: function(d) { return "Tiedostojen sallittu enimmäismäärä on " + d.maxFiles + "."; }
        },
        submitted: function(d) { return "Vikailmoitus on toimitettu talosi huoltoyhtiölle. Kiireettömiä huoltotöitä tehdään arkisin klo 8-16 välisenä aikana."; }
      },
      terminateLease: {
        title: function(d) { return "Vuokrasopimuksen irtisanominen"; },
        apartment: function(d) { return "Huoneisto"; },
        description: function(d) { return "Täytä alla olevat tiedot. Tähtimerkityt kentät ovat pakollisia."; },
        addressDescription: function(d) { return "Olet irtisanomassa asuntoa "; },
        addressDescription2: function(d) { return "Huomioi nämä asiat täyttäessäsi irtisanomislomaketta:"; },
        addressDescription3: function(d) { return "Jos vuokrasopimuksella on muita osapuolia, heidän täytyy käydä vahvistamassa irtisanominen ennen kuin irtisanomisilmoitus voidaan ottaa käsittelyyn Y-Säätiön tai M2-Kotien puolella.  "; },
        addressDescription4: function(d) { return "Jos sopimuksella on useita sopimusosapuolia, joista joku on jäämässä asumaan asuntoon, ilmoita asiasta Lisätiedot-kentässä. "; },
        addressDescription5: function(d) { return "Sopimus päättyy oletuksena kalenterikuukauden viimeisenä päivänä. Jos muutat pois ennen sopimuksen päättymispäivää, ilmoita siitä Lisätietoja -kentässä."; },
        movingOutDate: function(d) { return "Poismuuttopäivä"; },
        terminationReason: function(d) { return "Ensisijainen irtisanomisen syy"; },
        endDate: function(d) { return "Sopimuksen päättymispäivä"; },
        givingContactInfoAllowed: function(d) { return "Yhteystietoni saa luovuttaa asunnosta kiinnostuneelle asuntoesittelyä varten. Yhteystiedot luovutetaan vain yhdelle hakijalle kerrallaan."; },
        masterKeyAccessAllowed: function(d) { return "Huoneistoon saa tulla yleisavaimella asuntonäyttöä ja muuttotarkastusta varten. Olemme yhteydessä ennen asunnossa käyntiä."; },
        display: function(d) { return "Asuntonäyttö"; },
        additionalDetails: function(d) { return "Lisätiedot"; },
        additionalDetailsLabel: function(d) { return "Jos vuokrasopimuksella on useita sopimusosapuolia, joista joku on jäämässä asumaan asuntoon, kirjoita asuntoon jäävän henkilön nimi ja syntymäaika. Jos toivot sopimuksen päättyvän muuna, kuin kuukauden viimeisenä päivänä, kirjoita toiveesi päättymispäivälle."; },
        hasPetsInApartment: function(d) { return "Asunnossa on lemmikkejä"; },
        newAddress: {
          title: function(d) { return "Uusi osoite"; },
          recipientName: function(d) { return "Vastaanottajan nimi"; },
          streetAddress: function(d) { return "Katuosoite"; },
          postalCode: function(d) { return "Postinumero"; },
          city: function(d) { return "Kaupunki"; }
        },
        apartment_size: function(d) { return "Asunnon koko"; },
        area_poor_services: function(d) { return "Alueen huonot palvelut tai liikenneyhteydet"; },
        buying_property: function(d) { return "Muutto omistusasuntoon"; },
        disturbing_neighbours_or_building: function(d) { return "Häiritsevät naapurit / häiriö talossa"; },
        family_size_change: function(d) { return "Perhekoon muutos"; },
        housing_costs: function(d) { return "Asunnon vuokra"; },
        move_due_work: function(d) { return "Muutto työn tai opiskelun vuoksi"; },
        move_to_another_apartment_of_same_owner: function(d) { return "Muutto toiseen Y-Säätiön tai M2-Kotien asuntoon"; },
        move_to_another_municipality: function(d) { return "Muutto toiselle paikkakunnalle"; },
        move_to_care_home_or_hospital: function(d) { return "Muutto palvelukotiin tai sairaalaan"; },
        move_to_right_of_occupancy: function(d) { return "Muutto asumisoikeusasuntoon"; },
        poor_apartment_condition: function(d) { return "Asunnon huono kunto"; },
        poor_apartment_equipment_or_properties: function(d) { return "Asunnon huonot varusteet tai ominaisuudet"; },
        poor_property_condition: function(d) { return "Kiinteistön huono kunto"; },
        poor_property_maintenance: function(d) { return "Kiinteistön huono ylläpito"; },
        poor_transportation_options: function(d) { return "Huonot kulkuyhteydet"; },
        beneficiary: function(d) { return "Tiedot vakuuden palautusta varten"; },
        depositInfo: function(d) { return "Vakuus palautetaan noin 1 kuukauden kuluttua siitä, kun sopimus on päättynyt."; },
        addNewBeneficiary: function(d) { return "Lisää maksunsaaja"; },
        removeBeneficiary: function(d) { return "Poista maksunsaaja"; },
        beneficiaries: {
          beneficiaryName: function(d) { return "Tilinomistaja"; },
          email: function(d) { return "Sähköpostiosoite"; },
          phoneNumber: function(d) { return "Puhelinnumero"; },
          iban: function(d) { return "Pankkitili IBAN-muodossa"; },
          bic: function(d) { return "BIC-koodi"; }
        },
        terminationCardTitle: function(d) { return "Irtisanomisen tiedot"; },
        send: function(d) { return "Lähetä"; },
        noticeInReview: function(d) { return "Irtisanomisilmoituksesi on vastaanotettu ja odottaa vuokranantajan käsittelyä. Saat pian lisätietoa sähköpostiisi."; },
        tenantApprovalRequired: function(d) { return "Sopimuksesi irtisanominen on aloitettu toisen sopimusosapuolen toimesta ja odottaa vahvistustasi. Tarkista huolellisesti, että annetut tiedot pitävät paikkansa."; },
        awaitingOtherTenantApproval: function(d) { return "Irtisanomisilmoituksesi on vastaanotettu ja odottaa muiden sopimusosapuolten hyväksyntää."; },
        noticeApproved: function(d) { return "Irtisanomisilmoituksesi on käsitelty ja vahvistettu. Saat pian ohjeet poismuuttoon ja avainten palautukseen liittyen."; },
        acceptNotice: function(d) { return "Vahvista irtisanomisilmoitus"; },
        rejectNotice: function(d) { return "Hylkää irtisanomisilmoitus"; }
      }
    },
    "resident-activity": {
      title: function(d) { return "Asukastoiminta"; }
    },
    maintenance: {
      financial: {
        generic: function(d) { return "Vuokra- ja maksutiedot eivät ole tällä hetkellä nähtävissä OmaM2-palvelussa eikä niitä ole saatavilla asiakaspalvelun kautta. Pyrimme saamaan tiedot näkyviin mahdollisimman pian."; },
        paymentPage: function(d) { return "Vuokran maksu ei ole tällä hetkellä mahdollista OmaM2-palvelun kautta. Pyydämme teitä maksamaan vuokran toistaiseksi oman verkkopankin kautta. Pahoittelemme tilannetta."; },
        rentCard: function(d) { return "Vuokranmaksutiedot eivät ole tällä hetkellä nähtävissä."; }
      }
    },
    termination: {
      title: function(d) { return "Vuokrasopimuksen irtisanominen"; },
      description: function(d) { return "Tässä palvelussa voit irtisanoa Y-Säätiön ja M2-Kotien vuokra-asunnon sähköisesti. Y-Säätiö ja M2-Kodit kuuluvat Y-Säätiö-konserniin."; },
      description2: function(d) { return "Irtisanominen edellyttää vahvaa tunnistautumista pankkitunnuksilla tai mobiilivarmenteella sopimuksen kaikilta osapuolilta."; },
      residents: {
        title: function(d) { return "Asukkaita asunnossa"; },
        withContract: function(d) { return "Sopimusosapuolet"; },
        other: function(d) { return "Muut asukkaat"; }
      },
      instructions: {
        title: function(d) { return "Näin irtisanot Y-Säätiön ja M2-Kotien vuokra-asunnon sähköisesti"; },
        step1: {
          title: function(d) { return "Palveluun kirjautuminen"; },
          description: function(d) { return "Kaikkien sopimusosapuolten tulee luoda tunnukset irtisanomispalveluun ennen irtisanomislomakkeen täyttämistä. M2-Kotien asukkaat voivat kirjautua OmaM2-palvelun tunnuksilla."; }
        },
        step2: {
          title: function(d) { return "Hyväksyntä kaikilta osapuolilta"; },
          description1: function(d) { return "Jos vuokrasopimus on useamman henkilön nimissä, yksi sopimusosapuoli täyttää irtisanomislomakkeen. Muiden osapuolten on odotettava, kunnes lomake on lähetetty."; },
          description2: function(d) { return "Lomakkeen täyttämisen jälkeen muut osapuolet voivat jatkaa eteenpäin hyväksymään irtisanomisen, jonka jälkeen irtisanomisilmoitus käsitellään Y-Säätiön tai M2-Kotien puolesta."; }
        },
        step3: {
          title: function(d) { return "Toisen sopimusosapuolen irtisanominen"; },
          description: function(d) { return "Jos vain toinen vuokralaisista irtisanoo sopimuksen ja toinen jää asumaan, kirjaa asuntoon jäävän henkilön nimi ja syntymäaika irtisanomislomakkeen lisätietoihin."; }
        },
        step4: {
          title: function(d) { return "Irtisanomisaika"; },
          description: function(d) { return "Irtisanomisaika on yksi kalenterikuukausi. Irtisanomisaika lasketaan sen kalenterikuukauden viimeisestä päivästä, jonka aikana irtisanomisilmoitus on tehty."; }
        },
        step5: {
          title: function(d) { return "Huoneiston tyhjennys ja siivous"; },
          description: function(d) { return "Vuokralainen antaa irtisanomisen yhteydessä luvan siihen, että huoneisto voidaan tyhjentää ja tavarat hävittää sopimuksen päätyttyä, mikäli asuntoa ei ole tyhjennetty ja siivottu vuokralaisen toimesta sopimuksen päättymispäivään mennessä."; }
        }
      },
      "continue": function(d) { return "Jatka eteenpäin"; },
      instructionsRead: function(d) { return "Olen lukenut ja ymmärtänyt irtisanomisen ohjeet"; },
      kenno_termination_disallowed_reason: {
        contract_terminated: function(d) { return "Irtisanomisilmoitus on jo lähetetty."; },
        pending_termination_tenant_approvals: function(d) { return "Toinen osapuoli on tehnyt irtisanomisilmoituksen. Jatka eteenpäin vahvistaaksesi irtisanomisen."; },
        pending_termination_review: function(d) { return "Irtisanomisilmoitusta käsitellään."; },
        is_estate_contract: function(d) { return "Irtisanomisilmoitusta ei voida tehdä asunnon tyypin takia."; },
        has_guardian_of_interests: function(d) { return "Irtisanomisilmoitusta ei voida tehdä, sillä sopimuksella on edunvalvoja."; },
        missing_resident_users: function(d) { return "Irtisanomisilmoitusta ei voida tehdä, sillä toinen sopimusosapuoli ei ole luonut tunnuksia palveluun."; },
        not_contract_party: function(d) { return "Irtisanomisilmoitusta ei voida tehdä, sillä irtisanoja ei ole sopimusosapuoli."; },
        tenants_with_undetermined_age: function(d) { return "Irtisanomisilmoitusta ei voida tehdä, sillä irtisanoja ei ole täysi-ikäinen."; },
        has_company_tenant: function(d) { return "Irtisanomisilmoitusta ei voida tehdä, sillä sopimuksella on yritysomistaja."; },
        pending_modification_request: function(d) { return "Irtisanomisilmoitusta ei voida tehdä, sillä sopimuksen muutosta käsitellään."; },
        general: function(d) { return "Sopimuksen purkamisilmoitus epäonnistui"; },
        help: function(d) { return "Yritä myöhemmin uudelleen tai ole yhteydessä asiakaspalveluun"; }
      }
    },
    admin: {
      impersonation: {
        title: function(d) { return "Kirjaudu"; },
        form: {
          email: function(d) { return "Henkilökunnan sähköposti "; },
          ssn: function(d) { return "Asukkaan henkilötunnus"; },
          targetTenantId: function(d) { return "Asukkaan tunnus"; }
        },
        signIn: function(d) { return "Kirjaudu"; },
        systemNotification: function(d) { return "Olet kirjautunut ylläpitäjänä asukkaan sivulle. Huomaathan, että et voi tehdä toimenpiteitä asukkaan puolesta."; }
      }
    },
    input: {
      showPassword: function(d) { return "Näytä salasana"; },
      hidePassword: function(d) { return "Piilota salasana"; },
      addAttachment: function(d) { return "Lisää liite"; },
      dropdown: {
        monthOption: function(d) { return d.amount + " kk"; },
        choose: function(d) { return "Valitse"; },
        repeatOptions: {
          never: function(d) { return "Ei koskaan"; },
          weekly: function(d) { return "Kerran viikossa"; },
          biweekly: function(d) { return "Joka toinen viikko"; },
          monthly: function(d) { return "Kuukausittain"; },
          yearly: function(d) { return "Vuosittain"; }
        }
      }
    },
    pagination: {
      previousPage: function(d) { return "Edellinen sivu"; },
      nextPage: function(d) { return "Seuraava sivu"; },
      pageNumber: function(d) { return "Sivu " + d.page; }
    },
    time: {
      clock: function(d) { return "klo"; }
    },
    months: {
      january: function(d) { return "Tammikuu"; },
      february: function(d) { return "Helmikuu"; },
      march: function(d) { return "Maaliskuu"; },
      april: function(d) { return "Huhtikuu"; },
      may: function(d) { return "Toukokuu"; },
      june: function(d) { return "Kesäkuu"; },
      july: function(d) { return "Heinäkuu"; },
      august: function(d) { return "Elokuu"; },
      september: function(d) { return "Syyskuu"; },
      october: function(d) { return "Lokakuu"; },
      november: function(d) { return "Marraskuu"; },
      december: function(d) { return "Joulukuu"; }
    }
  }
}